/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(13);
	
	__webpack_require__(20);
	
	__webpack_require__(12);
	
	__webpack_require__(35);
	
	__webpack_require__(40);
	
	__webpack_require__(1);
	
	__webpack_require__(34);
	
	__webpack_require__(8);
	
	__webpack_require__(5);
	
	__webpack_require__(14);
	
	__webpack_require__(3);
	
	__webpack_require__(4);
	
	__webpack_require__(23);
	
	__webpack_require__(43);
	
	__webpack_require__(7);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var USE_STRICT_MODE, el, height_cache, log_writer, logs_to_write, safe_string, size_cache, videos_viewport_status, width_cache,
	  hasProp = {}.hasOwnProperty;
	
	window.styles = "";
	
	window.screencasting = function() {
	  var ref;
	  if (window.__screencasting == null) {
	    window.__screencasting = ((ref = fetch('location').query_params) != null ? ref.screencasting : void 0) === 'true';
	  }
	  return window.__screencasting;
	};
	
	window.embedded_demo = function() {
	  var ref;
	  if (window.__embedded_demo == null) {
	    window.__embedded_demo = ((ref = fetch('location').query_params) != null ? ref.embedded_demo : void 0) === 'true' || location.search.indexOf('embedded_demo') > -1;
	  }
	  return window.__embedded_demo;
	};
	
	__webpack_require__(22);
	
	__webpack_require__(15);
	
	window.ajax_submit_files_in_form = function(opts) {
	  var cb, form, frm, k, ref, v, xhr;
	  if (opts == null) {
	    opts = {};
	  }
	  cb = function(evt) {
	    var status;
	    if (xhr.readyState === XMLHttpRequest.DONE) {
	      status = xhr.status;
	      if (status === 0 || (status >= 200 && status < 400)) {
	        return typeof opts.success === "function" ? opts.success(xhr.responseText) : void 0;
	      } else {
	        return typeof opts.error === "function" ? opts.error({
	          response: xhr.responseText,
	          status: status
	        }) : void 0;
	      }
	    }
	  };
	  form = document.querySelector(opts.form);
	  frm = new FormData(form);
	  ref = opts.additional_data || {};
	  for (k in ref) {
	    v = ref[k];
	    frm.append(k, v);
	  }
	  xhr = new XMLHttpRequest;
	  xhr.addEventListener('readystatechange', cb, false);
	  xhr.open(opts.type || 'POST', opts.uri || form.getAttribute('action'), true);
	  return xhr.send(frm);
	};
	
	window.pad = function(num, len) {
	  var dec, i, str;
	  str = num;
	  dec = str.split('.');
	  i = 0;
	  while (i < len - dec[0].toString().length) {
	    dec[0] = "0" + dec[0];
	    i += 1;
	  }
	  return dec[0] + (dec.length > 0 ? '.' + dec[1] : '');
	};
	
	window.back_to_homepage_button = function(style, text) {
	  var hash, loc;
	  loc = fetch('location');
	  hash = loc.url.split('/')[1].replace('-', '_');
	  return NAV({
	    role: 'navigation'
	  }, A({
	    className: 'back_to_homepage',
	    title: 'back to homepage',
	    key: 'back_to_homepage_button',
	    "data-no-scroll": true,
	    href: "/#" + hash,
	    style: _.defaults({}, style, {
	      fontSize: 43,
	      visibility: is_a_dialogue_page() || !customization('has_homepage') ? 'hidden' : 'visible',
	      color: 'black',
	      display: 'flex',
	      alignItems: 'center'
	    })
	  }, ChevronLeft(20), text ? SPAN({
	    style: {
	      paddingLeft: 20
	    }
	  }, text) : void 0));
	};
	
	window.get_region_name = function() {
	  var reg, region;
	  region = fetch('/application').region;
	  if (!region) {
	    return "";
	  }
	  if (region === 'US') {
	    reg = "the United States";
	  } else if (region === 'CA') {
	    reg = "Canada";
	  } else if (region === 'EU') {
	    reg = "the European Union";
	  } else if (region === 'AU') {
	    reg = "Australia";
	  } else {
	    throw "Unknown region " + region;
	  }
	  return translator("server.region_string." + reg, reg);
	};
	
	for (el in ReactDOMFactories) {
	  window[el.toUpperCase()] = React.createFactory(el);
	}
	
	USE_STRICT_MODE = false;
	
	if (USE_STRICT_MODE) {
	  window['STRICTMODE'] = React.createFactory(React.StrictMode);
	}
	
	if (typeof ReactFlipToolkit !== "undefined" && ReactFlipToolkit !== null) {
	  window.FLIPPER = React.createFactory(ReactFlipToolkit.Flipper);
	  window.FLIPPED = React.createFactory(ReactFlipToolkit.Flipped);
	  window.EXITCONTAINER = React.createFactory(ReactFlipToolkit.ExitContainer);
	}
	
	window.LIVE_UPDATE_INTERVAL = 3 * 60 * 1000;
	
	window.live_update = function() {
	  var key, results;
	  results = [];
	  for (key in arest.components_4_key.hash) {
	    if (key[0] === '/' && arest.components_4_key.get(key).length > 0 && !key.match(/\/(current_user|proposal|user|opinion|point|visits|subdomain|application|translations)/)) {
	      results.push(arest.serverFetch(key));
	    } else {
	      results.push(void 0);
	    }
	  }
	  return results;
	};
	
	setInterval(live_update, LIVE_UPDATE_INTERVAL);
	
	(function() {
	  var event, idle_time_before_subdomain_fetch, j, last_activity, len1, ref, reload_subdomain, resetTimer, results, timer;
	  idle_time_before_subdomain_fetch = 30 * 60 * 1000;
	  last_activity = Date.now();
	  reload_subdomain = function() {
	    if (Date.now() - last_activity >= idle_time_before_subdomain_fetch) {
	      return arest.serverFetch('/subdomain');
	    }
	  };
	  timer = setInterval(reload_subdomain, 60 * 1000);
	  resetTimer = function() {
	    return last_activity = Date.now();
	  };
	  window.addEventListener('load', resetTimer, true);
	  ref = ['mousedown', 'mousemove', 'keydown', 'touchstart'];
	  results = [];
	  for (j = 0, len1 = ref.length; j < len1; j++) {
	    event = ref[j];
	    results.push(document.addEventListener(event, resetTimer, true));
	  }
	  return results;
	})();
	
	window.POINT_MOUTH_WIDTH = 17;
	
	window.getCoords = function(el) {
	  var docEl, offset, rect;
	  rect = el.getBoundingClientRect();
	  docEl = document.documentElement;
	  offset = {
	    top: rect.top + window.pageYOffset,
	    left: rect.left + window.pageXOffset
	  };
	  return _.extend(offset, {
	    width: rect.width,
	    height: rect.height,
	    cx: offset.left + rect.width / 2,
	    cy: offset.top + rect.height / 2,
	    right: offset.left + rect.width,
	    bottom: offset.top + rect.height
	  });
	};
	
	window.asset = function(name) {
	  var a, app;
	  app = fetch('/application');
	  if (app.asset_host != null) {
	    a = (app.asset_host || '') + "/images/" + name;
	  } else {
	    a = (window.asset_host || '') + "/images/" + name;
	  }
	  return a;
	};
	
	window.lazyLoadJavascript = function(src, args) {
	  var already_loaded, id, script;
	  id = slugify(src);
	  already_loaded = document.body.querySelector("script#" + id);
	  if (!already_loaded) {
	    script = document.createElement('script');
	    script.type = 'text/javascript';
	    script.id = id;
	    script.src = src;
	    if (args.onload) {
	      script.onload = args.onload;
	    }
	    if (args.onerror) {
	      script.onerror = args.onerror;
	    }
	    document.body.appendChild(script);
	  }
	  return !!already_loaded;
	};
	
	window.LoadScripts = {
	  loadScripts: function() {
	    var done_loading, fn, j, len1, ref, req;
	    if (!this.local.loading && !this.local.loaded) {
	      if (this.scripts_loaded == null) {
	        this.scripts_loaded = {};
	      }
	      done_loading = (function(_this) {
	        return function() {
	          var k, loaded, ref, v;
	          loaded = 0;
	          ref = _this.scripts_loaded;
	          for (k in ref) {
	            v = ref[k];
	            if (v) {
	              loaded += 1;
	            }
	          }
	          return loaded >= (_this.js_dependencies || []).length;
	        };
	      })(this);
	      ref = this.js_dependencies || [];
	      fn = (function(_this) {
	        return function(req) {
	          if (!_this.scripts_loaded[req]) {
	            return _this.scripts_loaded[req] = lazyLoadJavascript((fetch('/application').asset_host) + "/vendor/" + req, {
	              onload: function() {
	                _this.scripts_loaded[req] = true;
	                _this.local.loaded = done_loading();
	                _this.local.loading = !_this.local.loaded;
	                return save(_this.local);
	              },
	              onerror: function() {
	                _this.scripts_loaded[req] = false;
	                _this.local.error = true;
	                _this.local.loaded = false;
	                _this.local.loading = false;
	                return save(_this.local);
	              }
	            });
	          }
	        };
	      })(this);
	      for (j = 0, len1 = ref.length; j < len1; j++) {
	        req = ref[j];
	        fn(req);
	      }
	      return this.local.loading = !done_loading();
	    }
	  }
	};
	
	window.opinionsForProposal = function(proposal) {
	  var opinions;
	  opinions = fetch(proposal).opinions || [];
	  return opinions;
	};
	
	window.namespaced_key = function(base_key, base_object) {
	  var namespace_key;
	  namespace_key = fetch(base_object).key;
	  if (namespace_key[0] === '/') {
	    namespace_key = namespace_key.substring(1, namespace_key.length);
	  }
	  return namespace_key + "_" + base_key;
	};
	
	window.on_ajax_error = function() {
	  var root;
	  root = fetch('root');
	  root.server_error = true;
	  return save(root);
	};
	
	window.on_client_error = function(e) {
	  if (navigator.userAgent.indexOf('PhantomJS') >= 0) {
	    return;
	  }
	  return save({
	    key: '/new/client_error',
	    stack: e.stack,
	    message: e.message || e.description,
	    name: e.name,
	    line_number: e.lineNumber,
	    column_number: e.columnNumber
	  });
	};
	
	logs_to_write = [];
	
	log_writer = null;
	
	window.writeToLog = function(entry) {
	  return;
	  entry.where = fetch('location').url;
	  logs_to_write.push(entry);
	  if (!log_writer) {
	    return setTimeout(function() {
	      return log_writer = setInterval(function() {
	        var j, len1, log;
	        for (j = 0, len1 = logs_to_write.length; j < len1; j++) {
	          log = logs_to_write[j];
	          log.key = '/new/log';
	          save(log);
	        }
	        return logs_to_write = [];
	      }, 100);
	    }, 2000);
	  }
	};
	
	window.prettyDate = function(time) {
	  var date, day_diff, diff, r, subdomain;
	  subdomain = fetch('/subdomain');
	  date = new Date(time);
	  diff = ((new Date()).getTime() - date.getTime()) / 1000;
	  day_diff = Math.floor(diff / 86400);
	  if (isNaN(day_diff) || day_diff < 0) {
	    return;
	  }
	  if (subdomain.lang !== 'en') {
	    return (date.getMonth() + 1) + "/" + (date.getDate()) + "/" + (date.getFullYear());
	  }
	  r = day_diff === 0 && (diff < 60 && "just now" || diff < 120 && "1 minute ago" || diff < 3600 && Math.floor(diff / 60) + " minutes ago" || diff < 7200 && "1 hour ago" || diff < 86400 && Math.floor(diff / 3600) + " hours ago") || day_diff === 1 && "Yesterday" || day_diff < 7 && day_diff + " days ago" || day_diff < 31 && Math.ceil(day_diff / 7) + " weeks ago" || ((date.getMonth() + 1) + "/" + (date.getDate() + 1) + "/" + (date.getFullYear()));
	  r = r.replace('1 days ago', '1 day ago').replace('1 weeks ago', '1 week ago').replace('1 years ago', '1 year ago');
	  return r;
	};
	
	window.inRange = function(val, min, max) {
	  return val <= max && val >= min;
	};
	
	window.capitalize = function(string) {
	  return string.charAt(0).toUpperCase() + string.substring(1);
	};
	
	window.capitalize_each_word = function(str) {
	  return str.replace(/\b\w/g, function(l) {
	    return l.toUpperCase();
	  });
	};
	
	window.loading_indicator = DIV({
	  className: 'loading sk-wave',
	  dangerouslySetInnerHTML: {
	    __html: "<div class=\"sk-rect sk-rect1\"></div>\n<div class=\"sk-rect sk-rect2\"></div>\n<div class=\"sk-rect sk-rect3\"></div>\n<div class=\"sk-rect sk-rect4\"></div>\n<div class=\"sk-rect sk-rect5\"></div>"
	  }
	});
	
	window.LOADING_INDICATOR = window.loading_indicator;
	
	styles += ".sk-wave {\n  margin: 40px auto;\n  width: 50px;\n  height: 40px;\n  text-align: center;\n  font-size: 10px; }\n  .sk-wave .sk-rect {\n    background-color: rgba(223, 98, 100, .5);\n    height: 100%;\n    width: 6px;\n    display: inline-block;\n    -webkit-animation: sk-waveStretchDelay 1.2s infinite ease-in-out;\n            animation: sk-waveStretchDelay 1.2s infinite ease-in-out; }\n  .sk-wave .sk-rect1 {\n    -webkit-animation-delay: -1.2s;\n            animation-delay: -1.2s; }\n  .sk-wave .sk-rect2 {\n    -webkit-animation-delay: -1.1s;\n            animation-delay: -1.1s; }\n  .sk-wave .sk-rect3 {\n    -webkit-animation-delay: -1s;\n            animation-delay: -1s; }\n  .sk-wave .sk-rect4 {\n    -webkit-animation-delay: -0.9s;\n            animation-delay: -0.9s; }\n  .sk-wave .sk-rect5 {\n    -webkit-animation-delay: -0.8s;\n            animation-delay: -0.8s; }\n\n@-webkit-keyframes sk-waveStretchDelay {\n  0%, 40%, 100% {\n    -webkit-transform: scaleY(0.4);\n            transform: scaleY(0.4); }\n  20% {\n    -webkit-transform: scaleY(1);\n            transform: scaleY(1); } }\n\n@keyframes sk-waveStretchDelay {\n  0%, 40%, 100% {\n    -webkit-transform: scaleY(0.4);\n            transform: scaleY(0.4); }\n  20% {\n    -webkit-transform: scaleY(1);\n            transform: scaleY(1); } }";
	
	window.shared_local_key = function(key_or_object) {
	  var key;
	  key = key_or_object.key || key_or_object;
	  if (key[0] === '/') {
	    key = key.substring(1, key.length);
	    return key + "/shared";
	  } else {
	    return key;
	  }
	};
	
	window.reset_key = function(obj_or_key, updates) {
	  var k, resetting_totally, v;
	  resetting_totally = !updates;
	  updates = updates || {};
	  if (!obj_or_key.key) {
	    obj_or_key = fetch(obj_or_key);
	  }
	  updates.key = obj_or_key.key;
	  if (obj_or_key.key === 'auth' && (obj_or_key.after != null)) {
	    if (!resetting_totally) {
	      if (updates.after == null) {
	        updates.after = obj_or_key.after;
	      }
	    } else {
	      if (typeof obj_or_key.after === "function") {
	        obj_or_key.after();
	      }
	    }
	  }
	  if (_.isEqual(obj_or_key, updates)) {
	    return;
	  }
	  for (k in obj_or_key) {
	    if (!hasProp.call(obj_or_key, k)) continue;
	    v = obj_or_key[k];
	    if (k !== 'key') {
	      delete obj_or_key[k];
	    }
	  }
	  _.extend(obj_or_key, updates);
	  return save(obj_or_key);
	};
	
	safe_string = function(user_content) {
	  var hyperlink_pattern;
	  user_content = user_content.replace(/(<li>|<br\s?\/?>|<p>)/g, '\n');
	  user_content = user_content.replace(/(<([^>]+)>)/ig, "");
	  hyperlink_pattern = /(^|[\s\n])((?:https?):\/\/[\-A-Z0-9+\u0026\u2019@#\/%?=()\[\]\-\$&\*~_|!:,.;']*[\-A-Z0-9+\u0026@#\/%=~()_|])/gi;
	  user_content = user_content.replace(hyperlink_pattern, "$1(*-&)link:$2(*-&)");
	  return user_content;
	};
	
	window.splitParagraphs = function(user_content, append) {
	  var WRAPPER, idx, j, len1, para, paragraphs, pidx, results, text;
	  if (!user_content) {
	    return SPAN(null);
	  }
	  user_content = safe_string(user_content);
	  paragraphs = user_content.split(/(?:\r?\n)/g);
	  if (paragraphs.length < 2) {
	    WRAPPER = SPAN;
	  } else {
	    WRAPPER = P;
	  }
	  results = [];
	  for (pidx = j = 0, len1 = paragraphs.length; j < len1; pidx = ++j) {
	    para = paragraphs[pidx];
	    results.push(WRAPPER({
	      key: "para-" + pidx
	    }, (function() {
	      var len2, m, ref, results1;
	      ref = para.split('(*-&)');
	      results1 = [];
	      for (idx = m = 0, len2 = ref.length; m < len2; idx = ++m) {
	        text = ref[idx];
	        if (text.substring(0, 5) === 'link:') {
	          results1.push(A({
	            key: idx,
	            href: text.substring(5, text.length),
	            target: '_blank'
	          }, text.substring(5, text.length)));
	        } else {
	          results1.push(SPAN({
	            key: idx
	          }, text));
	        }
	      }
	      return results1;
	    })(), append && pidx === paragraphs.length - 1 ? append : void 0));
	  }
	  return results;
	};
	
	width_cache = {};
	
	window.widthWhenRendered = function(str, style) {
	  var key, parent, width;
	  key = JSON.stringify(_.extend({
	    str: str
	  }, style));
	  if (!(key in width_cache)) {
	    if (style.display == null) {
	      style.display = 'inline-block';
	    }
	    el = document.createElement('span');
	    el.id = "width_test";
	    el.style.setProperty('position', 'absolute');
	    el.style.setProperty('visibility', 'hidden');
	    el.innerHTML = "<span>" + str + "</span>";
	    parent = document.getElementById('content');
	    parent.appendChild(el);
	    $$.setStyles("#width_test", style);
	    width = $$.width(el);
	    parent.removeChild(el);
	    width_cache[key] = width;
	  }
	  return width_cache[key];
	};
	
	height_cache = {};
	
	window.heightWhenRendered = function(str, style, el, skip_caching) {
	  var height, k, key, parent, v;
	  key = JSON.stringify(_.extend({
	    str: str
	  }, style));
	  if ((!(key in height_cache)) || skip_caching) {
	    if (el == null) {
	      el = document.createElement('div');
	    }
	    el.style.position = 'absolute';
	    el.style.visibility = 'hidden';
	    el.innerHTML = "<div>" + str + "</div>";
	    for (k in style) {
	      v = style[k];
	      if (k.indexOf('-') > -1) {
	        el.style.setProperty(k, v);
	      } else {
	        el.style[k] = v;
	      }
	    }
	    parent = document.getElementById('content');
	    parent.appendChild(el);
	    height = $$.height(el);
	    parent.removeChild(el);
	    height_cache[key] = height;
	  }
	  return height_cache[key];
	};
	
	size_cache = {};
	
	window.sizeWhenRendered = function(str, style) {
	  var h, k, key, main, test, v, w;
	  main = document.getElementById('content');
	  if (!main) {
	    return {
	      width: 0,
	      height: 0
	    };
	  }
	  style || (style = {});
	  style.str = str;
	  key = JSON.stringify(style);
	  delete style.str;
	  if (!(key in size_cache)) {
	    style.display || (style.display = 'inline-block');
	    test = document.createElement("div");
	    test.style.position = 'absolute';
	    test.style.visibility = 'hidden';
	    test.innerHTML = "<div>" + str + "</div>";
	    for (k in style) {
	      v = style[k];
	      key = k.replace(/([A-Z])/g, '-$1').toLowerCase();
	      if (key === 'font-size' || key === 'max-width' || key === 'max-height') {
	        test.style[key] = v + "px";
	      } else {
	        test.style[key] = v;
	      }
	    }
	    main.appendChild(test);
	    h = test.offsetHeight;
	    w = test.offsetWidth;
	    main.removeChild(test);
	    size_cache[key] = {
	      width: w,
	      height: h
	    };
	  }
	  return size_cache[key];
	};
	
	window.translateStanceToPixelX = function(stance, width) {
	  return (stance + 1) / 2 * width;
	};
	
	window.translatePixelXToStance = function(pixel_x, width) {
	  return 2 * (pixel_x / width) - 1;
	};
	
	window.closest = function(node, check) {
	  if (!node || node === document) {
	    return false;
	  } else {
	    return check(node) || closest(node.parentNode, check);
	  }
	};
	
	window.location_origin = function() {
	  if (!window.location.origin) {
	    return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
	  } else {
	    return window.location.origin;
	  }
	};
	
	window.focus_color = function() {
	  return focus_blue;
	};
	
	window.css = {};
	
	css.crossbrowserify = function(styles) {
	  return styles;
	};
	
	css.grab_cursor = function(selector) {
	  return selector + " {\n  cursor: move;\n  cursor: ew-resize;\n  cursor: -webkit-grab;\n  cursor: -moz-grab;\n} " + selector + ":active {\n  cursor: move;\n  cursor: ew-resize;\n  cursor: -webkit-grabbing;\n  cursor: -moz-grabbing;\n}";
	};
	
	window.cssTriangle = function(direction, color, width, height, style) {
	  var border_color, border_width;
	  style = style || {};
	  switch (direction) {
	    case 'top':
	      border_width = "0 " + (width / 2) + "px " + height + "px " + (width / 2) + "px";
	      border_color = "transparent transparent " + color + " transparent";
	      break;
	    case 'bottom':
	      border_width = height + "px " + (width / 2) + "px 0 " + (width / 2) + "px";
	      border_color = color + " transparent transparent transparent";
	      break;
	    case 'left':
	      border_width = (height / 2) + "px " + width + "px " + (height / 2) + "px 0";
	      border_color = "transparent " + color + " transparent transparent";
	      break;
	    case 'right':
	      border_width = (height / 2) + "px 0 " + (height / 2) + "px " + width + "px";
	      border_color = "transparent transparent transparent " + color;
	  }
	  _.defaults(style, {
	    width: 0,
	    height: 0,
	    borderStyle: 'solid',
	    borderWidth: border_width,
	    borderColor: border_color
	  });
	  return style;
	};
	
	window.header_font = function() {
	  return customization('header_font') || customization('font');
	};
	
	window.mono_font = function() {
	  return customization('mono_font') || customization('font');
	};
	
	window.responsive_css_rule = function(arg) {
	  var XX, YY, ZZ, max_size, max_vw, min_size, min_vw;
	  min_size = arg.min_size, max_size = arg.max_size, min_vw = arg.min_vw, max_vw = arg.max_vw;
	  XX = min_vw / 100;
	  YY = 100 * (max_size - min_size) / (max_vw - min_vw);
	  ZZ = min_size;
	  return "clamp(" + min_size + "px, calc(" + ZZ + "px + ((1vw - " + XX + "px) * " + YY + ")), " + max_size + "px)";
	};
	
	window.slugify = function(text) {
	  var slug;
	  slug = text.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^a-zA-Z0-9_\u3400-\u9FBF\s-]/g, '').replace(/\-\-+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
	  if ((text != null ? text.length : void 0) > 0 && (slug != null ? slug.length : void 0) === 0) {
	    slug = md5(text);
	  }
	  return slug;
	};
	
	videos_viewport_status = {};
	
	window.play_videos_when_in_viewport = function(parent_el, args) {
	  var j, len1, observe_video, play_only_topmost_video, play_or_pause_after_event, results, video, video_id, videos;
	  play_only_topmost_video = (args || {}).play_only_topmost_video;
	  videos = parent_el.querySelectorAll('video[autoplay]:not([data-initialized])');
	  video_id = function(video) {
	    return video.getElementsByTagName("source")[0].src;
	  };
	  play_or_pause_after_event = function() {
	    var j, len1, play_rest, results, should_play, video;
	    play_rest = true;
	    results = [];
	    for (j = 0, len1 = videos.length; j < len1; j++) {
	      video = videos[j];
	      if (video.readyState < 1) {
	        continue;
	      }
	      should_play = !document.hidden && videos_viewport_status[video_id(video)];
	      if (should_play && play_rest) {
	        video.play();
	        if (play_only_topmost_video) {
	          results.push(play_rest = false);
	        } else {
	          results.push(void 0);
	        }
	      } else {
	        results.push(video.pause());
	      }
	    }
	    return results;
	  };
	  document.addEventListener('visibilitychange', play_or_pause_after_event);
	  observe_video = function(video) {
	    var id;
	    id = video_id(video);
	    video.setAttribute('data-initialized', "");
	    video.setAttribute('playsinline', "");
	    video.addEventListener("loadstart", function(e) {
	      video.classList.add('loading');
	      if (video.hasAttribute('controls')) {
	        video.setAttribute('data-controls', "");
	      }
	      if (!video.hasAttribute('poster')) {
	        return video.setAttribute('controls', "");
	      }
	    });
	    return video.addEventListener('loadeddata', function(e) {
	      var eligible_to_play, observer, observer_options;
	      if (video.readyState >= 1) {
	        video.classList.remove('loading');
	        if (!video.hasAttribute('data-controls')) {
	          video.removeAttribute('controls');
	        }
	        eligible_to_play = null;
	        observer_options = {
	          root: null,
	          threshold: [1.0]
	        };
	        observer = new IntersectionObserver(function(entries) {
	          return entries.forEach(function(entry) {
	            if (!entry.isIntersecting) {
	              videos_viewport_status[id] = false;
	            } else {
	              videos_viewport_status[id] = true;
	            }
	            return play_or_pause_after_event();
	          });
	        }, observer_options);
	        return observer.observe(video);
	      }
	    });
	  };
	  results = [];
	  for (j = 0, len1 = videos.length; j < len1; j++) {
	    video = videos[j];
	    results.push(observe_video(video));
	  }
	  return results;
	};
	
	window.styles += "\n/* \nhttps://stackoverflow.com/questions/2710764/preserve-html-font-size-when-iphone-orientation-changes-from-portrait-to-landsca \n*/\nhtml {\n  -ms-text-size-adjust: 100%;\n  -webkit-text-size-adjust: 100%;  \n}\n\n\n/* RESET\n * Eric Meyer's Reset CSS v2.0 (http://meyerweb.com/eric/tools/css/reset/)\n * http://cssreset.com\n */\nhtml, body, div, span, applet, object, iframe,\nh1, h2, h3, h4, h5, h6, p, blockquote, pre,\na, abbr, acronym, address, big, cite, code,\ndel, dfn, em, img, ins, kbd, q, s, samp,\nsmall, strike, strong, sub, tt, var,\nb, u, i, center,\ndl, dt, dd, ol, ul, li,\nfieldset, form, label, legend,\ntable, caption, tbody, tfoot, thead, tr, th, td,\narticle, aside, canvas, details, embed,\nfigure, figcaption, footer, header, hgroup,\nmenu, nav, output, ruby, section, summary,\ntime, mark, audio, video {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n  line-height: 1.4; }\n\n\n#content .fa {\n  font-family: FontAwesome;  \n}\n\n#content, body, html, .full_height {\n  height: 100%;\n}\n\nbutton {\n  line-height: 1.4;\n}\nhr {\n  display: block;\n  height: 1px;\n  border: 0;\n  border-top: 1px solid #cccccc;\n  margin: 0;\n  padding: 0; }\n\nbody {\n  min-height: 100%; }\n\nol, ul {\n  list-style: none;\n  list-style-position: inside; }\n\nblockquote, q {\n  quotes: none; }\n\nblockquote:before, blockquote:after,\nq:before, q:after {\n  content: '';\n  content: none; }\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0; }\n\ntd, th {vertical-align: top;}\n\nh1, h2, h3, h4, h5, h6, strong {\n  font-weight: bold; }\n\nem, i {\n  font-style: italic; }\n\nb, strong { font-weight: bold; }\n\n/* ELEMENT DEFAULTS */\n* {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box; \n}\n.goog-te-gadget-simple .goog-te-menu-value span {\n  font-weight: 400;\n}\na {\n  color: inherit;\n  cursor: pointer;\n  text-decoration: underline; \n  font-weight: 700;}\n  a:focus {\n  }\n  a:active {\n  }  \n  a img {\n    border: none; }\n\n:focus {\n}\n.button, button, input[type='submit'] {\n  cursor: pointer;\n  text-align: center; \n  font-size: inherit;\n} .button:focus, button:focus, input[type='submit']:focus {\n} .button:active:focus, button:active:focus, input[type='submit']:active:focus{\n}\n\nbutton.like_link, input[type='submit'].like_link {\n  background: none;\n  border: none;\n  text-decoration: underline;\n  padding: 0px;\n}\n\n.btn {\n  color: white;\n  border: 0;\n  font-weight: 700;\n  padding: .325rem 1.5rem .4rem;\n  line-height: 1.5;\n  text-align: center;\n  text-decoration: none;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n\n  border-radius: .25rem;\n  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;\n  margin: 0;\n  background-color: " + focus_blue + "; \n} .btn[disabled=\"true\"], .btn[disabled] {\n  cursor: default;\n  opacity: .5;\n}\n\n\ntable {\n  border-collapse: separate; }\n\nul {\n  margin: 0;\n  list-style-type: disc; }\n\nol {\n  margin: 0;\n  list-style-type: decimal; }\n\nblockquote {\n  quotes: '\"' '\"' \"'\" \"'\"; }\n  blockquote:before {\n    content: open-quote;}\n  blockquote:after {\n    content: close-quote;}\n";
	
	window.styles += "\nbody, h1, h2, h3, h4, h5, h6 {\n  color: black; }\n\nhtml[lang='cs'] body, html[lang='cs'] input, html[lang='cs'] button, html[lang='cs'] textarea {\n  font-family: Helvetica, Verdana, Arial, 'Lucida Grande', 'Lucida Sans Unicode', sans-serif; }\n\n\ninput[type=\"checkbox\"], input[type=\"radio\"], button, a {\n  cursor: pointer;\n}\n\ninput[type=\"checkbox\"].bigger, input[type=\"radio\"].bigger {\n  transform: scale(1.5) translate(20%,0);\n  font-size: 24px;\n}\n\n.hidden {\n  position:absolute;\n  left:-10000px;\n  top:auto;\n  width:1px;\n  height:1px;\n  overflow:hidden;}\n\na.skip:active, \na.skip:focus, \na.skip:hover {\n    position: fixed;\n    left: 0; \n    top: 0;\n    width: auto; \n    height: auto; \n    overflow: visible; \n}\n\n\n.content {\n  position: relative;\n  font-size: 16px;\n  color: black;\n  min-height: 100%; \n  font-weight: 400;\n\n  background-color: #ffffff;\n\n}\n\n\n.flipped {\n  -moz-transform: scaleX(-1);\n  -o-transform: scaleX(-1);\n  -webkit-transform: scaleX(-1);\n  transform: scaleX(-1);\n  filter: FlipH;\n  -ms-filter: 'FlipH'; }\n\n.primary_button, .primary_cancel_button {\n  border-radius: 16px;\n  text-align: center;\n  padding: 3px;\n  cursor: pointer; }\n\n.primary_button {\n  color: white;\n  font-size: 29px;\n  margin-top: 14px;\n  border: none;\n  padding: 8px 36px; }\n\nbutton.disabled {\n  background-color: #eeeeee;\n  color: #cccccc;\n  box-shadow: none;\n  border: none;\n  cursor: wait; }\n\n.primary_cancel_button {\n  color: #888888;\n  margin-top: 0.5em; }\n\n.cancel_opinion_button {\n  float: right;\n  background: transparent;\n  border: none;\n  margin-top: 0.5em; }\n\nbutton.primary_button, input[type='submit'] {\n  display: inline-block; }\n\nselect.unstyled:not([multiple]){\n    -webkit-appearance:none;\n    -moz-appearance:none;\n    background-position:right 50%;\n    background-repeat:no-repeat;\n    background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBNYWNpbnRvc2giIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDZFNDEwNjlGNzFEMTFFMkJEQ0VDRTM1N0RCMzMyMkIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDZFNDEwNkFGNzFEMTFFMkJEQ0VDRTM1N0RCMzMyMkIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo0NkU0MTA2N0Y3MUQxMUUyQkRDRUNFMzU3REIzMzIyQiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo0NkU0MTA2OEY3MUQxMUUyQkRDRUNFMzU3REIzMzIyQiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PuGsgwQAAAA5SURBVHjaYvz//z8DOYCJgUxAf42MQIzTk0D/M+KzkRGPoQSdykiKJrBGpOhgJFYTWNEIiEeAAAMAzNENEOH+do8AAAAASUVORK5CYII=);\n    padding: .5em;\n    padding-right:1.5em;\n    border-radius: 16px;\n}\n";


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var __convert, convert_customization, customizations_by_file, masthead_only, text_and_masthead;
	
	window.customizations = {};
	
	customizations_by_file = {};
	
	window._ = _;
	
	window.FUNCTION_IDENTIFIER = "#javascript\n";
	
	convert_customization = function(obj) {
	  return __convert(obj, []);
	};
	
	__convert = function(obj, path) {
	  var func, k, p, str_func, tree, v, vv;
	  if (Array.isArray(obj)) {
	    return (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = obj.length; i < len; i++) {
	        vv = obj[i];
	        results.push(__convert(vv, path));
	      }
	      return results;
	    })();
	  } else if (obj === null) {
	    return null;
	  } else if (typeof obj === 'object') {
	    tree = {};
	    for (k in obj) {
	      v = obj[k];
	      p = path.slice();
	      p.push(k);
	      tree[k] = __convert(v, p);
	    }
	    return tree;
	  } else if (typeof obj === 'function') {
	    return "" + FUNCTION_IDENTIFIER + (obj.toString());
	  } else if (typeof obj === 'string' && obj.startsWith(FUNCTION_IDENTIFIER)) {
	    str_func = obj.substring(FUNCTION_IDENTIFIER.length);
	    func = new Function("return " + str_func)();
	    return func;
	  } else {
	    return obj;
	  }
	};
	
	window.load_customization = function(subdomain) {
	  var customizations_file_used, error, ref, subdomain_name;
	  if (!subdomain.name) {
	    return;
	  }
	  subdomain_name = (ref = subdomain.name) != null ? ref.toLowerCase() : void 0;
	  try {
	    customizations_file_used = !!customizations_by_file[subdomain_name];
	    if (customizations_file_used) {
	      console.log(subdomain_name + " config for import: \n", JSON.stringify(convert_customization(customizations_by_file[subdomain_name]), null, 2));
	    }
	    subdomain = fetch('/subdomain');
	    return customizations[subdomain_name] = _.extend({}, customizations_by_file[subdomain_name] || {}, convert_customization(subdomain.customizations));
	  } catch (error1) {
	    error = error1;
	    return console.error(error);
	  }
	};
	
	window.customization = function(field, object_or_key, subdomain) {
	  var chain_of_configs, config, i, key, len, list_key, obj, proposal, ref, ref1, subdomain_config, subdomain_name, value;
	  if (!!object_or_key && (object_or_key.key == null)) {
	    obj = fetch(object_or_key);
	  } else {
	    obj = object_or_key;
	  }
	  if (subdomain == null) {
	    if (object_or_key != null ? (ref = object_or_key.key) != null ? ref.match('/subdomain/') : void 0 : void 0) {
	      subdomain = object_or_key;
	    } else {
	      subdomain = fetch('/subdomain');
	      if (((obj != null ? obj.subdomain_id : void 0) != null) && obj.subdomain_id !== subdomain.id) {
	        subdomain = fetch("/subdomain/" + obj.subdomain_id);
	      }
	    }
	  }
	  subdomain_name = (ref1 = subdomain.name) != null ? ref1.toLowerCase() : void 0;
	  key = obj ? obj.key ? obj.key : obj : null;
	  chain_of_configs = [];
	  if (customizations[subdomain_name] != null) {
	    subdomain_config = customizations[subdomain_name];
	    if (key) {
	      if (subdomain_config[key] != null) {
	        chain_of_configs.push(subdomain_config[key]);
	      }
	      if (key.match(/\/proposal\//)) {
	        proposal = obj;
	        list_key = get_list_for_proposal(proposal);
	        if (subdomain_config[list_key] != null) {
	          chain_of_configs.push(subdomain_config[list_key]);
	        }
	      }
	    }
	    chain_of_configs.push(subdomain_config);
	  }
	  chain_of_configs.push(customizations['default']);
	  value = void 0;
	  for (i = 0, len = chain_of_configs.length; i < len; i++) {
	    config = chain_of_configs[i];
	    value = config[field];
	    if (value != null) {
	      break;
	    }
	  }
	  return value;
	};
	
	window.CustomizationTransition = ReactiveComponent({
	  displayName: 'CustomizationTransition',
	  render: function() {
	    var check_update_customizations_object, ck, customizations_signature, subdomain;
	    subdomain = fetch('/subdomain');
	    customizations_signature = fetch('customizations_signature');
	    check_update_customizations_object = function() {
	      var signature;
	      signature = JSON.stringify(subdomain.customizations);
	      if (customizations_signature.signature !== signature) {
	        customizations_signature.signature = signature;
	        load_customization(subdomain);
	        save(customizations_signature);
	        return re_render(['/subdomain']);
	      }
	    };
	    ck = setInterval(function() {
	      if (!arest.pending_saves['/subdomain']) {
	        check_update_customizations_object();
	        return clearInterval(ck);
	      }
	    }, 1);
	    return SPAN(null);
	  }
	});
	
	__webpack_require__(4);
	
	__webpack_require__(11);
	
	__webpack_require__(16);
	
	customizations["default"] = {
	  point_labels: point_labels.pro_con,
	  slider_pole_labels: slider_labels.agree_disagree,
	  list_opinions_title: 'Opinions',
	  list_items_title: 'Proposals',
	  discussion_enabled: true,
	  homepage_show_search_and_sort: true,
	  list_permit_new_items: true,
	  homepage_show_new_proposal_button: true,
	  show_proposal_meta_data: true,
	  slider_handle: slider_handle.flat,
	  slider_regions: null,
	  show_proposal_scores: true,
	  show_proposer_icon: true,
	  collapse_proposal_description_at: 300,
	  list_is_archived: false,
	  list_uncollapseable: false,
	  list_item_name: 'Proposal',
	  auth_footer: false,
	  has_homepage: true,
	  auth_callout: true,
	  user_tags: {},
	  font: "IBM Plex Sans, Helvetica Neue, sans-serif",
	  header_font: "IBM Plex Sans, IBM Plex Sans, Helvetica Neue, sans-serif",
	  condensed_font: "IBM Plex Sans Condensed, IBM Plex Sans, Helvetica Neue, sans-serif",
	  mono_font: "IBM Plex Mono, Menlo, Consolas, Monaco, Fira Mono, Liberation Mono, Lucida Console, monospace",
	  new_proposal_fields: function() {
	    return {
	      name: translator("engage.edit_proposal.summary_label", "Summary"),
	      description: translator("engage.edit_proposal.description_label", "Details") + (" (" + (translator('optional', 'optional')) + ")"),
	      additional_fields: [],
	      create_description: function(fields) {
	        return fields.description;
	      }
	    };
	  }
	};
	
	text_and_masthead = ['educacion2025', 'ynpn', 'lsfyl', 'kealaiwikuamoo', 'iwikuamoo'];
	
	masthead_only = ["kamakakoi", "seattletimes", "kevin", "ihub", "SilverLakeNC", "Relief-Demo", "GS-Demo", "ri", "ITFeedback", "Committee-Meeting", "policyninja", "SocialSecurityWorks", "amberoon", "economist", "impacthub-demo", "mos", "Cattaca", "Airbdsm", "bitcoin-ukraine", "lyftoff", "hcao", "arlingtoncountyfair", "progressive", "design", "crm", "safenetwork", "librofm", "washingtonpost", "MSNBC", "PublicForum", "AMA-RFS", "AmySchumer", "VillaGB", "AwesomeHenri", "citySENS", "alcala", "MovilidadCDMX", "deus_ex", "neuwrite", "bitesizebio", "HowScienceIsMade", "SABF", "engagedpublic", "sabfteam", "Tunisia", "theartofco", "SGU", "radiolab", "ThisLand", "Actuality", 'cimsec', 'sosh', 'swotconsultants'];
	
	setTimeout(function() {
	  var i, j, len, len1, results, sub;
	  if (typeof ImageHeader !== "undefined" && ImageHeader !== null) {
	    window.LegacyImageHeader = ImageHeader;
	    for (i = 0, len = text_and_masthead.length; i < len; i++) {
	      sub = text_and_masthead[i];
	      customizations_by_file[sub.toLowerCase()] = {
	        HomepageHeader: LegacyImageHeader
	      };
	    }
	    results = [];
	    for (j = 0, len1 = masthead_only.length; j < len1; j++) {
	      sub = masthead_only[j];
	      results.push(customizations_by_file[sub.toLowerCase()] = {
	        HomepageHeader: LegacyImageHeader
	      });
	    }
	    return results;
	  }
	});


/***/ },
/* 3 */
/***/ function(module, exports) {

	var is_android_browser, rxaosp;
	
	rxaosp = window.navigator.userAgent.match(/Android.*AppleWebKit\/([\d.]+)/);
	
	is_android_browser = !!(rxaosp && rxaosp[1] < 537);
	
	window.browser = {
	  key: 'browser',
	  is_android_browser: is_android_browser,
	  is_opera_mini: !!navigator.userAgent.match(/Opera Mini/),
	  high_density_display: (window.matchMedia && (window.matchMedia('(min-resolution: 124dpi), \n(min-resolution: 1.3dppx), \n(min-resolution: 48.8dpcm)').matches || window.matchMedia('(-webkit-min-device-pixel-ratio: 1.3), \n(-o-min-device-pixel-ratio: 2.6/2), \n(min--moz-device-pixel-ratio: 1.3), \n(min-device-pixel-ratio: 1.3)').matches)) || (window.devicePixelRatio && window.devicePixelRatio > 1.3),
	  is_mobile: is_android_browser || navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i),
	  touch: matchMedia('(hover: none)').matches
	};
	
	save(browser);
	
	window.BrowserHacks = ReactiveComponent({
	  displayName: 'BrowserHacks',
	  render: function() {
	    var browser;
	    browser = fetch('browser');
	    if (browser.is_opera_mini) {
	      return DIV({
	        style: {
	          backgroundColor: 'red',
	          padding: 10,
	          textAlign: 'center',
	          color: 'white',
	          fontSize: 24
	        }
	      }, "This website does not work well with ", browser.is_android_browser ? 'the Android Browser' : 'Opera Mini', ". Please use ", A({
	        href: "https://play.google.com/store/apps/details?id=com.android.chrome&hl=en",
	        style: {
	          color: 'white',
	          textDecoration: 'underline'
	        }
	      }, 'Chrome for Android'), ' if you experience difficulty. Thanks, and sorry for the inconvenience!');
	    } else {
	      return SCRIPT({
	        type: 'text/javascript',
	        src: '//browser-update.org/update.js'
	      });
	    }
	  }
	});


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var addEventListener, location, old_A, parseURL, popstate_event, ref, relativeURLFromLocation, relativeURLFromStatebus,
	  hasProp = {}.hasOwnProperty;
	
	__webpack_require__(1);
	
	__webpack_require__(3);
	
	window.is_a_dialogue_page = function() {
	  var url;
	  url = fetch('location').url;
	  return url.indexOf('/dashboard') === -1 && url.indexOf('/docs/') === -1;
	};
	
	parseURL = function(url) {
	  var alt_search, i, parser, pathname, queries, searchObject, split;
	  parser = document.createElement('a');
	  parser.href = url;
	  pathname = parser.pathname || '/';
	  if (pathname[0] !== '/') {
	    pathname = "/" + pathname;
	  }
	  searchObject = {};
	  alt_search = new URLSearchParams(parser.search);
	  queries = parser.search.replace(/^\?/, '').split('&');
	  i = 0;
	  while (i < queries.length) {
	    if (queries[i].length > 0) {
	      split = queries[i].split('=');
	      searchObject[split[0]] = alt_search.get(split[0]);
	    }
	    i++;
	  }
	  return {
	    protocol: parser.protocol,
	    host: parser.host,
	    hostname: parser.hostname,
	    port: parser.port,
	    pathname: pathname,
	    search: parser.search,
	    searchObject: searchObject,
	    hash: parser.hash
	  };
	};
	
	window.loadPage = function(url, query_params, triggered_by) {
	  var hash, k, loc, ref, url_parts, v;
	  loc = fetch('location');
	  loc.query_params = query_params || {};
	  url_parts = parseURL("" + (location_origin()) + url);
	  ref = url_parts.searchObject;
	  for (k in ref) {
	    v = ref[k];
	    if (k.length > 0) {
	      loc.query_params[decodeURIComponent(k)] = decodeURIComponent(v);
	    }
	  }
	  if (loc.query_params.u) {
	    delete loc.query_params.u;
	  }
	  if (loc.query_params.t) {
	    delete loc.query_params.t;
	  }
	  hash = url_parts.hash;
	  if (hash && hash.length > 0) {
	    hash = hash.substring(1);
	    loc.seek_to_hash = hash;
	  }
	  loc.url = decodeURIComponent(url_parts.pathname);
	  loc.hash = hash;
	  loc.triggered_by = triggered_by;
	  return save(loc);
	};
	
	old_A = A;
	
	window.is_swipping = false;
	
	window.A = React.createFactory(createReactClass({
	  displayName: 'modified_A',
	  render: function() {
	    var props;
	    props = _.extend({}, this.props);
	    if (props.treat_as_external_link != null) {
	      delete props.treat_as_external_link;
	    }
	    if (props.href) {
	      this._onclick = props.onClick || (function() {
	        return null;
	      });
	      if (browser.is_mobile) {
	        props.onTouchEnd = (function(_this) {
	          return function(e) {
	            if (!is_swipping) {
	              return _this.handleClick(e);
	            }
	          };
	        })(this);
	        if (browser.is_android_browser) {
	          props.onClick = function(e) {
	            e.preventDefault();
	            return e.stopPropagation();
	          };
	        }
	      } else {
	        props.onClick = this.handleClick;
	      }
	    }
	    return old_A(props, props.children);
	  },
	  handleClick: function(event) {
	    var href, is_external_link, is_mailto, no_scroll, node, opened_in_new_tab;
	    node = ReactDOM.findDOMNode(this);
	    no_scroll = node.getAttribute('data-no-scroll');
	    href = node.getAttribute('href');
	    is_external_link = href.indexOf('//') > -1 || this.props.treat_as_external_link;
	    is_mailto = href.toLowerCase().indexOf('mailto') > -1;
	    opened_in_new_tab = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
	    if (!is_external_link && !opened_in_new_tab && !is_mailto && !node.getAttribute('data-nojax')) {
	      event.preventDefault();
	      event.stopPropagation();
	      loadPage(href);
	      this._onclick(event);
	      return setTimeout((function(_this) {
	        return function() {
	          if (!no_scroll || no_scroll === 'false') {
	            return window.scrollTo(0, 0);
	          }
	        };
	      })(this), 1);
	    } else {
	      return this._onclick(event);
	    }
	  }
	}));
	
	window.BrowserLocation = ReactiveComponent({
	  displayName: 'BrowserLocation',
	  render: function() {
	    var doc, loc, new_location, title;
	    loc = fetch('location');
	    doc = fetch('document');
	    title = doc.title || document.title;
	    if (doc.title && document.title !== doc.title) {
	      document.title = doc.title;
	    }
	    new_location = relativeURLFromStatebus();
	    if (this.last_location !== new_location) {
	      if (relativeURLFromLocation() !== new_location) {
	        history.pushState(loc.query_params, title, new_location);
	      }
	      this.last_location = new_location;
	      writeToLog({
	        what: 'changing url',
	        where: loc.url
	      });
	    }
	    return SPAN(null);
	  },
	  componentDidUpdate: function() {
	    var int, loc;
	    loc = fetch('location');
	    if (loc.seek_to_hash) {
	      loc.seek_to_hash = false;
	      save(loc);
	      return int = setInterval(function() {
	        var docks, e, el, noop, seek_below;
	        el = null;
	        try {
	          el = document.querySelector("#" + loc.hash);
	        } catch (error) {
	          e = error;
	          noop = 1;
	        }
	        el || (el = document.querySelector("[name=\"" + loc.hash + "\"]") || document.querySelector("#p" + loc.hash));
	        if (el) {
	          docks = fetch('docking_station');
	          seek_below = docks.y_stack || 50;
	          window.scrollTo(0, getCoords(el).top - seek_below);
	          el.focus();
	          return clearInterval(int);
	        }
	      }, 100);
	    }
	  }
	});
	
	relativeURLFromLocation = function() {
	  var loc, ref, ref1, search;
	  search = (ref = location.search) != null ? ref.replace(/\%2[fF]/g, '/') : void 0;
	  loc = (ref1 = location.pathname) != null ? ref1.replace(/\%20/g, ' ') : void 0;
	  return "" + loc + search + location.hash;
	};
	
	relativeURLFromStatebus = function() {
	  var k, loc, query_params, ref, relative_url, v;
	  loc = fetch('location');
	  relative_url = loc.url;
	  if (_.keys(loc.query_params).length > 0) {
	    query_params = (function() {
	      var ref, results;
	      ref = loc.query_params;
	      results = [];
	      for (k in ref) {
	        if (!hasProp.call(ref, k)) continue;
	        v = ref[k];
	        results.push(k + "=" + (encodeURIComponent(v)));
	      }
	      return results;
	    })();
	    relative_url += "?" + (query_params.join('&'));
	  }
	  if (((ref = loc.hash) != null ? ref.length : void 0) > 0) {
	    relative_url += "#" + loc.hash;
	  }
	  return relative_url;
	};
	
	location = window.history.location || window.location;
	
	ref = window.addEventListener ? ['addEventListener', 'popstate'] : ['attachEvent', 'onpopstate'], addEventListener = ref[0], popstate_event = ref[1];
	
	window[addEventListener](popstate_event, function(ev) {
	  return loadPage(relativeURLFromLocation());
	});
	
	loadPage(relativeURLFromLocation());


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	__webpack_require__(4);
	
	__webpack_require__(2);
	
	__webpack_require__(1);
	
	__webpack_require__(9);
	
	window.AuthCallout = ReactiveComponent({
	  displayName: 'AuthCallout',
	  render: function() {
	    var create_account_button_style, current_user, subdomain;
	    current_user = fetch('/current_user');
	    subdomain = fetch('/subdomain');
	    if (current_user.logged_in || customization('contribution_phase') === 'frozen') {
	      return SPAN(null);
	    }
	    create_account_button_style = {
	      marginRight: 8
	    };
	    return DIV({
	      style: {
	        width: '100%'
	      }
	    }, DIV({
	      style: {
	        padding: 12,
	        textAlign: 'center'
	      }
	    }, DIV({
	      style: {
	        fontSize: PHONE_SIZE() ? 16 : 20,
	        fontWeight: 600
	      }
	    }, AUTH_CALLOUT_BUTTONS(create_account_button_style), indexOf.call(subdomain.roles.participant, '*') < 0 ? DIV({
	      style: {
	        fontSize: 12,
	        marginTop: 4
	      }
	    }, translator('engage.permissions.only_some_participate', 'Only some accounts are authorized to participate.')) : void 0), this.props.children ? this.props.children : void 0));
	  }
	});
	
	window.AUTH_CALLOUT_BUTTONS = function(button_style) {
	  var subdomain;
	  if (button_style == null) {
	    button_style = {};
	  }
	  if (PHONE_SIZE()) {
	    _.extend(button_style, {
	      display: 'block',
	      margin: 'auto'
	    });
	  }
	  subdomain = fetch('/subdomain');
	  if (subdomain.SSO_domain) {
	    return TRANSLATE({
	      id: 'create_account.call_out',
	      BUTTON1: {
	        component: A,
	        args: {
	          className: "btn create_account",
	          href: '/login_via_saml',
	          treat_as_external_link: true,
	          style: button_style
	        }
	      }
	    }, "<BUTTON1>Create an Account</BUTTON1> to share your thoughts");
	  } else if (embedded_demo()) {
	    return DIV(null, BUTTON({
	      key: 'create_button',
	      'data-action': 'create',
	      onClick: (function(_this) {
	        return function(e) {
	          return reset_key('auth', {
	            form: 'create account'
	          });
	        };
	      })(this),
	      style: button_style,
	      className: "btn create_account"
	    }, "Choose a persona"), "to participate here");
	  } else {
	    return TRANSLATE({
	      id: 'create_account.call_out',
	      BUTTON1: {
	        component: BUTTON,
	        args: {
	          key: 'create_button',
	          'data-action': 'create',
	          onClick: (function(_this) {
	            return function(e) {
	              return reset_key('auth', {
	                form: 'create account'
	              });
	            };
	          })(this),
	          style: button_style,
	          className: "btn create_account"
	        }
	      }
	    }, "<BUTTON1>Create an Account</BUTTON1> to share your thoughts");
	  }
	};
	
	window.AuthTransition = ReactiveComponent({
	  displayName: 'AuthTransition',
	  render: function() {
	    var allegiance, auth, avatar_url, base, current_user, email, id, name, ref, subdomain;
	    current_user = fetch('/current_user');
	    auth = fetch('auth');
	    if ((base = this.local).logged_in_last_render == null) {
	      base.logged_in_last_render = current_user.logged_in;
	    }
	    if (current_user.csrf) {
	      arest.csrf();
	    }
	    if (this.local.current_auth !== auth.form) {
	      this.local.current_auth = auth.form;
	      current_user.errors = [];
	    }
	    if ((auth.form !== 'user questions' && !this.local.logged_in_last_render && current_user.logged_in && !auth.show_user_questions_after_account_creation) || (auth.form === 'verify email' && current_user.verified) || (auth.form === 'user questions' && (current_user.completed_host_questions && !auth.show_user_questions_after_account_creation)) || (auth.form === 'create account via invitation' && !current_user.needs_to_complete_profile)) {
	      reset_key(auth);
	    }
	    if (current_user.needs_to_complete_profile && ((ref = auth.form) !== 'edit profile' && ref !== 'create account via invitation')) {
	      subdomain = fetch('/subdomain');
	      reset_key('auth', {
	        key: 'auth',
	        form: subdomain.SSO_domain ? 'edit profile' : 'create account via invitation',
	        goal: ''
	      });
	      if (subdomain.SSO_domain) {
	        loadPage('/dashboard/edit_profile');
	      }
	    } else if (current_user.logged_in && ((!current_user.completed_host_questions && !auth.form) || auth.show_user_questions_after_account_creation)) {
	      reset_key('auth', {
	        form: 'user questions',
	        goal: '',
	        show_user_questions_after_account_creation: auth.show_user_questions_after_account_creation
	      });
	    } else if (current_user.needs_to_verify && !window.send_verification_token) {
	      current_user.trying_to = 'send_verification_token';
	      save(current_user);
	      window.send_verification_token = true;
	      reset_key('auth', {
	        key: 'auth',
	        form: 'verify email',
	        goal: 'To participate, please demonstrate you control this email.'
	      });
	    }
	    this.local.logged_in_last_render = current_user.logged_in;
	    if (embedded_demo() && fetch('/subdomain').name === 'galacticfederation') {
	      if (auth.form === 'create account') {
	        id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 15);
	        _.extend(current_user, {
	          name: "temp",
	          email: "temp-" + id + "@galacticfederation.gov",
	          password: "" + (Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 15)),
	          trying_to: 'create account'
	        });
	        save(current_user);
	        reset_key('auth', {
	          form: 'user questions',
	          goal: "",
	          after: auth.after,
	          show_user_questions_after_account_creation: auth.show_user_questions_after_account_creation
	        });
	      } else if (current_user.tags.federation_allegiance && current_user.name === 'temp') {
	        allegiance = current_user.tags.federation_allegiance;
	        id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 15);
	        switch (allegiance) {
	          case 'Dark':
	            name = "Stormtrooper #" + id;
	            email = "stormtrooper-" + id + "@deathstar.org";
	            avatar_url = "https://d2rtgkroh5y135.cloudfront.net/system/avatars/287330/large/stormtrooper1.png";
	            break;
	          case 'Light':
	            name = "Ewok #" + id;
	            email = "endorite-" + id + "@endor.net";
	            avatar_url = "https://f.consider.it/galacticfederation/ewok.png";
	            break;
	          case "Wouldn't you like to know":
	            name = "Wookiee #" + id;
	            email = "kashyyyk-wook" + id + "@oo.com";
	            avatar_url = 'https://f.consider.it/galacticfederation/wookiee.jpeg';
	            break;
	          case 'Non-binary':
	            name = "Rodian #" + id;
	            email = "rodia-" + id + "@bountyhuntersrus.com";
	            avatar_url = 'https://f.consider.it/galacticfederation/rodian.jpeg';
	            break;
	        }
	        _.extend(current_user, {
	          name: name,
	          email: email,
	          avatar_url: avatar_url
	        });
	        save(current_user);
	        poll_until_avatar_arrives();
	      }
	    }
	    return SPAN(null);
	  }
	});
	
	window.Auth = ReactiveComponent({
	  displayName: 'Auth',
	  render: function() {
	    var auth, current_user;
	    current_user = fetch('/current_user');
	    auth = fetch('auth');
	    if (auth.form === 'reset password') {
	      return ResetPassword(this.props);
	    } else if (auth.form === 'verify email') {
	      return VerifyEmail(this.props);
	    } else if (auth.form === 'login') {
	      return Login(this.props);
	    } else if (auth.form === 'create account') {
	      return CreateAccount(this.props);
	    } else if (auth.form === 'create account via invitation') {
	      return CreateAccount({
	        by_invitation: true
	      });
	    } else if (auth.form === 'user questions') {
	      return HostQuestions(this.props);
	    } else {
	      return SPAN(null);
	    }
	  },
	  componentDidMount: function() {
	    return writeToLog({
	      what: 'accessed authentication'
	    });
	  }
	});
	
	window.logout = function() {
	  var auth, current_user, loc;
	  current_user = fetch('/current_user');
	  current_user.logged_in = false;
	  current_user.trying_to = 'logout';
	  auth = fetch('auth');
	  loc = fetch('location');
	  if (loc.url.match('/dashboard')) {
	    loadPage('/');
	  }
	  reset_key(auth);
	  return save(current_user, (function(_this) {
	    return function() {
	      return location.reload();
	    };
	  })(this));
	};
	
	window.auth_text_gray = '#444';
	
	window.styles += ".AUTH {}\n\n#AUTH_wrapper {\n  margin: 0 auto;\n  position: relative;\n  z-index: 0;\n  padding: 3em 0;\n}\n\n.AUTH_header {\n  text-align: center;\n  margin-bottom: 48px;\n}\n\n#AUTH_goal {\n  font-size: 16px;\n  text-align: center;\n  color: white;\n  margin-bottom: 8px;\n  font-style: italic;\n}\n\n#AUTH_task {\n  font-size: 38px;\n  font-weight: 700;\n  margin-bottom: 18px;\n}\n\n.AUTH_body_wrapper {\n  padding: 3.5em 105px 4em 90px;\n  font-size: 16px;\n  box-shadow: 0 2px 4px rgba(0,0,0,.4), 0 0 100px rgb(255 255 255 / 40%);\n  background-color: white;\n  position: relative;\n  border-radius: 16px;\n}\n\n.AUTH_cancel {\n  background-color: transparent;\n  border: none;\n  opacity: .7;\n}\n\n.AUTH_cancel.floating {\n  color: white;\n  position: absolute;\n  cursor: pointer;\n  right: -46px;\n  top: 16px;\n  padding: 10px;\n  font-size: 24px;\n}\n.AUTH_cancel.embedded {\n  margin: 8px auto 0px auto;\n  padding: 8px 0 8px 8px;\n  font-size: 18px;\n}\n\n@media " + PHONE_MEDIA + " {\n  .AUTH_cancel.floating {\n    display: none;\n  }\n}\n\n.AUTH_submit_button {\n  font-size: 22px;\n  display: block;\n  width: 100%;\n  margin-top: 20px;\n  border-radius: 16px;\n  padding: .8rem 1.5rem .8rem;\n  background-color: " + selected_color + ";\n}\n\n.AUTH_field_wrapper {\n  margin-bottom: 12px;\n}\n\n.AUTH_field_label {\n  color: #444;\n  font-size: 12px;\n  display: block;\n  text-transform: uppercase;\n}\n\n.AUTH_text_input {\n  margin-bottom: 6px;\n  width: 100%;\n  border: 1px solid #ccc;\n  padding: 10px 14px;\n  font-size: 20px;\n  display: inline-block;\n  background-color: #f2f2f2;\n}\n\n\n@media " + PHONE_MEDIA + " {\n  .AUTH_body_wrapper {\n    padding: 2em 16px;\n  }\n  #AUTH_task {\n    font-size: 28px;      \n  }\n}\n\n";
	
	window.AuthForm = {
	  Draw: function(options, children) {
	    var cancel_modal;
	    cancel_modal = function(e) {
	      if (typeof options.before_cancel === "function") {
	        options.before_cancel();
	      }
	      if (location.pathname === '/proposal/new') {
	        loadPage('/');
	      }
	      return reset_key('auth');
	    };
	    return DIV({
	      className: 'AUTH'
	    }, !this.props.no_modal ? DIV({
	      id: 'lightbox'
	    }) : void 0, DIV({
	      id: !this.props.no_modal ? 'modal' : void 0,
	      ref: !this.props.no_modal ? 'dialog' : void 0,
	      role: !this.props.no_modal ? 'dialog' : void 0,
	      'aria-labelledby': 'AUTH_task',
	      'aria-describedby': options.goal ? 'AUTH_goal' : void 0
	    }, DIV({
	      id: 'AUTH_wrapper',
	      style: {
	        maxWidth: AUTH_WIDTH()
	      }
	    }, !options.disallow_cancel && !this.props.disallow_cancel ? BUTTON({
	      className: 'AUTH_cancel floating',
	      title: translator('shared.cancel_button', 'cancel'),
	      onClick: cancel_modal
	    }, DIV({
	      dangerouslySetInnerHTML: {
	        __html: '<svg x="0px" y="0px" fill="white" viewBox="0 0 64 80" enable-background="new 0 0 64 64" xml:space="preserve"><g><path d="M17.586,46.414C17.977,46.805,18.488,47,19,47s1.023-0.195,1.414-0.586L32,34.828l11.586,11.586   C43.977,46.805,44.488,47,45,47s1.023-0.195,1.414-0.586c0.781-0.781,0.781-2.047,0-2.828L34.828,32l11.586-11.586   c0.781-0.781,0.781-2.047,0-2.828c-0.781-0.781-2.047-0.781-2.828,0L32,29.172L20.414,17.586c-0.781-0.781-2.047-0.781-2.828,0   c-0.781,0.781-0.781,2.047,0,2.828L29.172,32L17.586,43.586C16.805,44.367,16.805,45.633,17.586,46.414z"/><path d="M32,64c8.547,0,16.583-3.329,22.626-9.373C60.671,48.583,64,40.547,64,32s-3.329-16.583-9.374-22.626   C48.583,3.329,40.547,0,32,0S15.417,3.329,9.374,9.373C3.329,15.417,0,23.453,0,32s3.329,16.583,9.374,22.626   C15.417,60.671,23.453,64,32,64z M12.202,12.202C17.49,6.913,24.521,4,32,4s14.51,2.913,19.798,8.202C57.087,17.49,60,24.521,60,32   s-2.913,14.51-8.202,19.798C46.51,57.087,39.479,60,32,60s-14.51-2.913-19.798-8.202C6.913,46.51,4,39.479,4,32   S6.913,17.49,12.202,12.202z"/></g></svg>'
	      },
	      style: {
	        width: 30
	      }
	    })) : void 0, options.goal ? DIV({
	      id: 'AUTH_goal'
	    }, options.goal) : void 0, DIV({
	      className: "AUTH_body_wrapper"
	    }, DIV({
	      className: 'AUTH_header'
	    }, H1({
	      id: 'AUTH_task'
	    }, options.task), typeof options.render_below_title === "function" ? options.render_below_title() : void 0), children, BUTTON({
	      className: "btn AUTH_submit_button " + (this.local.submitting ? 'disabled' : void 0),
	      onClick: options.on_submit
	    }, options.submit_button || this.i18n().submit_button), !options.disallow_cancel ? DIV({
	      style: {
	        textAlign: 'center'
	      }
	    }, BUTTON({
	      ref: 'cancel_dialog',
	      className: 'AUTH_cancel embedded',
	      title: translator('shared.cancel_button', 'cancel'),
	      onClick: cancel_modal
	    }, translator('shared.cancel_button', 'cancel'))) : void 0, options.under_submit ? options.under_submit : void 0))));
	  },
	  RenderInput: function(opts) {
	    var base, base1, current_user, field_id, name, type;
	    current_user = fetch('/current_user');
	    type = opts.type || 'text';
	    name = opts.name;
	    field_id = "user_" + name;
	    if ((base = this.local).updates == null) {
	      base.updates = {};
	    }
	    if ((base1 = this.local.updates)[name] == null) {
	      base1[name] = current_user[name];
	    }
	    return DIV({
	      key: field_id,
	      className: 'AUTH_field_wrapper',
	      style: {
	        opacity: opts.disabled ? .5 : void 0
	      }
	    }, LABEL({
	      className: 'AUTH_field_label',
	      htmlFor: field_id
	    }, opts.label), opts.render ? opts.render() : INPUT({
	      id: 'user_' + name,
	      key: name + "_inputBox",
	      name: "user[" + name + "]",
	      type: type,
	      className: 'AUTH_text_input',
	      defaultValue: this.local.updates[name],
	      'aria-label': opts.label,
	      autoComplete: 'off',
	      disabled: opts.disabled,
	      onChange: (function(_this) {
	        return function(event) {
	          if (type === 'email') {
	            _this.local.updates[name] = event.target.value.trim();
	          } else {
	            _this.local.updates[name] = event.target.value;
	          }
	          return save(_this.local);
	        };
	      })(this),
	      onKeyPress: (function(_this) {
	        return function(event) {
	          if (event.which === 13) {
	            return opts.on_submit(event);
	          }
	        };
	      })(this)
	    }));
	  },
	  Submit: function(ev, opts) {
	    var current_user;
	    current_user = fetch('/current_user');
	    ev.preventDefault();
	    if (opts == null) {
	      opts = {};
	    }
	    if (opts.has_host_questions) {
	      this.local.errors = errors_in_host_questions(current_user.tags);
	    } else {
	      this.local.errors = [];
	    }
	    if (this.local.errors.length === 0) {
	      current_user.trying_to = opts.action;
	      if (this.local.updates) {
	        _.extend(current_user, this.local.updates);
	      }
	      this.local.submitting = true;
	      save(current_user, (function(_this) {
	        return function() {
	          _this.local.saved_successfully = current_user.errors.length + _this.local.errors.length === 0;
	          _this.local.submitting = false;
	          save(_this.local);
	          if (_this.local.saved_successfully) {
	            return typeof opts.onSuccess === "function" ? opts.onSuccess() : void 0;
	          }
	        };
	      })(this));
	      if (opts.has_avatar_upload) {
	        upload_avatar();
	      }
	    }
	    return save(this.local);
	  },
	  ShowErrors: function(errors) {
	    var current_user, error;
	    current_user = fetch('/current_user');
	    errors = (current_user.errors || []).concat(this.local.errors || []);
	    if (!errors || errors.length === 0) {
	      return SPAN(null);
	    }
	    return DIV({
	      role: 'alert',
	      style: {
	        fontSize: 18,
	        color: 'darkred',
	        backgroundColor: '#ffD8D8',
	        padding: 10,
	        marginTop: 10
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = errors.length; i < len; i++) {
	        error = errors[i];
	        results.push(DIV(null, I({
	          className: 'fa fa-exclamation-circle',
	          style: {
	            paddingRight: 9
	          }
	        }), SPAN(null, error)));
	      }
	      return results;
	    })());
	  },
	  i18n: function() {
	    return {
	      name_label: translator('auth.create.name_label', 'Your name or pseudonym'),
	      email_label: translator('auth.login.email_label', 'Your email'),
	      password_label: translator('auth.login.password_label', 'Your password'),
	      old_password_label: translator('auth.login.old_password_label', 'Your old password'),
	      new_password_label: translator('auth.login.new_password_label', 'New password'),
	      pic_prompt: translator('auth.create.pic_prompt', 'Your picture'),
	      code_label: translator('auth.code_entry', 'Code'),
	      successful_update: translator("auth.successful_update", "Updated successfully"),
	      verification_sent_message: translator('auth.verification_sent', 'We just emailed you a verification code. Copy / paste it below.'),
	      submit_button: translator("auth.submit", 'Done')
	    };
	  }
	};
	
	__webpack_require__(32);
	
	__webpack_require__(30);
	
	__webpack_require__(33);
	
	__webpack_require__(28);
	
	__webpack_require__(29);


/***/ },
/* 6 */
/***/ function(module, exports) {

	/**
	 * JS Implementation of MurmurHash3 (r136) (as of May 20, 2011)
	 * 
	 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
	 * @see http://github.com/garycourt/murmurhash-js
	 * @author <a href="mailto:aappleby@gmail.com">Austin Appleby</a>
	 * @see http://sites.google.com/site/murmurhash/
	 * 
	 * @param {string} key ASCII only
	 * @param {number} seed Positive integer only
	 * @return {number} 32-bit positive integer hash 
	 */
	
	function murmurhash3_32_gc(key, seed) {
	  var remainder, bytes, h1, h1b, c1, c1b, c2, c2b, k1, i;
	  
	  remainder = key.length & 3; // key.length % 4
	  bytes = key.length - remainder;
	  h1 = seed;
	  c1 = 0xcc9e2d51;
	  c2 = 0x1b873593;
	  i = 0;
	  
	  while (i < bytes) {
	      k1 = 
	        ((key.charCodeAt(i) & 0xff)) |
	        ((key.charCodeAt(++i) & 0xff) << 8) |
	        ((key.charCodeAt(++i) & 0xff) << 16) |
	        ((key.charCodeAt(++i) & 0xff) << 24);
	    ++i;
	    
	    k1 = ((((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16))) & 0xffffffff;
	    k1 = (k1 << 15) | (k1 >>> 17);
	    k1 = ((((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16))) & 0xffffffff;
	
	    h1 ^= k1;
	        h1 = (h1 << 13) | (h1 >>> 19);
	    h1b = ((((h1 & 0xffff) * 5) + ((((h1 >>> 16) * 5) & 0xffff) << 16))) & 0xffffffff;
	    h1 = (((h1b & 0xffff) + 0x6b64) + ((((h1b >>> 16) + 0xe654) & 0xffff) << 16));
	  }
	  
	  k1 = 0;
	  
	  switch (remainder) {
	    case 3: k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16;
	    case 2: k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8;
	    case 1: k1 ^= (key.charCodeAt(i) & 0xff);
	    
	    k1 = (((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16)) & 0xffffffff;
	    k1 = (k1 << 15) | (k1 >>> 17);
	    k1 = (((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16)) & 0xffffffff;
	    h1 ^= k1;
	  }
	  
	  h1 ^= key.length;
	
	  h1 ^= h1 >>> 16;
	  h1 = (((h1 & 0xffff) * 0x85ebca6b) + ((((h1 >>> 16) * 0x85ebca6b) & 0xffff) << 16)) & 0xffffffff;
	  h1 ^= h1 >>> 13;
	  h1 = ((((h1 & 0xffff) * 0xc2b2ae35) + ((((h1 >>> 16) * 0xc2b2ae35) & 0xffff) << 16))) & 0xffffffff;
	  h1 ^= h1 >>> 16;
	
	  return h1 >>> 0;
	}
	
	
	window.murmurhash = murmurhash3_32_gc
	


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	
	__webpack_require__(12);
	
	window.Bubblemouth = function(props) {
	  var apex, bubblemouth_path, cx, full_width, id, qx1, qx2, qy1, qy2, ref, ref1, ref2, ref3, ref4, skew_x, skew_y, svg_h, svg_w, x1, x2, x3, x_pad, y1, y2, y3;
	  _.defaults(props, {
	    svg_w: 85,
	    svg_h: 100,
	    skew_x: 15,
	    skew_y: 80,
	    apex_xfrac: .5,
	    fill: 'white',
	    stroke: focus_color(),
	    stroke_width: 10,
	    box_shadow: null
	  });
	  full_width = props.svg_w + 4 * props.skew_x * Math.max(.5, Math.abs(.5 - props.apex_xfrac));
	  _.defaults(props, {
	    width: full_width,
	    height: props.svg_h
	  });
	  apex = props.apex_xfrac;
	  svg_w = props.svg_w;
	  svg_h = props.svg_h;
	  skew_x = props.skew_x;
	  skew_y = props.skew_y;
	  cx = skew_x + svg_w / 2;
	  ref = [skew_x - apex * skew_x, svg_h], x1 = ref[0], y1 = ref[1];
	  ref1 = [skew_x + apex * svg_w, 0], x2 = ref1[0], y2 = ref1[1];
	  ref2 = [x1 + svg_w + skew_x, svg_h], x3 = ref2[0], y3 = ref2[1];
	  ref3 = [-skew_x + apex * (cx + 2 * skew_x), skew_y], qx1 = ref3[0], qy1 = ref3[1];
	  ref4 = [qx1 + cx, skew_y], qx2 = ref4[0], qy2 = ref4[1];
	  bubblemouth_path = "M  " + x1 + "  " + y1 + "\nQ " + qx1 + " " + qy1 + "\n   " + x2 + "  " + y2 + "\nQ " + qx2 + " " + qy2 + "\n   " + x3 + "  " + y3 + "\n";
	  id = "x-" + ((Math.random() * 10000000000).toFixed(0));
	  x_pad = 0;
	  if (props.box_shadow) {
	    x_pad = (props.box_shadow.dx || 0) + (props.box_shadow.stdDeviation || 0);
	    if (x_pad > 0) {
	      x_pad *= -1;
	    }
	  }
	  return SVG({
	    version: "1.1",
	    xmlns: "http://www.w3.org/2000/svg",
	    width: props.width,
	    height: props.height,
	    viewBox: x_pad + " 0 " + full_width + " " + svg_h,
	    preserveAspectRatio: "none",
	    style: props.style ? props.style : void 0
	  }, DEFS(null, CLIPPATH({
	    id: id
	  }, PATH({
	    strokeWidth: props.stroke_width * 2,
	    d: bubblemouth_path
	  })), props.box_shadow ? svg.dropShadow(_.extend(props.box_shadow, {
	    id: id + "-shadow"
	  })) : void 0), props.box_shadow ? PATH({
	    key: 'shadow',
	    fill: props.fill,
	    style: {
	      filter: "url(#" + id + "-shadow)"
	    },
	    d: bubblemouth_path
	  }) : void 0, PATH({
	    key: 'stroke',
	    fill: props.fill,
	    stroke: props.stroke,
	    strokeWidth: props.stroke_width * 2,
	    clipPath: "url(#" + id + ")",
	    strokeDasharray: props.dash_array ? props.dash_array : void 0,
	    d: bubblemouth_path
	  }));
	};
	
	window.PointBubblemouth = function(props) {
	  var apex, bubblemouth_path, cx, full_width, qx1, qx2, qy1, qy2, ref, ref1, ref2, ref3, ref4, skew_x, skew_y, svg_h, svg_w, x1, x2, x3, x_pad, y1, y2, y3;
	  _.defaults(props, {
	    svg_w: 85,
	    svg_h: 100,
	    skew_x: 15,
	    skew_y: 80,
	    apex_xfrac: .5,
	    fill: 'white',
	    stroke: focus_color(),
	    stroke_width: 10,
	    box_shadow: null
	  });
	  full_width = props.svg_w + 4 * props.skew_x * Math.max(.5, Math.abs(.5 - props.apex_xfrac));
	  _.defaults(props, {
	    width: full_width,
	    height: props.svg_h
	  });
	  apex = props.apex_xfrac;
	  svg_w = props.svg_w;
	  svg_h = props.svg_h;
	  skew_x = props.skew_x;
	  skew_y = props.skew_y;
	  cx = skew_x + svg_w / 2;
	  ref = [skew_x - apex * skew_x, svg_h], x1 = ref[0], y1 = ref[1];
	  ref1 = [skew_x + apex * svg_w, 0], x2 = ref1[0], y2 = ref1[1];
	  ref2 = [x1 + svg_w + skew_x, svg_h], x3 = ref2[0], y3 = ref2[1];
	  ref3 = [-skew_x + apex * (cx + 2 * skew_x), skew_y], qx1 = ref3[0], qy1 = ref3[1];
	  ref4 = [qx1 + cx, skew_y], qx2 = ref4[0], qy2 = ref4[1];
	  bubblemouth_path = "M  " + x1 + "  " + y1 + "\nQ " + qx1 + " " + qy1 + "\n   " + x2 + "  " + y2 + "\nQ " + qx2 + " " + qy2 + "\n   " + x3 + "  " + y3 + "\n";
	  x_pad = 0;
	  if (props.box_shadow) {
	    x_pad = (props.box_shadow.dx || 0) + (props.box_shadow.stdDeviation || 0);
	    if (x_pad > 0) {
	      x_pad *= -1;
	    }
	  }
	  return SVG({
	    version: "1.1",
	    xmlns: "http://www.w3.org/2000/svg",
	    width: props.width,
	    height: props.height,
	    viewBox: x_pad + " 0 " + full_width + " " + svg_h,
	    preserveAspectRatio: "none",
	    style: props.style ? props.style : void 0
	  }, PATH({
	    key: 'stroke',
	    fill: props.fill,
	    stroke: props.stroke,
	    strokeWidth: props.stroke_width * 2,
	    strokeDasharray: props.dash_array ? props.dash_array : void 0,
	    d: bubblemouth_path,
	    style: props.style || {}
	  }));
	};


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var CHUNK_SIZE, DEVELOPMENT_LANGUAGE, IN_SITU_TRANSLATOR, TranslationsDash, TranslationsForLang, deleteTranslationString, draw_translation_metadata, editable_translation, log_translation_count, promote_temporary_translations, regexp_tmatch, regexp_tsplit, rejectProposals, submitTranslationProposalsInChunks, translation_cache, translation_logging_in_progress, translation_uses, translation_uses_last_written_at, translation_uses_write_after, translations_loaded, try_submit_translations, updateTranslations,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	__webpack_require__(2);
	
	window.translation_progress = function(lang, key_prefix) {
	  var dev_language, k, proposed_translations, target_lang, translated, v;
	  key_prefix || (key_prefix = '/translations');
	  proposed_translations = fetch("/proposed_translations/" + lang + (key_prefix.replace('/translations', '')));
	  dev_language = fetch(key_prefix + "/en");
	  target_lang = fetch(key_prefix + "/" + lang);
	  translated = (function() {
	    var results;
	    results = [];
	    for (k in dev_language) {
	      v = dev_language[k];
	      if (target_lang[k] || proposed_translations[k]) {
	        results.push(k);
	      }
	    }
	    return results;
	  })();
	  return translated.length / (Object.keys(dev_language).length - 1);
	};
	
	regexp_tsplit = /<(\w+)>[^<]+<\/[\w|\s]+>/g;
	
	regexp_tmatch = /<(\w+)>([^<]+)<\/[\w|\s]+>/g;
	
	window.TRANSLATE = function(args, native_text) {
	  var def, j, lang_used, len, match, matches, message, part, parts, props, ref, target_lang, tr, translation, translations;
	  if (typeof args === "string") {
	    if (native_text) {
	      args = {
	        id: args
	      };
	    } else {
	      native_text = args;
	      args = {};
	    }
	  }
	  tr = fetch('translations');
	  args.return_lang_used = true;
	  if (args.key) {
	    console.trace();
	  }
	  ref = translator(args, native_text), message = ref.message, lang_used = ref.lang_used, target_lang = ref.target_lang;
	  if (!message) {
	    return native_text;
	  }
	  if (message.indexOf('<') > -1) {
	    parts = message.split(regexp_tsplit);
	    matches = {};
	    while (match = regexp_tmatch.exec(message)) {
	      matches[match[1]] = match[2];
	    }
	    translation = [];
	    for (j = 0, len = parts.length; j < len; j++) {
	      part = parts[j];
	      if (part in matches && part in args) {
	        def = args[part];
	        if (def.render != null) {
	          translation.push(def.render());
	        } else if (args.as_html) {
	          translation.push("<" + def.component + " " + def.args + ">" + matches[part] + "</" + def.component + ">");
	        } else {
	          translation.push(def.component(def.args, matches[part]));
	        }
	      } else {
	        translation.push(part);
	      }
	    }
	  } else {
	    translation = message;
	  }
	  if (!tr.in_situ_translations) {
	    return translation;
	  } else {
	    translations = fetch("/translations/" + target_lang);
	    props = _.extend({
	      lang_used: lang_used,
	      target_lang: target_lang,
	      message: message,
	      native_text: native_text
	    }, args);
	    props.translation_key = props.key;
	    return IN_SITU_TRANSLATOR(props, translation);
	  }
	};
	
	IN_SITU_TRANSLATOR = ReactiveComponent({
	  displayName: 'InSituTranslator',
	  render: function() {
	    var available_languages, id, key, message_style, proposed_translations, subdomain, subdomain_id, target_lang, translated, updated_translations;
	    key = this.props.translation_key || '/translations';
	    target_lang = this.props.target_lang;
	    translated = this.props.lang_used === target_lang;
	    id = this.props.id || this.props.native_text;
	    return SPAN({
	      style: {
	        backgroundColor: translated ? "rgba(166, 195, 151, .5)" : "rgba(251,124,124,.5)",
	        position: 'relative'
	      },
	      onMouseOver: (function(_this) {
	        return function() {
	          if (!_this.local.show_translator) {
	            _this.local.show_translator = true;
	            return save(_this.local);
	          }
	        };
	      })(this)
	    }, this.props.children, this.local.show_translator ? (available_languages = fetch('/supported_languages').available_languages, this.props.local ? (subdomain = fetch('/subdomain'), updated_translations = fetch("local_translations/" + target_lang + "/" + subdomain.name), proposed_translations = fetch("/proposed_translations/" + target_lang + "/" + subdomain.name), subdomain_id = subdomain.id) : (updated_translations = fetch("local_translations/" + target_lang), proposed_translations = fetch("/proposed_translations/" + target_lang), subdomain_id = null), message_style = {
	      fontWeight: 700
	    }, DIV({
	      style: {
	        position: 'absolute',
	        zIndex: 9999,
	        fontSize: 14,
	        width: 300,
	        padding: '4px 8px',
	        backgroundColor: 'white',
	        border: "1px solid #ccc"
	      },
	      onClick: (function(_this) {
	        return function(e) {
	          e.stopPropagation();
	          return e.preventDefault();
	        };
	      })(this)
	    }, DIV({
	      style: {}
	    }, "English message: ", DIV({
	      style: message_style
	    }, "" + this.props.native_text)), DIV({
	      style: {
	        marginTop: 8
	      }
	    }, LABEL(null, available_languages[target_lang] + " translation:"), editable_translation(id, target_lang, subdomain_id, updated_translations, proposed_translations.proposals[id], message_style)), BUTTON({
	      className: "btn",
	      style: {
	        fontSize: 14
	      },
	      onClick: (function(_this) {
	        return function() {
	          promote_temporary_translations(updated_translations.key);
	          _this.local.show_translator = false;
	          return save(_this.local);
	        };
	      })(this)
	    }, "Save"), BUTTON({
	      style: {
	        backgroundColor: 'none',
	        border: 'none',
	        color: '#888'
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.show_translator = false;
	          return save(_this.local);
	        };
	      })(this)
	    }, "Cancel"))) : void 0);
	  }
	});
	
	DEVELOPMENT_LANGUAGE = 'en';
	
	translation_cache = {};
	
	translations_loaded = false;
	
	window.T = window.t = function(args, native_text) {
	  console.trace();
	  console.warn("Deprecated: calling window.t or window.T should be replaced with window.translator");
	  return translator(args, native_text);
	};
	
	window.translator = function(args, native_text) {
	  var cache_key, e, id, j, lang, lang_used, langs, len, message, subdomain, translations, translations_key_prefix, translations_native, translator, user;
	  if (translations_loaded) {
	    cache_key = JSON.stringify(args, native_text);
	    if (cache_key in translation_cache) {
	      if (typeof args === "string") {
	        if (native_text) {
	          args = {
	            id: args
	          };
	        } else {
	          native_text = args;
	          args = {};
	        }
	      }
	      id = args.id || native_text;
	      log_translation_count(id);
	      return translation_cache[cache_key];
	    }
	  }
	  if (args.key) {
	    console.trace();
	  }
	  subdomain = fetch('/subdomain');
	  if (args.local && !subdomain.name) {
	    return '...';
	  }
	  if (args.local) {
	    translations_key_prefix = "/translations/" + subdomain.name;
	  } else {
	    translations_key_prefix = "/translations";
	  }
	  translations_native = fetch(translations_key_prefix + "/" + DEVELOPMENT_LANGUAGE);
	  if (waiting_for(translations_native)) {
	    return '...';
	  }
	  translations_loaded || (translations_loaded = true);
	  if (cache_key == null) {
	    cache_key = JSON.stringify(args, native_text);
	  }
	  if (typeof args === "string") {
	    if (native_text) {
	      args = {
	        id: args
	      };
	    } else {
	      native_text = args;
	      args = {};
	    }
	  }
	  id = args.id || native_text;
	  native_text = native_text.replace(/\n/g, "");
	  if (translations_native[id] !== native_text) {
	    console.log('updating', {
	      args: args,
	      key: translations_native.key,
	      id: id,
	      native_text: native_text,
	      saved: translations_native[id]
	    }, translations_native[id] === native_text);
	    translations_native[id] = native_text;
	    setTimeout(function() {
	      var proposed_update;
	      proposed_update = {
	        string_id: id,
	        lang_code: DEVELOPMENT_LANGUAGE,
	        subdomain_id: args.local ? subdomain.id : null,
	        translation: native_text
	      };
	      return updateTranslations([proposed_update]);
	    }, 1000);
	  }
	  user = {};
	  langs = [user.lang, subdomain.lang, DEVELOPMENT_LANGUAGE].filter(function(l) {
	    return l != null;
	  });
	  if (langs.length > 1) {
	    langs = Array.from(new Set(langs));
	  }
	  lang_used = null;
	  message = null;
	  for (j = 0, len = langs.length; j < len; j++) {
	    lang = langs[j];
	    translations = fetch(translations_key_prefix + "/" + lang);
	    if (translations[id] != null) {
	      message = translations[id];
	      if (message) {
	        lang_used = lang;
	        break;
	      }
	    }
	  }
	  try {
	    translator = new IntlMessageFormat.IntlMessageFormat(message, lang_used);
	    message = translator.format(args);
	  } catch (error) {
	    e = error;
	    console.error("Error translating " + id, {
	      error: e,
	      message: message,
	      native_text: native_text
	    });
	    message = translations_native[id];
	  }
	  if (args.return_lang_used) {
	    translation_cache[cache_key] = {
	      message: message,
	      lang_used: lang_used,
	      target_lang: fetch('translations').translating_lang || langs[0]
	    };
	  } else {
	    translation_cache[cache_key] = message;
	  }
	  log_translation_count(id);
	  return translation_cache[cache_key];
	};
	
	translation_uses = {};
	
	log_translation_count = function(string_id) {
	  var ref;
	  if (((ref = window.navigator.userAgent) != null ? ref.indexOf('Prerender') : void 0) > -1) {
	    return;
	  }
	  return translation_uses[string_id] = 1;
	};
	
	translation_uses_write_after = 1000 * 60;
	
	translation_uses_last_written_at = Date.now() - translation_uses_write_after * .95;
	
	translation_logging_in_progress = false;
	
	try_submit_translations = function() {
	  var frm, xhr;
	  frm = new FormData();
	  frm.append("authenticity_token", arest.csrf());
	  frm.append("counts", JSON.stringify(translation_uses));
	  translation_logging_in_progress = true;
	  xhr = new XMLHttpRequest;
	  xhr.addEventListener('readystatechange', function(evt) {
	    if (xhr.readyState >= 3) {
	      if (xhr.status === 200) {
	        translation_uses = {};
	        translation_uses_last_written_at = Date.now();
	        return translation_logging_in_progress = false;
	      } else if (xhr.status === 422) {
	        return arest.serverFetch('/current_user', function() {
	          return setTimeout(function() {
	            return translation_logging_in_progress = false;
	          }, 1000);
	        });
	      } else {
	        return translation_logging_in_progress = false;
	      }
	    }
	  }, false);
	  xhr.open('PUT', '/log_translation_counts', true);
	  return xhr.send(frm);
	};
	
	setInterval(function() {
	  var logging_due;
	  logging_due = Object.keys(translation_uses).length > 0 && Date.now() - translation_uses_last_written_at >= translation_uses_write_after;
	  if (logging_due && !translation_logging_in_progress && Object.keys(arest.pending_saves).length === 0 && Object.keys(arest.outstanding_fetches).length === 0) {
	    return try_submit_translations();
	  }
	}, 200);
	
	styles += ".translation_filters {\n  margin-top: 48px;\n}\n\n.translation_filters button {\n  background-color: #eaeaea;\n  border: none;\n  border-radius: 8px;\n  margin: 0 8px;\n}\n\n.translation_filters button.active {\n  background-color: " + focus_blue + ";\n  color: white;\n}\n";
	
	TranslationsDash = ReactiveComponent({
	  displayName: 'TranslationsDash',
	  render: function() {
	    var all_langs, current_user, filter, filters, k, local, subdomain, translations, v;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    translations = fetch('/supported_languages');
	    if (!translations.available_languages) {
	      return DIV();
	    }
	    local = fetch('translations');
	    if (local.filters == null) {
	      local.filters = [];
	    }
	    all_langs = (function() {
	      var ref, results;
	      ref = translations.available_languages;
	      results = [];
	      for (k in ref) {
	        v = ref[k];
	        if (k !== DEVELOPMENT_LANGUAGE) {
	          results.push([k, v]);
	        }
	      }
	      return results;
	    })();
	    if (current_user.is_super_admin) {
	      all_langs.push(['pseudo-en', "Pseudo English (for testing)"]);
	    }
	    if (!local.translating_lang) {
	      if (subdomain.lang && subdomain.lang !== 'en') {
	        local.translating_lang = subdomain.lang;
	      } else {
	        local.translating_lang = all_langs[0][0];
	      }
	    }
	    return DIV(null, DIV({
	      style: {}
	    }, "Consider.it's native development language is English (en). Please help us translate it to your language!"), DIV({
	      style: {
	        marginTop: 24
	      }
	    }, "Which language do you wish to translate for?", SELECT({
	      value: local.translating_lang || subdomain.lang || 'en',
	      style: {
	        fontSize: 20,
	        marginLeft: 14,
	        display: 'inline-block'
	      },
	      onChange: (function(_this) {
	        return function(ev) {
	          local.translating_lang = ev.target.value;
	          return save(local);
	        };
	      })(this)
	    }, (function() {
	      var j, len, ref, results;
	      results = [];
	      for (j = 0, len = all_langs.length; j < len; j++) {
	        ref = all_langs[j], k = ref[0], v = ref[1];
	        results.push(OPTION({
	          key: k + "-" + v,
	          value: k
	        }, v + " (" + k + ")"));
	      }
	      return results;
	    })()), DIV({
	      style: {
	        fontSize: 12
	      }
	    }, "Is your language not available? Email us at hello@consider.it to get your language added.")), current_user.is_super_admin ? DIV({
	      style: {
	        marginTop: 24
	      }
	    }, LABEL({
	      htmlFor: 'insitutranslations'
	    }, "Enable in-situ translations?"), INPUT({
	      id: 'insitutranslations',
	      type: 'checkbox',
	      checked: fetch('translations').in_situ_translations,
	      style: {
	        fontSize: 36
	      },
	      onChange: (function(_this) {
	        return function() {
	          var tr;
	          tr = fetch('translations');
	          tr.in_situ_translations = !tr.in_situ_translations;
	          return save(tr);
	        };
	      })(this)
	    }), DIV({
	      style: {
	        fontSize: 12
	      }
	    }, "In-situ mode lets you browse the rest of the site and add some translations in context.")) : void 0, current_user.is_super_admin ? DIV({
	      style: {
	        marginTop: 24
	      }
	    }, "Add a new language", DIV(null, INPUT({
	      style: {
	        fontSize: 18
	      },
	      type: 'text',
	      ref: 'newlang_abbrev',
	      placeholder: 'Abbreviation'
	    }), INPUT({
	      type: 'text',
	      ref: 'newlang_label',
	      placeholder: 'Full Name',
	      style: {
	        margin: '0 8px',
	        fontSize: 18
	      }
	    }), BUTTON({
	      onClick: (function(_this) {
	        return function() {
	          var abbrev, label;
	          abbrev = _this.refs.newlang_abbrev.value;
	          label = _this.refs.newlang_label.value;
	          if (!(abbrev in translations.available_languages)) {
	            translations.available_languages[abbrev] = label;
	            save(translations);
	            _this.refs.newlang_abbrev.value = "";
	            return _this.refs.newlang_label.value = "";
	          }
	        };
	      })(this)
	    }, "Add"))) : void 0, local.translating_lang ? (filters = ['Untranslated', 'Not translated by you', 'High use', 'Medium use', 'Low use', 'Rarely used'], current_user.is_super_admin ? filters.push('Under review') : void 0, DIV(null, DIV({
	      className: 'translation_filters'
	    }, LABEL(null, "Filter translations to:"), (function() {
	      var j, len, results;
	      results = [];
	      for (j = 0, len = filters.length; j < len; j++) {
	        filter = filters[j];
	        results.push((function(_this) {
	          return function(filter) {
	            return BUTTON({
	              key: filter,
	              className: indexOf.call(local.filters, filter) >= 0 ? 'active' : void 0,
	              onClick: function() {
	                if (indexOf.call(local.filters, filter) >= 0) {
	                  local.filters.splice(local.filters.indexOf(filter), 1);
	                } else {
	                  local.filters.push(filter);
	                }
	                return save(local);
	              }
	            }, filter);
	          };
	        })(this)(filter));
	      }
	      return results;
	    }).call(this)), TranslationsForLang({
	      key: "translations_for_" + local.translating_lang,
	      lang: local.translating_lang,
	      filtered_users: local.filters
	    }), TranslationsForLang({
	      key: "forum_translations_for_" + local.translating_lang,
	      lang: local.translating_lang,
	      forum_specific: true,
	      filters: local.filters
	    }), DIV({
	      style: {
	        position: 'fixed',
	        bottom: 0,
	        left: 0,
	        width: WINDOW_WIDTH(),
	        zIndex: 999,
	        backgroundColor: 'rgba(220,220,220,.8)',
	        textAlign: 'center',
	        padding: '8px'
	      }
	    }, BUTTON({
	      className: 'btn',
	      onClick: (function(_this) {
	        return function() {
	          promote_temporary_translations("local_translations/" + local.translating_lang);
	          return promote_temporary_translations("local_translations/" + local.translating_lang + "/" + subdomain.name);
	        };
	      })(this)
	    }, "Save Changes"), fetch('translations_interface').saved_successfully ? DIV({
	      style: {
	        color: 'green',
	        marginTop: 10
	      }
	    }, "Successfully saved") : void 0))) : void 0);
	  }
	});
	
	TranslationsForLang = ReactiveComponent({
	  displayName: 'TranslationsForLang',
	  render: function() {
	    var all_uses, available_languages, col, cols, could_not_find, current_user, has_use_filter, idx, j, k, lang, len, local, name, name1, names, native_messages, native_messages_with_count, passes_use_range, percentRank, percentiles, proposed_translations, rank, ref, ref1, ref2, ref3, rows, section, sections, sp, subdomain, subdomain_id, to_translate, trans, translation, translation_key_prefix, updated_translations, uses, v;
	    lang = this.props.lang;
	    subdomain = fetch('/subdomain');
	    if (this.props.forum_specific) {
	      translation_key_prefix = "/translations/" + subdomain.name;
	      proposed_translations = fetch("/proposed_translations/" + lang + "/" + subdomain.name);
	      subdomain_id = subdomain.id;
	      updated_translations = fetch("local_translations/" + lang + "/" + subdomain.name);
	    } else {
	      translation_key_prefix = "/translations";
	      proposed_translations = fetch("/proposed_translations/" + lang);
	      subdomain_id = null;
	      updated_translations = fetch("local_translations/" + lang);
	    }
	    available_languages = fetch("/supported_languages").available_languages;
	    native_messages = fetch(translation_key_prefix + "/" + DEVELOPMENT_LANGUAGE);
	    native_messages_with_count = fetch("/proposed_translations/" + DEVELOPMENT_LANGUAGE);
	    if (waiting_for(native_messages) || waiting_for(proposed_translations) || waiting_for(native_messages_with_count)) {
	      return DIV();
	    }
	    to_translate = (function() {
	      var results;
	      results = [];
	      for (k in native_messages) {
	        v = native_messages[k];
	        if (k !== 'key') {
	          results.push(k);
	        }
	      }
	      return results;
	    })();
	    if (to_translate.length === 0) {
	      return DIV();
	    }
	    sections = {};
	    could_not_find = {};
	    if (!this.props.forum_specific) {
	      percentRank = function(array, n) {
	        var L, N, S, aa, i, j, len;
	        L = 0;
	        S = 0;
	        N = array.length;
	        for (i = j = 0, len = array.length; j < len; i = ++j) {
	          aa = array[i];
	          if (array[i] < n) {
	            L += 1;
	          } else if (array[i] === n) {
	            S += 1;
	          }
	        }
	        return (L + (0.5 * S)) / N;
	      };
	      percentiles = {};
	      uses = [];
	      ref = native_messages_with_count.proposals;
	      for (name in ref) {
	        trans = ref[name];
	        if (name === 'key') {
	          continue;
	        }
	        if (trans.accepted.uses_this_period + trans.accepted.uses_last_period > 0) {
	          uses.push(trans.accepted.uses_this_period + trans.accepted.uses_last_period);
	        }
	      }
	      all_uses = uses.sort(function(a, b) {
	        return a - b;
	      });
	      ref1 = native_messages_with_count.proposals;
	      for (name in ref1) {
	        trans = ref1[name];
	        if (name === 'key') {
	          continue;
	        }
	        uses = trans.accepted.uses_this_period + trans.accepted.uses_last_period;
	        if (uses === 0) {
	          rank = -1;
	        } else {
	          rank = percentRank(all_uses, uses) * 100;
	        }
	        percentiles[name] = rank;
	      }
	    }
	    local = fetch('translations');
	    for (j = 0, len = to_translate.length; j < len; j++) {
	      name = to_translate[j];
	      if (((ref2 = local.filters) != null ? ref2.length : void 0) > 0) {
	        translation = proposed_translations.proposals[name];
	        if (indexOf.call(local.filters, 'Untranslated') >= 0 && !!translation) {
	          continue;
	        }
	        if (indexOf.call(local.filters, 'Not translated by you') >= 0 && !!(translation != null ? translation.yours : void 0)) {
	          continue;
	        }
	        if (indexOf.call(local.filters, 'Under review') >= 0 && !(translation != null ? (ref3 = translation.proposals) != null ? ref3.length : void 0 : void 0) > 0) {
	          continue;
	        }
	        if (!this.props.forum_specific) {
	          passes_use_range = false;
	          has_use_filter = false;
	          if (indexOf.call(local.filters, 'High use') >= 0) {
	            has_use_filter = true;
	            passes_use_range || (passes_use_range = percentiles[name] >= 75);
	          }
	          if (indexOf.call(local.filters, 'Medium use') >= 0) {
	            has_use_filter = true;
	            passes_use_range || (passes_use_range = percentiles[name] >= 25 && percentiles[name] < 75);
	          }
	          if (indexOf.call(local.filters, 'Low use') >= 0) {
	            has_use_filter = true;
	            passes_use_range || (passes_use_range = percentiles[name] >= 0 && percentiles[name] < 25);
	          }
	          if (indexOf.call(local.filters, 'Rarely used') >= 0) {
	            has_use_filter = true;
	            passes_use_range || (passes_use_range = percentiles[name] === -1);
	          }
	          if (!passes_use_range && has_use_filter) {
	            continue;
	          }
	        }
	      }
	      sp = name.split('.');
	      if (sp.length > 1) {
	        sections[name1 = sp[0]] || (sections[name1] = []);
	        sections[sp[0]].push(name);
	      } else {
	        sections.misc || (sections.misc = []);
	        sections.misc.push(name);
	      }
	    }
	    current_user = fetch('/current_user');
	    if (this.props.forum_specific) {
	      cols = ['Message', "Translation. Leave blank if Message already " + available_languages[lang]];
	    } else {
	      cols = ['Message in English', "Translation to " + available_languages[lang]];
	    }
	    return DIV({
	      style: {
	        marginTop: 36
	      }
	    }, H2({
	      style: {
	        fontSize: 22,
	        marginBottom: 12
	      }
	    }, TRANSLATE({
	      id: "translations.language_header",
	      percent_complete: Math.round(translation_progress(lang, translation_key_prefix) * 100),
	      language: available_languages[lang]
	    }, "Translations for {language} ({percent_complete}% completed)")), current_user.is_super_admin ? DIV(null, BUTTON({
	      onClick: (function(_this) {
	        return function() {
	          var candidates, id, latest, len1, m, proposal, proposals, props, ref4, ref5, ref6, ref7, to_accept;
	          proposals = [];
	          ref4 = proposed_translations.proposals;
	          for (id in ref4) {
	            props = ref4[id];
	            if (((ref5 = props.proposals) != null ? ref5.length : void 0) > 0) {
	              latest = null;
	              to_accept = null;
	              candidates = props.proposals.slice();
	              if (props.accepted) {
	                candidates.push(props.accepted);
	              }
	              for (m = 0, len1 = candidates.length; m < len1; m++) {
	                proposal = candidates[m];
	                if (!latest || proposal.created_at > latest) {
	                  latest = proposal.created_at;
	                  to_accept = proposal;
	                }
	              }
	              if (!to_accept.accepted) {
	                console.log("Promoting", to_accept.id, " over ", (ref6 = props.accepted) != null ? ref6.id : void 0, "(" + proposal.created_at + " over " + ((ref7 = props.accepted) != null ? ref7.created_at : void 0));
	                to_accept['accepted'] = true;
	                proposals.push(to_accept);
	              }
	            }
	          }
	          if (proposals.length > 0) {
	            return updateTranslations(proposals);
	          }
	        };
	      })(this)
	    }, "Accept latest proposed translations"), BUTTON({
	      onClick: (function(_this) {
	        return function() {
	          var id, len1, m, proposal, proposals, props, ref4, ref5, ref6;
	          proposals = [];
	          ref4 = proposed_translations.proposals;
	          for (id in ref4) {
	            props = ref4[id];
	            if (((ref5 = props.proposals) != null ? ref5.length : void 0) > 0) {
	              ref6 = props.proposals;
	              for (m = 0, len1 = ref6.length; m < len1; m++) {
	                proposal = ref6[m];
	                if (proposal.accepted || (proposed_translations.accepted && proposal.translation === proposed_translations.accepted.translation)) {
	                  continue;
	                }
	                console.log("Proposed to delete:", proposal);
	                proposals.push(proposal);
	              }
	            }
	          }
	          if (proposals.length > 0) {
	            return rejectProposals(proposals);
	          }
	        };
	      })(this)
	    }, "Clear proposals"), BUTTON({
	      onClick: (function(_this) {
	        return function() {
	          var id, proposals, props, ref4;
	          proposals = [];
	          ref4 = proposed_translations.proposals;
	          for (id in ref4) {
	            props = ref4[id];
	            if (props.accepted) {
	              proposals.push(props.accepted);
	            }
	          }
	          if (proposals.length > 0) {
	            return updateTranslations(proposals);
	          }
	        };
	      })(this)
	    }, "Propagate accepted")) : void 0, TABLE({
	      style: {
	        width: HOMEPAGE_WIDTH()
	      }
	    }, TBODY(null, (function() {
	      var fn, len1, m, results;
	      results = [];
	      for (section in sections) {
	        names = sections[section];
	        if (names.length === 0) {
	          continue;
	        }
	        names.sort();
	        rows = [];
	        rows.push(TR({
	          key: 'preamble'
	        }, TD({
	          colSpan: cols.length,
	          style: {
	            fontSize: 24,
	            paddingTop: 12
	          }
	        }, section.toUpperCase().replace(/\_/g, ' '), DIV({
	          style: {
	            fontSize: 12,
	            marginBottom: 8
	          }
	        }, "Translation strings support ICU format for e.g. pluralization. For complicated translations, you may wish to ", A({
	          href: "http://format-message.github.io/icu-message-format-for-translators/editor.html",
	          target: '_blank',
	          style: {
	            textDecoration: 'underline'
	          }
	        }, "use this helper"), "."))));
	        rows.push(TR({
	          key: 'header',
	          style: {
	            backgroundColor: '#dfdfdf'
	          }
	        }, (function() {
	          var len1, m, results1;
	          results1 = [];
	          for (m = 0, len1 = cols.length; m < len1; m++) {
	            col = cols[m];
	            results1.push(TH({
	              key: col,
	              style: {
	                textAlign: 'left',
	                padding: "4px 6px"
	              }
	            }, col));
	          }
	          return results1;
	        })()));
	        fn = (function(_this) {
	          return function(name, idx) {
	            var no_id, percentile, proposal, proposals, ref4, use_color, use_label;
	            no_id = name === native_messages[name];
	            if (!_this.props.forum_specific) {
	              percentile = percentiles[name];
	              if (percentile >= 75) {
	                use_color = 'red';
	                use_label = 'high use';
	              } else if (percentile >= 25) {
	                use_color = 'orange';
	                use_label = 'medium use';
	              } else if (percentile >= 0) {
	                use_color = 'green';
	                use_label = 'low use';
	              } else {
	                use_color = 'blue';
	                use_label = 'rarely used';
	              }
	            }
	            return rows.push(TR({
	              key: "row-id-" + name,
	              style: {
	                backgroundColor: idx % 2 === 1 ? '#f8f8f8' : void 0
	              }
	            }, TD({
	              style: {
	                padding: "2px 4px",
	                width: "40%"
	              }
	            }, DIV({
	              ref: "message-" + name + "-" + idx,
	              title: no_id ? 'no ID' : name
	            }, "" + native_messages[name], !_this.props.forum_specific ? SPAN({
	              style: {
	                color: use_color,
	                fontSize: 12,
	                paddingLeft: 12
	              }
	            }, use_label) : void 0)), TD({
	              style: {
	                width: '58%',
	                padding: "2px 4px",
	                position: 'relative'
	              }
	            }, DIV({
	              style: {
	                position: 'relative'
	              }
	            }, editable_translation(name, lang, subdomain_id, updated_translations, proposed_translations.proposals[name]), current_user.is_super_admin ? (function(name) {
	              return BUTTON({
	                style: {
	                  fontSize: 14,
	                  backgroundColor: 'transparent',
	                  border: 'none',
	                  color: '#ccc',
	                  position: 'absolute',
	                  right: -25,
	                  padding: '4px',
	                  top: 'calc(50% - 14px)'
	                },
	                onClick: function() {
	                  deleteTranslationString(name);
	                  delete native_messages[name];
	                  return delete updated_translations[name];
	                }
	              }, "x");
	            })(name) : void 0), current_user.is_super_admin && ((ref4 = proposed_translations.proposals[name]) != null ? ref4.proposals.length : void 0) > 0 ? (proposals = proposed_translations.proposals[name].proposals, proposed_translations.proposals[name].accepted ? proposals.unshift(proposed_translations.proposals[name].accepted) : void 0, UL({
	              style: {}
	            }, (function() {
	              var len2, o, results1;
	              results1 = [];
	              for (idx = o = 0, len2 = proposals.length; o < len2; idx = ++o) {
	                proposal = proposals[idx];
	                results1.push((function(_this) {
	                  return function(proposal, name, idx) {
	                    return LI({
	                      key: name + "-" + proposal.translation + "-" + proposal.id,
	                      style: {
	                        padding: "2px 0px 8px 0px",
	                        listStyle: 'none'
	                      }
	                    }, DIV({
	                      style: {
	                        color: proposal.accepted ? 'darkgreen' : void 0
	                      }
	                    }, proposal.translation), draw_translation_metadata(proposal), !proposal.accepted ? DIV(null, BUTTON({
	                      style: {
	                        borderRadius: 8
	                      },
	                      onClick: function() {
	                        proposal.accepted = true;
	                        return updateTranslations([proposal]);
	                      }
	                    }, "Ok"), BUTTON({
	                      style: {
	                        backgroundColor: 'transparent',
	                        display: 'inline-block',
	                        marginLeft: 20,
	                        border: 'none',
	                        color: '#999',
	                        textDecoration: 'underline',
	                        fontSize: 14
	                      },
	                      onClick: function() {
	                        return rejectProposals(name, [proposal]);
	                      }
	                    }, "reject")) : void 0);
	                  };
	                })(this)(proposal, name, idx));
	              }
	              return results1;
	            }).call(_this))) : void 0)));
	          };
	        })(this);
	        for (idx = m = 0, len1 = names.length; m < len1; idx = ++m) {
	          name = names[idx];
	          fn(name, idx);
	        }
	        results.push(rows);
	      }
	      return results;
	    }).call(this))));
	  }
	});
	
	draw_translation_metadata = function(proposal) {
	  var proposer;
	  if (proposal.user_id) {
	    proposer = fetch("/user/" + proposal.user_id);
	  } else {
	    proposer = fetch('/current_user');
	  }
	  return SPAN({
	    style: {
	      fontSize: 14,
	      color: "#aaa",
	      paddingRight: 4
	    }
	  }, proposal.origin_server + " - " + (proposer.name || proposer.user || proposal.user_id) + " " + (prettyDate(proposal.created_at)));
	};
	
	CHUNK_SIZE = 15;
	
	submitTranslationProposalsInChunks = function(proposals, http_method, endpoint, cb) {
	  var chunk_id, next_chunk, submit_form;
	  submit_form = function(chunk_o_proposals) {
	    var frm, xhr;
	    if (!((chunk_o_proposals != null ? chunk_o_proposals.length : void 0) > 0)) {
	      if (typeof cb === "function") {
	        cb();
	      }
	      return;
	    }
	    frm = new FormData();
	    frm.append("authenticity_token", arest.csrf());
	    frm.append("proposals", JSON.stringify(chunk_o_proposals));
	    xhr = new XMLHttpRequest;
	    xhr.addEventListener('readystatechange', null, false);
	    xhr.open(http_method, endpoint, true);
	    xhr.onload = function() {
	      var next_proposals, result;
	      result = JSON.parse(xhr.responseText);
	      arest.update_cache(result);
	      next_proposals = next_chunk();
	      console.log("SUBMITTING", next_proposals);
	      return submit_form(next_proposals);
	    };
	    return xhr.send(frm);
	  };
	  chunk_id = 0;
	  next_chunk = function() {
	    chunk_id += 1;
	    return proposals.slice((chunk_id - 1) * CHUNK_SIZE, chunk_id * CHUNK_SIZE);
	  };
	  return submit_form(next_chunk());
	};
	
	updateTranslations = function(proposals, cb) {
	  var ref;
	  if (((ref = window.navigator.userAgent) != null ? ref.indexOf('Prerender') : void 0) > -1) {
	    return;
	  }
	  return submitTranslationProposalsInChunks(proposals, 'PUT', '/translations', function() {
	    translation_cache = {};
	    return typeof cb === "function" ? cb() : void 0;
	  });
	};
	
	rejectProposals = function(proposals) {
	  return submitTranslationProposalsInChunks(proposals, 'DELETE', '/translation_proposal');
	};
	
	deleteTranslationString = function(string_id) {
	  var frm, xhr;
	  frm = new FormData();
	  frm.append("authenticity_token", arest.csrf());
	  frm.append("string_id", string_id);
	  xhr = new XMLHttpRequest;
	  xhr.addEventListener('readystatechange', null, false);
	  xhr.open('DELETE', '/translations', true);
	  xhr.onload = function() {
	    var result;
	    result = JSON.parse(xhr.responseText);
	    return arest.update_cache(result);
	  };
	  return xhr.send(frm);
	};
	
	editable_translation = function(id, lang_code, subdomain_id, updated_translations, proposed_translations, style) {
	  var accepted, current_user, proposal, proposed, ref, val;
	  current_user = fetch('/current_user');
	  accepted = proposed = val = proposal = null;
	  if (proposed_translations) {
	    if (proposed_translations.accepted) {
	      accepted = val = proposed_translations.accepted.translation;
	      proposal = proposed_translations.accepted;
	    }
	    if (proposed_translations.yours) {
	      proposed = val = proposed_translations.yours.translation;
	      proposal = proposed_translations.yours;
	    }
	  }
	  return SPAN({
	    key: id + "-" + accepted + "-" + proposed
	  }, accepted && proposed && accepted.user_id !== proposed.user_id ? DIV(null, DIV({
	    style: {
	      fontStyle: 'italic',
	      fontSize: 14
	    }
	  }, "Current translation:"), accepted, DIV({
	    style: {
	      fontStyle: 'italic',
	      marginTop: 12,
	      fontSize: 14
	    }
	  }, "Your proposed translation:")) : void 0, AutoGrowTextArea({
	    defaultValue: ((ref = updated_translations[id]) != null ? ref.translation : void 0) || val,
	    style: _.defaults(style || {}, {
	      verticalAlign: 'top',
	      fontSize: 'inherit',
	      width: '100%',
	      borderColor: '#ddd'
	    }),
	    onChange: function(e) {
	      var trans;
	      trans = e.target.value;
	      if (!updated_translations[id]) {
	        return updated_translations[id] = {
	          string_id: id,
	          lang_code: lang_code,
	          subdomain_id: subdomain_id,
	          translation: e.target.value
	        };
	      } else {
	        return updated_translations[id].translation = e.target.value;
	      }
	    }
	  }));
	};
	
	promote_temporary_translations = function(key) {
	  var k, proposals, updated_translations, v;
	  updated_translations = fetch(key);
	  proposals = [];
	  for (k in updated_translations) {
	    v = updated_translations[k];
	    if (k === 'key') {
	      continue;
	    }
	    proposals.push(v);
	  }
	  if (proposals.length === 0) {
	    return;
	  }
	  return updateTranslations(proposals, function() {
	    var trans_UI;
	    for (k in updated_translations) {
	      v = updated_translations[k];
	      if (k !== 'key') {
	        delete updated_translations[k];
	      }
	    }
	    save(updated_translations);
	    trans_UI = fetch('translations_interface');
	    trans_UI.saved_successfully = true;
	    save(trans_UI);
	    return _.delay(function() {
	      trans_UI.saved_successfully = false;
	      return save(trans_UI);
	    }, 4000);
	  });
	};
	
	window.TranslationsDash = TranslationsDash;


/***/ },
/* 9 */
/***/ function(module, exports) {

	window.styles += "#lightbox {\n  position: fixed;\n  top: 0;\n  left: 0;\n  background: rgba(0,0,0,.6);\n\n  \n  width: 100vw;\n  height: 100vh;\n  z-index: 99999;\n}\n\n#modal-wrapper {\n  margin: 0 auto;\n  position: relative;\n  z-index: 0;\n  padding: 3em 0;\n}\n\n#modal-body {\n  padding: 2.5em 125px 3.5em 125px;\n  font-size: 16px;\n  box-shadow: 0 2px 4px rgba(0,0,0,.4), 0 0 100px rgb(255 255 255 / 40%);\n  background-color: white; /* #f1f1f1; */\n  position: relative;\n  border-radius: 16px;\n}\n\n@media (max-width: 700px) {\n  #modal-body {\n    padding: 2.5em 42px 3.5em 42px;\n  }\n}\n";
	
	window.Modal = {
	  accessibility_on_keydown: function(e) {
	    var is_tab_pressed, ref;
	    if (e.key === 'Escape' || e.keyCode === 27) {
	      if (this.refs.cancel_dialog) {
	        if ((ref = ReactDOM.findDOMNode(this.refs.cancel_dialog)) != null) {
	          ref.click();
	        }
	      }
	    }
	    is_tab_pressed = e.key === 'Tab' || e.keyCode === 9;
	    if (!is_tab_pressed) {
	      return;
	    }
	    if (e.shiftKey) {
	      if (document.activeElement === this.first_focusable_element) {
	        this.last_focusable_element.focus();
	        e.preventDefault();
	      }
	    } else {
	      if (document.activeElement === this.last_focusable_element) {
	        this.first_focusable_element.focus();
	        e.preventDefault();
	      }
	    }
	  },
	  UNSAFE_componentWillMount: function() {
	    this.scroll_Y = window.scrollY;
	    return setTimeout((function(_this) {
	      return function() {
	        if (!_this.scroll_Y) {
	          return _this.scroll_Y = window.scrollY;
	        }
	      };
	    })(this));
	  },
	  componentDidMount: function() {
	    return this.componentDidUpdate();
	  },
	  componentDidUpdate: function() {
	    var modal, ref;
	    modal = ((ref = this.refs) != null ? ref.dialog : void 0) || document.querySelector('[role=dialog]');
	    if (!modal || this.mounted) {
	      return;
	    }
	    this.mounted = true;
	    return setTimeout((function(_this) {
	      return function() {
	        var e, focusable_content, focusable_elements, ref1, scroll_bar_width;
	        _this.focused_element_before_opening = document.activeElement;
	        focusable_elements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
	        _this.first_focusable_element = modal.querySelectorAll(focusable_elements)[0];
	        focusable_content = modal.querySelectorAll(focusable_elements);
	        _this.last_focusable_element = focusable_content[focusable_content.length - 1];
	        document.addEventListener('keydown', _this.accessibility_on_keydown);
	        try {
	          if ((ref1 = modal.querySelector('input:not([disabled])')) != null) {
	            ref1.focus();
	          }
	        } catch (error) {
	          e = error;
	          console.error(e);
	        }
	        _.extend(modal.style, {
	          position: 'fixed',
	          top: "0px",
	          left: "0px",
	          width: '100vw',
	          height: '100vh',
	          overflow: 'auto',
	          zIndex: 99999
	        });
	        scroll_bar_width = window.innerWidth - document.body.offsetWidth;
	        return _.extend(document.body.style, {
	          marginRight: scroll_bar_width,
	          overflow: 'hidden',
	          position: 'fixed',
	          top: "-" + _this.scroll_Y + "px",
	          width: '100vw'
	        });
	      };
	    })(this));
	  },
	  componentWillUnmount: function() {
	    if (this.focused_element_before_opening && document.body.contains(this.focused_element_before_opening)) {
	      this.focused_element_before_opening.focus();
	      clear_tooltip();
	    }
	    document.removeEventListener('keydown', this.accessibility_on_keydown);
	    _.extend(document.body.style, {
	      marginRight: null,
	      overflow: null,
	      position: null,
	      top: 0,
	      width: null
	    });
	    return window.scroll(0, this.scroll_Y);
	  }
	};
	
	window.wrap_in_modal = function(width, click_lightbox_callback, children) {
	  return DIV(null, DIV({
	    id: 'lightbox'
	  }), DIV({
	    id: 'modal',
	    ref: 'dialog',
	    role: 'dialog',
	    onClick: click_lightbox_callback ? click_lightbox_callback : void 0
	  }, DIV({
	    id: 'modal-wrapper',
	    style: {
	      maxWidth: width || AUTH_WIDTH()
	    },
	    onClick: click_lightbox_callback ? function(e) {
	      return e.stopPropagation();
	    } : void 0
	  }, DIV({
	    id: 'modal-body'
	  }, children))));
	};


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var DELAY_TO_SHOW_POPOVER, clear_popover, hide_popover, show_popover_from_dom, toggle_popover, zero_popover;
	
	__webpack_require__(1);
	
	zero_popover = function() {
	  var popover;
	  popover = fetch('popover');
	  popover.coords = popover.tip = popover.render = popover.top = popover.positioned = null;
	  popover.offsetY = popover.offsetX = null;
	  popover.rendered_size = false;
	  popover.id = null;
	  popover.hide_triangle = false;
	  popover.size_checked = void 0;
	  return save(popover);
	};
	
	clear_popover = function(immediate, cb) {
	  var id, popover;
	  popover = fetch('popover');
	  if (!popover.id) {
	    return;
	  }
	  if (immediate) {
	    zero_popover();
	    return typeof cb === "function" ? cb() : void 0;
	  } else {
	    id = popover.id;
	    return setTimeout(function() {
	      if (!popover.has_focus && popover.id === id && !popover.element_in_focus) {
	        zero_popover();
	        return typeof cb === "function" ? cb() : void 0;
	      }
	    }, 200);
	  }
	};
	
	hide_popover = function(e) {
	  var popover;
	  if (e.target.getAttribute('data-popover')) {
	    if (e.target.getAttribute('data-title')) {
	      e.target.setAttribute('title', e.target.getAttribute('data-title'));
	      e.target.removeAttribute('data-title');
	    }
	    popover = fetch('popover');
	    popover.element_in_focus = false;
	    if (popover.coords) {
	      return clear_popover(false, function() {
	        if (e.target.getAttribute('data-previous_zindex') != null) {
	          e.target.style.zIndex = e.target.getAttribute('data-previous_zindex');
	          return e.target.removeAttribute('data-previous_zindex');
	        }
	      });
	    }
	  }
	};
	
	toggle_popover = function(e) {
	  var popover;
	  if (e.target.getAttribute('data-popover')) {
	    popover = fetch('popover');
	    if (popover.element_in_focus) {
	      return hide_popover(e);
	    } else {
	      return show_popover_from_dom(e);
	    }
	  }
	};
	
	DELAY_TO_SHOW_POPOVER = 1000;
	
	window.update_avatar_popover_from_canvas_histo = function(opts) {
	  var already_hovering_on_avatar, anon, coords, id, opinion, popover, user;
	  popover = fetch('popover');
	  already_hovering_on_avatar = !!popover.id;
	  if (!opts) {
	    popover.element_in_focus = null;
	    clear_popover(false);
	    return;
	  }
	  id = opts.id, user = opts.user, coords = opts.coords, anon = opts.anon, opinion = opts.opinion;
	  popover.element_in_focus = id;
	  return setTimeout(function() {
	    if (popover.element_in_focus === id) {
	      if (popover.id !== id) {
	        clear_popover(true);
	        popover.id = id;
	        popover.render = function() {
	          return AvatarPopover({
	            key: user,
	            user: user,
	            anon: anon,
	            opinion: opinion
	          });
	        };
	      }
	      popover.coords = coords;
	      return save(popover);
	    }
	  }, (popover.delay || DELAY_TO_SHOW_POPOVER) * (already_hovering_on_avatar ? .25 : 1));
	};
	
	show_popover_from_dom = function(e) {
	  var popover;
	  if (e.target.getAttribute('data-popover')) {
	    popover = fetch('popover');
	    popover.element_in_focus = e.target.getAttribute('data-popover');
	    setTimeout(function() {
	      var anon, attribute, group, key, proposal, style, user;
	      if (popover.element_in_focus === e.target.getAttribute('data-popover')) {
	        if (e.target.getAttribute('title')) {
	          e.target.setAttribute('data-title', e.target.getAttribute('title'));
	          e.target.removeAttribute('title');
	        }
	        style = getComputedStyle(e.target);
	        if (style != null ? style.zIndex : void 0) {
	          e.target.setAttribute('data-previous_zindex', "" + e.target.style.zIndex);
	          e.target.style.zIndex = "" + (parseInt(style.zIndex) + 1);
	        }
	        if (e.target.getAttribute('data-user')) {
	          user = e.target.getAttribute('data-user');
	          if (user !== popover.id) {
	            clear_popover(true);
	            anon = e.target.getAttribute('data-anonymous') === 'true';
	            popover.id = user;
	            popover.render = function() {
	              return AvatarPopover({
	                key: user,
	                user: user,
	                anon: anon,
	                opinion: e.target.getAttribute('data-opinion')
	              });
	            };
	          }
	        } else if (e.target.getAttribute('data-group')) {
	          proposal = e.target.getAttribute('data-popover');
	          attribute = e.target.getAttribute('data-attribute');
	          group = e.target.getAttribute('data-group');
	          key = proposal.key + "-" + attribute + "-" + group;
	          if (key !== popover.id) {
	            clear_popover(true);
	            popover.id = key;
	            popover.delay = 100;
	            popover.render = function() {
	              return AggregatedGroupPopover({
	                key: key,
	                proposal: proposal,
	                attribute: attribute,
	                group: group,
	                stance: e.target.getAttribute('data-stance'),
	                num_opinions: e.target.getAttribute('data-opinion-count')
	              });
	            };
	          }
	        } else if (e.target.getAttribute('data-proposal-scores')) {
	          proposal = e.target.getAttribute('data-popover');
	          if (proposal !== popover.id) {
	            clear_popover(true);
	            popover.render = function() {
	              return ProposalScoresPopover({
	                key: proposal,
	                proposal: proposal,
	                overall_avg: parseFloat(e.target.getAttribute('data-proposal-scores'))
	              });
	            };
	            popover.offsetY = e.target.offsetHeight + 12;
	            popover.offsetX = -e.target.offsetWidth / 2 + 36;
	            popover.positioned = 'right';
	            popover.top = false;
	            popover.id = proposal;
	          }
	        } else {
	          popover.tip = e.target.getAttribute('data-popover');
	        }
	        popover.coords = calc_coords_for_tooltip_or_popover(e.target);
	        return save(popover);
	      }
	    }, popover.delay || DELAY_TO_SHOW_POPOVER);
	    return e.preventDefault();
	  }
	};
	
	window.calc_coords_for_tooltip_or_popover = function(el) {
	  var coords;
	  coords = $$.offset(el);
	  coords.width = el.offsetWidth;
	  coords.height = el.offsetHeight;
	  coords.left += el.offsetWidth / 2;
	  return coords;
	};
	
	document.addEventListener("mouseover", show_popover_from_dom);
	
	document.addEventListener("mouseout", hide_popover);
	
	$$.add_delegated_listener(document.body, 'focusin', '[data-popover]', show_popover_from_dom);
	
	$$.add_delegated_listener(document.body, 'focusout', '[data-popover]', hide_popover);
	
	$$.add_delegated_listener(document.body, 'click', '[data-popover]', toggle_popover);
	
	window.get_tooltip_or_popover_position = function(arg) {
	  var arrow_adjustment, arrow_size, arrow_up, coords, left, popover, ref, tip, tooltip, top, try_bottom, try_top, viewport_bottom, viewport_top, window_height;
	  popover = arg.popover, tooltip = arg.tooltip, arrow_size = arg.arrow_size;
	  if (popover == null) {
	    popover = tooltip;
	  }
	  coords = popover.coords;
	  tip = popover.tip;
	  window_height = window.innerHeight;
	  viewport_top = window.scrollY;
	  viewport_bottom = viewport_top + window_height;
	  arrow_up = popover.top || (popover.top == null);
	  try_top = function(force) {
	    var ref, top;
	    top = coords.top + (popover.offsetY || 0) - (((ref = popover.rendered_size) != null ? ref.height : void 0) || 0) - arrow_size.height - 6;
	    if (top < viewport_top && !force) {
	      arrow_up = false;
	      return null;
	    } else {
	      arrow_up = true;
	      return top;
	    }
	  };
	  try_bottom = function(force) {
	    var ref, top;
	    top = coords.top + (popover.offsetY || 0) + arrow_size.height + coords.height + 12;
	    if (top + (((ref = popover.rendered_size) != null ? ref.height : void 0) || 0) + arrow_size.height > viewport_bottom && !force) {
	      arrow_up = true;
	      return null;
	    } else {
	      arrow_up = false;
	      return top;
	    }
	  };
	  if (popover.top || (popover.top == null)) {
	    top = try_top();
	    if (top === null) {
	      top = try_bottom();
	      if (top === null) {
	        top = try_top(true);
	      }
	    }
	  } else {
	    top = try_bottom();
	    if (top === null) {
	      top = try_top();
	      if (top === null) {
	        top = try_bottom(true);
	      }
	    }
	  }
	  arrow_adjustment = 0;
	  if ((ref = popover.rendered_size) != null ? ref.width : void 0) {
	    left = coords.left + (popover.offsetX || 0) - popover.rendered_size.width / 2;
	    if (left < 0) {
	      arrow_adjustment = -1 * left;
	      left = 0;
	    } else if (left + popover.rendered_size.width > window.innerWidth) {
	      arrow_adjustment = (window.innerWidth - popover.rendered_size.width) - left;
	      left = window.innerWidth - popover.rendered_size.width;
	    }
	  } else {
	    left = -999999;
	  }
	  return {
	    top: top,
	    left: left,
	    arrow_up: arrow_up,
	    arrow_adjustment: arrow_adjustment
	  };
	};
	
	window.Popover = ReactiveComponent({
	  displayName: 'Popover',
	  render: function() {
	    var arrow_adjustment, arrow_size, arrow_up, get_focus, left, lose_focus, popover, ref, style, top, x1;
	    popover = fetch('popover');
	    if (!popover.coords || !popover.render) {
	      return SPAN(null);
	    }
	    arrow_size = {
	      height: 10,
	      width: 26
	    };
	    ref = get_tooltip_or_popover_position({
	      popover: popover,
	      arrow_size: arrow_size
	    }), top = ref.top, left = ref.left, arrow_up = ref.arrow_up, arrow_adjustment = ref.arrow_adjustment;
	    style = _.defaults({
	      top: top,
	      left: left
	    }, this.props.style || {}, {
	      fontSize: 14,
	      padding: '4px 8px',
	      borderRadius: 8,
	      zIndex: 9999,
	      color: 'black',
	      backgroundColor: 'white',
	      position: 'absolute',
	      boxShadow: '0 1px 9px rgba(0,0,0,.5)',
	      maxWidth: '80vw'
	    });
	    get_focus = function() {
	      popover.has_focus = true;
	      return save(popover);
	    };
	    lose_focus = function() {
	      popover.has_focus = false;
	      clear_popover();
	      return save(popover);
	    };
	    return DIV({
	      id: 'popover',
	      role: "popover",
	      style: style,
	      onFocus: get_focus,
	      onMouseEnter: get_focus,
	      onBlur: lose_focus,
	      onMouseLeave: lose_focus
	    }, popover.render ? popover.render() : DIV({
	      dangerouslySetInnerHTML: {
	        __html: tip
	      }
	    }), SVG({
	      width: arrow_size.width,
	      height: arrow_size.height,
	      viewBox: "0 0 531.74 460.5",
	      preserveAspectRatio: "none",
	      style: {
	        position: 'absolute',
	        bottom: arrow_up ? -arrow_size.height : void 0,
	        top: !arrow_up ? -arrow_size.height : void 0,
	        left: popover.positioned !== 'right' ? "calc(50% - " + (arrow_size.width / 2 + arrow_adjustment) + "px)" : void 0,
	        right: popover.positioned === 'right' ? 7 : void 0,
	        transform: !arrow_up ? 'scale(1,-1)' : void 0,
	        display: popover.hide_triangle ? 'none' : void 0
	      }
	    }, POLYGON({
	      stroke: "none",
	      fill: 'white',
	      points: "530.874,0.5 265.87,459.5 0.866,0.5"
	    }), G(null, (function() {
	      var i, len, ref1, results;
	      ref1 = [0.866, 530.874];
	      results = [];
	      for (i = 0, len = ref1.length; i < len; i++) {
	        x1 = ref1[i];
	        results.push(LINE({
	          key: x1,
	          x1: x1,
	          y1: 0.5,
	          x2: 265.87,
	          y2: 459.5,
	          stroke: "black",
	          strokeWidth: 35,
	          strokeOpacity: .25
	        }));
	      }
	      return results;
	    })())));
	  },
	  componentDidUpdate: function() {
	    var popover, rendered_size;
	    popover = fetch('popover');
	    if (popover.coords) {
	      rendered_size = {
	        width: ReactDOM.findDOMNode(this).offsetWidth,
	        height: ReactDOM.findDOMNode(this).offsetHeight
	      };
	      if (popover.rendered_size == null) {
	        popover.rendered_size = {};
	      }
	      if (rendered_size.width !== popover.rendered_size.width || rendered_size.height !== popover.rendered_size.height) {
	        if (popover.size_checked == null) {
	          popover.size_checked = Date.now();
	        }
	        if (Date.now() - popover.size_checked < 500) {
	          popover.rendered_size = rendered_size;
	          return save(popover);
	        }
	      }
	    }
	  }
	});


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	
	window.Slider = ReactiveComponent({
	  displayName: 'Slider',
	  full_props: function() {
	    return _.defaults({}, this.props, {
	      handle_height: 6,
	      base_height: 6,
	      base_endpoint: 'square',
	      base_color: 'rgb(200, 200, 200)',
	      polarized: false,
	      draw_helpers: false,
	      respond_to_click: true
	    });
	  },
	  render: function() {
	    var draw_handle, props, slider, slider_style;
	    props = this.full_props();
	    draw_handle = props.draw_handle;
	    if (draw_handle == null) {
	      draw_handle = true;
	    }
	    if (draw_handle) {
	      slider = fetch(props.slider_key);
	      if (slider.value == null) {
	        _.defaults(slider, {
	          value: props.polarized ? -1.0 : 0,
	          has_moved: false,
	          is_moving: false
	        });
	        save(slider);
	      }
	    }
	    slider_style = _.defaults({}, props.slider_style || {}, {
	      width: props.width,
	      height: Math.max(props.base_height, props.handle_height),
	      position: 'relative'
	    });
	    return DIV({
	      className: 'slider',
	      style: slider_style,
	      onBlur: props.onBlur ? props.onBlur : void 0,
	      onFocus: props.onFocus ? props.onFocus : void 0
	    }, this.drawSliderBase(), draw_handle ? this.drawSliderHandle() : void 0);
	  },
	  drawSliderBase: function() {
	    var d, endpoint, endpoints, idx, inc, num_ticks, props, region, slider, slider_base_style, sty, tick_position, w;
	    props = this.full_props();
	    slider_base_style = {
	      width: props.width,
	      height: props.base_height,
	      backgroundColor: props.base_color,
	      position: 'absolute'
	    };
	    slider = fetch(props.slider_key);
	    if (typeof props.base_endpoint === 'string') {
	      endpoints = [props.base_endpoint, props.base_endpoint];
	    } else {
	      endpoints = props.base_endpoint;
	    }
	    return DIV({
	      ref: 'base',
	      key: 'slider_base',
	      className: 'slider_base',
	      style: slider_base_style,
	      onClick: this.handleMouseClick
	    }, props.show_val_highlighter ? DIV({
	      style: {
	        height: props.base_height + 4,
	        backgroundColor: "rgb(81, 142, 255)",
	        boxShadow: "0 0 " + (1.5 * (props.base_height + 4)) + "px rgb(255 255 255), 0 0 3px rgba(0,0,0,.2) inset",
	        position: 'relative',
	        top: -2,
	        width: (Math.abs(100 * slider.value * (props.polarized ? .5 : 1))) + "%",
	        left: !props.polarized ? 0 : slider.value < 0 ? (50 + 50 * slider.value) + "%" : '50%'
	      }
	    }) : void 0, (function() {
	      var results;
	      if (props.ticks) {
	        num_ticks = 2 / props.ticks.increment;
	        inc = slider_base_style.width / num_ticks;
	        tick_position = -inc;
	        results = [];
	        while (tick_position <= slider_base_style.width - inc) {
	          tick_position += inc;
	          results.push(DIV({
	            key: "tick-" + tick_position,
	            style: {
	              position: 'absolute',
	              left: ((tick_position - (Math.abs(tick_position - slider_base_style.width) < 2 ? 1 : 0)) / props.width * 100) + "%",
	              top: 0,
	              width: 1,
	              height: (props.ticks.height || 5) * (Math.abs(tick_position - slider_base_style.width / 2) < 3 ? 2 : 1),
	              backgroundColor: "#aaa"
	            }
	          }));
	        }
	        return results;
	      }
	    })(), (function() {
	      var i, len, results;
	      results = [];
	      for (idx = i = 0, len = endpoints.length; i < len; idx = ++i) {
	        endpoint = endpoints[idx];
	        if (endpoint === 'square') {
	          continue;
	        }
	        if (endpoint === 'sharp') {
	          results.push(DIV({
	            key: "endpoint-" + idx,
	            style: {
	              position: 'absolute',
	              left: idx === 0 ? -5 : void 0,
	              right: idx === 1 ? -5 : void 0,
	              width: 5,
	              height: slider_base_style.height,
	              backgroundColor: slider_base_style.backgroundColor
	            }
	          }, DIV({
	            style: cssTriangle((idx === 0 ? 'left' : 'right'), slider_base_style.backgroundColor, 12, 6, {
	              position: 'absolute',
	              left: idx === 0 ? -12 : void 0,
	              right: idx === 1 ? -12 : void 0
	            })
	          })));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    })(), (function() {
	      var i, len, ref, results;
	      if (props.regions) {
	        d = props.width / props.regions.length;
	        sty = {
	          color: '#BDBDBD',
	          fontSize: 14
	        };
	        ref = props.regions;
	        results = [];
	        for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	          region = ref[idx];
	          w = sizeWhenRendered(region.abbrev, sty);
	          results.push(DIV({
	            style: _.extend({}, sty, {
	              color: '#BDBDBD',
	              fontSize: 14,
	              position: 'absolute',
	              left: (idx + .5) * d - w.width / 2,
	              top: 4
	            })
	          }, region.abbrev));
	        }
	        return results;
	      }
	    })());
	  },
	  drawSliderHandle: function() {
	    var handle_height, handle_width, props, slider, sliderHandle, support;
	    props = this.full_props();
	    handle_width = handle_height = props.handle_height;
	    slider = fetch(props.slider_key);
	    sliderHandle = props.handle || slider_handle.flat;
	    return DIV({
	      className: 'the_handle',
	      role: 'slider',
	      'aria-valuemin': props.polarized ? -1 : 0,
	      'aria-valuemax': 1,
	      'aria-valuenow': slider.value,
	      'aria-valuetext': typeof props.readable_text === "function" ? props.readable_text(slider.value) : void 0,
	      'aria-label': props.label,
	      tabIndex: 0,
	      onKeyDown: (function(_this) {
	        return function(e) {
	          var amount, direction, new_val, ref, ref1, ref2, ref3, ref4;
	          if ((ref = e.which) === 37 || ref === 38 || ref === 39 || ref === 40 || ref === 33 || ref === 34 || ref === 35 || ref === 36) {
	            amount = (ref1 = e.which) === 37 || ref1 === 38 || ref1 === 39 || ref1 === 40 ? .05 : (ref2 = e.which) === 33 || ref2 === 34 ? .25 : (ref3 = e.which) === 35 || ref3 === 36 ? 10000 : void 0;
	            direction = (ref4 = e.which) === 37 || ref4 === 40 || ref4 === 34 || ref4 === 36 ? -1 : 1;
	            new_val = slider.value;
	            new_val += direction * amount;
	            new_val = Math.max(new_val, (props.polarized ? -1 : 0));
	            new_val = Math.min(new_val, 1);
	            if (new_val !== slider.value) {
	              slider.value = new_val;
	              save(slider);
	              if (typeof props.onMouseUpCallback === "function") {
	                props.onMouseUpCallback(e);
	              }
	            }
	            return e.preventDefault();
	          } else if (e.which === 13 || e.which === 32) {
	            if (props.onMouseUpCallback) {
	              props.onMouseUpCallback(e);
	            }
	            return e.preventDefault();
	          }
	        };
	      })(this),
	      onMouseUp: this.handleMouseUp,
	      onMouseDown: this.handleMouseDown,
	      onTouchEnd: this.handleMouseUp,
	      onTouchCancel: this.handleMouseUp,
	      onTouchStart: this.handleMouseDown,
	      onTouchMove: this.handleMouseMove,
	      onBlur: (function(_this) {
	        return function() {
	          _this.local.has_focus = false;
	          return save(_this.local);
	        };
	      })(this),
	      onFocus: (function(_this) {
	        return function() {
	          _this.local.has_focus = true;
	          return save(_this.local);
	        };
	      })(this),
	      style: _.extend(props.handle_style || {}, {
	        width: handle_width,
	        height: handle_height,
	        top: props.offset ? 0 : -(handle_height - props.base_height) / 2,
	        position: 'relative',
	        marginLeft: -handle_width / 2,
	        zIndex: 10,
	        outline: 'none',
	        left: props.polarized ? props.width * (slider.value + 1) / 2 : props.width * slider.value
	      })
	    }, sliderHandle(_.extend(props.handle_props || {}, {
	      value: props.polarized ? (slider.value + 1) / 2 : slider.value,
	      handle_height: handle_height,
	      handle_width: handle_width,
	      has_focus: this.local.has_focus
	    })), props.draw_helpers ? DIV(null, (function() {
	      var i, len, ref, results;
	      ref = [true, false];
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        support = ref[i];
	        results.push(DIV({
	          key: support + "1",
	          style: {
	            right: support ? -21 : void 0,
	            left: !support ? -21 : void 0,
	            position: 'absolute',
	            top: 7.5,
	            color: 'white',
	            pointerEvents: 'none'
	          }
	        }, support ? ChevronRight(15) : ChevronLeft(15)));
	      }
	      return results;
	    })(), (function() {
	      var i, len, ref, results;
	      ref = [true, false];
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        support = ref[i];
	        results.push(DIV({
	          key: support + "2",
	          style: {
	            right: support ? -19 : void 0,
	            left: !support ? -19 : void 0,
	            position: 'absolute',
	            top: 7.5,
	            color: 'white',
	            pointerEvents: 'none'
	          }
	        }, support ? ChevronRight(15) : ChevronLeft(15)));
	      }
	      return results;
	    })(), (function() {
	      var i, len, ref, results;
	      ref = [true, false];
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        support = ref[i];
	        results.push(DIV({
	          key: support + "3",
	          style: {
	            right: support ? -20 : void 0,
	            left: !support ? -20 : void 0,
	            position: 'absolute',
	            top: 7.5,
	            color: focus_color(),
	            pointerEvents: 'none'
	          }
	        }, support ? ChevronRight(15) : ChevronLeft(15)));
	      }
	      return results;
	    })()) : void 0);
	  },
	  handleMouseDown: function(e) {
	    var el, props, slider;
	    props = this.full_props();
	    el = ReactDOM.findDOMNode(this);
	    e.preventDefault();
	    slider = fetch(props.slider_key);
	    slider.is_moving = true;
	    save(slider);
	    this.local.starting_adjustment = (parseInt(e.currentTarget.style.left, 10) || 0) - (e.clientX || e.touches[0].clientX);
	    save(this.local);
	    if (props.onMouseDownCallback) {
	      props.onMouseDownCallback(e);
	    }
	    document.addEventListener("mousemove", this.handleMouseMove);
	    return document.addEventListener("mouseup", this.handleMouseUp);
	  },
	  handleMouseMove: function(e) {
	    var clientX, props, slider, x;
	    props = this.full_props();
	    e.preventDefault();
	    e.stopPropagation();
	    slider = fetch(props.slider_key);
	    clientX = e.clientX || e.touches[0].clientX;
	    x = clientX + this.local.starting_adjustment;
	    x = x < 0 ? 0 : x > props.width ? props.width : x;
	    slider.is_moving = true;
	    slider.has_moved = true;
	    slider.value = x / props.width;
	    if (props.polarized) {
	      slider.value = slider.value * 2 - 1;
	    }
	    slider.value = Math.round(slider.value * 10000) / 10000;
	    save(slider);
	    if (props.onMouseMoveCallback) {
	      return props.onMouseMoveCallback(e);
	    }
	  },
	  handleMouseUp: function(e) {
	    var props, slider;
	    props = this.full_props();
	    slider = fetch(props.slider_key);
	    if (typeof props.onMouseUpCallback === "function") {
	      props.onMouseUpCallback(e);
	    }
	    if (slider.is_moving) {
	      e.preventDefault();
	      slider.is_moving = false;
	      save(slider);
	    }
	    document.removeEventListener("mousemove", this.handleMouseMove);
	    return document.removeEventListener("mouseup", this.handleMouseUp);
	  },
	  handleMouseClick: function(e) {
	    var clientX, props, slider, val;
	    props = this.full_props();
	    if (props.respond_to_click) {
	      e.preventDefault();
	      clientX = e.clientX || e.touches[0].clientX;
	      val = (clientX - $$.offset(this.refs.base).left) / props.width;
	      if (val < 0) {
	        val = 0;
	      }
	      if (val > 1) {
	        val = 1;
	      }
	      if (props.polarized) {
	        val = val * 2 - 1;
	      }
	      slider = fetch(props.slider_key);
	      slider.has_moved = true;
	      slider.value = Math.round(val * 10000) / 10000;
	      save(slider);
	      return typeof props.onClickCallback === "function" ? props.onClickCallback(e) : void 0;
	    }
	  }
	});
	
	window.slider_handle || (window.slider_handle = {});
	
	slider_handle.face = function(props) {
	  var bh, bw, direction, is_left, x, y;
	  return SVG({
	    height: props.handle_height,
	    width: props.handle_width,
	    viewBox: "-2 -1 104 104",
	    style: {
	      pointerEvents: 'none',
	      position: 'absolute',
	      top: 0,
	      filter: props.has_focus ? "drop-shadow(0 0 1px rgba(0,0,0,.5))" : void 0
	    }
	  }, DEFS(null, svg.innerbevel({
	    id: 'handle-innerbevel',
	    shadows: [
	      {
	        color: 'black',
	        opacity: 1.0,
	        dx: 0,
	        dy: -3,
	        stdDeviation: 3
	      }, {
	        color: 'white',
	        opacity: .25,
	        dx: 0,
	        dy: 3,
	        stdDeviation: 3
	      }
	    ]
	  })), CIRCLE({
	    fill: props.color,
	    stroke: props.color,
	    cx: 50,
	    cy: 50,
	    r: 50
	  }), G(null, CIRCLE({
	    fill: props.color,
	    filter: "url(#handle-innerbevel)",
	    cx: 50,
	    cy: 50,
	    r: 50
	  }), props.detail ? G(null, (function() {
	    var i, len, ref, results;
	    ref = [true, false];
	    results = [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      is_left = ref[i];
	      direction = is_left ? -1 : 1;
	      bw = 15;
	      bh = 2;
	      x = 50 + direction * (28 + 4 * (1 - props.value)) - (is_left ? 0 : bw);
	      y = 28 - 4 * (1 - props.value);
	      results.push(RECT({
	        x: x,
	        y: y,
	        width: bw,
	        height: bh,
	        transform: "rotate(" + (direction * (5 + 30 * Math.abs(.5 - props.value))) + " " + (x + (is_left ? bw : 0)) + " " + (y + bh) + ")",
	        fill: 'white'
	      }));
	    }
	    return results;
	  })(), (function() {
	    var i, len, ref, results;
	    ref = [true, false];
	    results = [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      is_left = ref[i];
	      direction = is_left ? -1 : 1;
	      results.push(CIRCLE({
	        cx: 50 + direction * (13 + 6 * (1 - props.value)),
	        cy: 39,
	        r: 3,
	        fill: 'white'
	      }));
	    }
	    return results;
	  })(), (function(_this) {
	    return function() {
	      var frowniness, mw, my, qx1, qy1, ref, ref1, ref2, x1, x2, y1, y2;
	      frowniness = 5;
	      mw = 40;
	      my = 65;
	      ref = [50 - mw / 2, my + frowniness * (1 - props.value)], x1 = ref[0], y1 = ref[1];
	      ref1 = [50 + mw / 2, y1], x2 = ref1[0], y2 = ref1[1];
	      ref2 = [50, my + .5 * frowniness + 2 * frowniness * (2 * props.value - 1)], qx1 = ref2[0], qy1 = ref2[1];
	      return PATH({
	        stroke: 'white',
	        fill: focus_color(),
	        strokeWidth: 3,
	        d: "M " + x1 + " " + y1 + "\nQ " + qx1 + " " + qy1 + "\n  " + x2 + " " + y2
	      });
	    };
	  })(this)()) : void 0));
	};
	
	slider_handle.triangley = function(props) {
	  var id, svg_props;
	  svg_props = {
	    height: props.handle_height,
	    width: props.handle_width,
	    viewBox: "0 0 21 18",
	    style: {
	      pointerEvents: 'none',
	      position: 'absolute',
	      top: 0,
	      zIndex: 10,
	      filter: props.has_focus ? "drop-shadow(0 0 3px rgba(0,0,0,.5))" : void 0
	    }
	  };
	  id = "triangley_filter-" + ((Math.random() * 1000000).toFixed(0));
	  return SVG(svg_props, DEFS(null, FILTER({
	    id: id,
	    x: "-50%",
	    y: "-50%",
	    width: "200%",
	    height: "200%",
	    filterUnits: "objectBoundingBox"
	  }, FEOFFSET({
	    dx: "0",
	    dy: "1",
	    'in': "SourceAlpha",
	    result: "shadowOffsetOuter1"
	  }), FEGAUSSIANBLUR({
	    stdDeviation: "0.5",
	    'in': "shadowOffsetOuter1",
	    result: "shadowBlurOuter1"
	  }), FECOLORMATRIX({
	    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.16479563 0",
	    'in': "shadowBlurOuter1",
	    type: "matrix",
	    result: "shadowMatrixOuter1"
	  }), FEOFFSET({
	    dx: "0",
	    dy: "-1",
	    'in': "SourceAlpha",
	    result: "shadowOffsetInner1"
	  }), FEGAUSSIANBLUR({
	    stdDeviation: "1",
	    'in': "shadowOffsetInner1",
	    result: "shadowBlurInner1"
	  }), FECOMPOSITE({
	    'in': "shadowBlurInner1",
	    in2: "SourceAlpha",
	    operator: "arithmetic",
	    k2: "-1",
	    k3: "1",
	    result: "shadowInnerInner1"
	  }), FECOLORMATRIX({
	    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
	    'in': "shadowInnerInner1",
	    type: "matrix",
	    result: "shadowMatrixInner1"
	  }), FEMERGE(null, FEMERGENODE({
	    'in': "shadowMatrixOuter1"
	  }), FEMERGENODE({
	    'in': "SourceGraphic"
	  }), FEMERGENODE({
	    'in': "shadowMatrixInner1"
	  })))), G({
	    stroke: "none",
	    strokeWidth: "0",
	    fill: focus_color(),
	    fillRule: "evenodd"
	  }, PATH({
	    d: "M1,6 L20,6 L20,16 L1,16 L1,6 Z M10.5,0 L20,6 L1,6 L10.5,0 Z",
	    fill: focus_color(),
	    filter: "url(#" + id + ")"
	  })));
	};
	
	slider_handle.flat = function(props) {
	  var svg_props;
	  return DIV({
	    style: {
	      borderRadius: '50%',
	      position: 'absolute',
	      top: 0,
	      zIndex: 10,
	      height: props.handle_height,
	      width: props.handle_width,
	      backgroundColor: focus_color(),
	      boxShadow: 'inset 0 -1px 2px rgba(0,0,0,.3)'
	    }
	  });
	  svg_props = {
	    height: props.handle_height,
	    width: props.handle_width,
	    viewBox: "-2 -1 104 104",
	    style: {
	      pointerEvents: 'none',
	      zIndex: 10,
	      filter: props.has_focus ? "drop-shadow(0 0 3px rgba(0,0,0,.5))" : void 0
	    }
	  };
	  return SVG(svg_props, DEFS(null, CLIPPATH({
	    id: 'slider-avatar-clip'
	  }, CIRCLE({
	    cx: 50,
	    cy: 50,
	    r: 48
	  }))), CIRCLE({
	    fill: props.color,
	    stroke: props.color,
	    cx: 50,
	    cy: 50,
	    r: 50
	  }), props.use_face ? (function(_this) {
	    return function() {
	      var user;
	      user = fetch(fetch('/current_user').user);
	      if (user.avatar_file_name) {
	        return IMAGE({
	          'xlink:href': avatarUrl(user, 'large'),
	          x: 2,
	          y: 2,
	          width: 96,
	          height: 96,
	          clipPath: 'url(#slider-avatar-clip)'
	        });
	      }
	    };
	  })(this)() : void 0);
	};
	
	styles += "" + (css.grab_cursor('.the_handle'));


/***/ },
/* 12 */
/***/ function(module, exports) {

	window.svg = {
	  setSize: function(base_width, base_height, props) {
	    if (props.width && (props.height == null)) {
	      return props.height = props.width * base_height / base_width;
	    } else if (props.height && (props.width == null)) {
	      return props.width = props.height * base_width / base_height;
	    }
	  },
	  dropShadow: function(props) {
	    return FILTER({
	      id: props.id
	    }, FEOFFSET({
	      "in": "SourceAlpha",
	      dx: props.dx,
	      dy: props.dy,
	      result: "offsetblur"
	    }), FEGAUSSIANBLUR({
	      "in": 'offsetblur',
	      stdDeviation: props.stdDeviation,
	      result: 'blur2'
	    }), FECOLORMATRIX({
	      "in": 'blur2',
	      result: 'color',
	      type: 'matrix',
	      values: "0 0 0 0  0\n0 0 0 0  0 \n0 0 0 0  0 \n0 0 0 " + props.opacity + " 0"
	    }), FEMERGE(null, FEMERGENODE({
	      "in": 'color'
	    }), FEMERGENODE({
	      "in": 'SourceGraphic'
	    })));
	  },
	  innerbevel: function(props) {
	    var idx, shadow;
	    return FILTER({
	      id: props.id,
	      x0: "-50%",
	      y0: "-50%",
	      width: "200%",
	      height: "200%"
	    }, (function() {
	      var i, len, ref, results;
	      ref = props.shadows;
	      results = [];
	      for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	        shadow = ref[idx];
	        results.push([
	          FEGAUSSIANBLUR({
	            "in": 'SourceAlpha',
	            stdDeviation: shadow.stdDeviation,
	            result: "blur" + idx
	          }), FEOFFSET({
	            dy: shadow.dy,
	            dx: shadow.dx
	          }), FECOMPOSITE({
	            in2: 'SourceAlpha',
	            operator: "arithmetic",
	            k2: "-1",
	            k3: "1",
	            result: "shadowDiff"
	          }), FEFLOOD({
	            floodColor: shadow.color,
	            floodOpacity: shadow.opacity
	          }), FECOMPOSITE({
	            in2: "shadowDiff",
	            operator: "in"
	          }), FECOMPOSITE({
	            in2: idx === 0 ? 'SourceGraphic' : "result" + (idx - 1),
	            operator: "over",
	            result: "result" + idx
	          })
	        ]);
	      }
	      return results;
	    })());
	  }
	};


/***/ },
/* 13 */
/***/ function(module, exports) {

	(function () {
	
	    // ****************
	    // Public API
	    var cache = {}
	    function fetch(url, defaults) {
	        //if (window.watch && watch(url)) console.trace()
	
	        if (!url) return null
	        if (url.key) url = url.key   // If user passes key as object
	
	        window.record_dependence && record_dependence(url)
	
	        // Return the cached version if it exists
	        if (cache[url]) return cache[url]
	
	        // Else, start a serverFetch in the background and return stub.
	        if (url[0] === '/')
	            server_fetch(url)
	
	        update_cache(extend({key: url}, defaults), true)
	        return cache[url]
	    }
	
	    /*  Updates cache and saves to server.
	     *  You can pass a callback that will run when the saves have finished.
	     */
	    function save(object, continuation) {
	        update_cache(object)
	
	        // Save all the objects
	        if (object.key && object.key[0] == '/')
	            server_save(object, continuation)
	        else
	            if (continuation) continuation()
	    }
	
	    /*  Deletes from server (if it's there) and removes from cache
	     *  You can pass a callback that will run when the delete has finished.
	     */
	    function destroy(key, continuation) {
	        if (!key) return
	
	        // Save all the objects
	        if (key[0] == '/')
	            server_destroy(key, continuation)
	        else {
	            // Just remove the key from the cache if this state is
	            // owned by the client.  Note that this won't clean up
	            // references to this object in e.g. any lists. The Client
	            // is responsible for updating all the relevant
	            // references.
	            delete cache[key]
	            if (continuation) continuation()
	        }
	    }
	
	
	    // ================================
	    // == Internal funcs
	
	    var new_index = 0
	    var affected_keys = new Set()
	    var re_render_timer = null
	    function update_cache(object, from_fetch) {
	        do_not_recurse = !!object.key && object.key.startsWith('/translations/')
	
	        function recurse(object) {
	            // Recurses into object and folds it into the cache.
	
	            // If this object has a key, update the cache for it
	            var key = object && object.key
	            if (key) {
	                // if (!key || !key.match) {
	                //     console.trace()
	                //     console.log(key)
	                // }
	
	                // Change /new/thing to /new/thing/45
	                if (key.match(new RegExp('^/new/'))     // Starts with /new/
	                    && !key.match(new RegExp('/\\d+$'))) // Doesn't end in a /number
	                    key = object.key = key + '/' + new_index++
	
	                var cached = cache[key]
	                if (!cached)
	                    // This object is new.  Let's cache it.
	                    cache[key] = object
	                else if (object !== cached)
	                    // Else, mutate cache to match the object.
	                    for (var k in object)          // Mutating in place preserves
	                        cache[key][k] = object[k]  // pointers to this object
	
	                // Remember this key for re-rendering
	                if (!from_fetch) {
	                    affected_keys.add(key)
	                }
	            }
	
	            // Now recurse into this object.
	            //  - Through each element in arrays
	            //  - And each property on objects
	            if (Array.isArray(object))
	                for (var i=0; i < object.length; i++)
	                    object[i] = recurse(object[i])
	            else if (typeof(object) === 'object' && object !== null && !do_not_recurse)
	                for (var k in object){
	                    object[k] = recurse(object[k])
	                }
	
	            // Return the new cached representation of this object
	            return cache[key] || object
	        }
	
	        recurse(object)
	
	        // Now initiate the re-rendering, if there isn't a timer already going
	        if (!re_render_timer){
	            re_render_timer = requestAnimationFrame(function () {
	                re_render_timer = null
	                var keys = affected_keys.all()
	                affected_keys.clear()
	                if (keys.length > 0) {
	                    var re_render = (window.re_render || function () {
	                        console.log('You need to implement re_render()') })
	                    re_render(keys)
	                }
	            })
	        }
	    }
	
	    var outstanding_fetches = {}
	    function server_fetch(key, continuation) {
	        // Error check
	        if (outstanding_fetches[key]) {
	            console.error('Duplicate request for '+key)
	            return
	        }
	
	        // Build request
	        var request = new XMLHttpRequest()
	        request.onload = function () {
	            delete outstanding_fetches[key]
	            if (request.status === 200) {
	                var result = JSON.parse(request.responseText)
	                if (window.arest.trans_in)
	                    result = arest.trans_in(result)
	                update_cache(result)
	                if (continuation) continuation()                
	            }
	            else if (request.status === 500)
	                if (window.on_ajax_error) window.on_ajax_error()
	
	        }
	
	        // Open request
	        outstanding_fetches[key] = request
	        request.open('GET', key, true)
	        request.setRequestHeader('Accept','application/json')
	        request.setRequestHeader('X-Requested-With','XMLHttpRequest')
	
	        request.send(null)
	    }
	
	    var pending_saves = {} // Stores xmlhttprequest of any key being saved
	                           // (Note: This shim will fail in many situations...)
	    function server_save(object, continuation) {
	        if (pending_saves[object.key]) {
	            console.log('Yo foo, aborting', object.key)
	            pending_saves[object.key].abort()
	            delete pending_saves[object.key]
	        }
	
	        var original_key = object.key
	        
	        // Special case for /new.  Grab the pieces of the URL.
	        var pattern = new RegExp("/new/([^/]+)/(\\d+)")
	        var match = original_key.match(pattern)
	        var url = (match && '/' + match[1]) || original_key
	
	        // Build request
	        var request = new XMLHttpRequest()
	        request.onload = function () {
	            // No longer pending
	            delete pending_saves[original_key]
	
	            if (request.status === 200) {
	                var result = JSON.parse(request.responseText)
	                // console.log('New save result', result)
	                // Handle /new/stuff
	                deep_map(function (obj) {
	                    match = obj.key && obj.key.match(/(.*)\?original_id=(\d+)$/)
	                    if (match && match[2]) {
	                        // Let's map the old and new together
	                        var new_key = match[1]                // It's got a fresh key
	                        cache[new_key] = cache[original_key]  // Point them at the same thing
	                        obj.key = new_key                     // And it's no longer "/new/*"
	                    }
	                },
	                        result)
	
	
	                update_cache(result)
	                if (continuation) continuation()
	            }
	            else if (request.status === 500)
	                window.ajax_error && window.ajax_error()
	        }
	
	        object = clone(object)
	        object['authenticity_token'] = csrf()
	
	        // Open request
	        var POST_or_PUT = match ? 'POST' : 'PUT'
	        request.open(POST_or_PUT, url, true)
	        request.setRequestHeader('Accept','application/json')
	        request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
	        request.setRequestHeader('X-CSRF-Token', csrf())
	        request.setRequestHeader('X-Requested-With','XMLHttpRequest')
	
	        request.send(JSON.stringify(object))
	
	        // Remember it
	        pending_saves[original_key] = request
	    }
	
	    function server_destroy(key, continuation) {
	        // Build request
	        var request = new XMLHttpRequest()
	        request.onload = function () {
	            if (request.status === 200) {
	                console.log('Destroy returned for', key)
	                var result = JSON.parse(request.responseText)
	                delete cache[key]
	                update_cache(result)
	                if (continuation) continuation()
	            }
	            else if (request.status === 500)
	                if (window.on_ajax_error) window.on_ajax_error()
	            else {
	                // TODO: give user feedback that DELETE failed
	                console.log('DELETE of', key, 'failed!')
	            }
	
	        }
	
	        payload = {'authenticity_token': csrf()}
	
	        // Open request
	        request.open('DELETE', key, true)
	        request.setRequestHeader('Accept','application/json')
	        request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
	        request.setRequestHeader('X-CSRF-Token', csrf())
	        request.setRequestHeader('X-Requested-With','XMLHttpRequest')
	        request.send(JSON.stringify(payload))
	    }
	
	    // This is used in a specific hack.  I need to work on it.
	    function clear_matching_objects (match_key_func) {
	        // Clears all keys where match_key_func(key) returns true
	        for (key in cache)
	            if (match_key_func(key))
	                delete cache[key]
	    }
	
	
	    var csrf_token = null
	    function csrf(new_token) {
	        if (new_token) {
	            csrf_token = new_token;
	            return csrf_token;
	        }
	
	        if (cache['/current_user']) {
	            csrf_token = cache['/current_user'].csrf
	        }
	
	        if (csrf_token) return csrf_token
	        var metas = document.getElementsByTagName('meta')
	        for (i=0; i<metas.length; i++) { 
	            if (metas[i].getAttribute("name") == "csrf-token") { 
	                return metas[i].getAttribute("content");
	            } 
	        } 
	        return ""
	    }
	
	    window.loading_indicator = React.createFactory(ReactDOMFactories.div)({style: {height: '100%', width: '100%'},
	                                       className: 'loading'}, 'Loading')
	
	    function error_indicator(message) {
	        return ReactDOMFactories.div(null, 'Error! ' + message)
	    }
	
	
	    // ****************
	    // Wrapper for React Components
	    var components = {}                  // Indexed by 'component/0', 'component/1', etc.
	    var components_count = 0
	    var dirty_components = {}
	    var execution_context = []  // The stack of components that are being rendered
	
	    function ReactiveComponent(component) {
	
	        // STEP 1: Define get() and save()
	        component.fetch = component.data = component.get = function (key, defaults) {
	            if (!this.isMounted)
	                throw Error('Component ' + this.name + ' (' + this.local_key
	                            + ') is tryin to get data(' + key + ') after it died.')
	
	            if (key === undefined)    key = this.mounted_key || this.name
	            if (!key)                 return null
	            // if (!key)    throw TypeError('Component mounted onto a null key. '
	            //                              + this.name + ' ' + this.local_key)
	            if (key.key) key = key.key   // If user passes key as object
	            return fetch(key, defaults)  // Call into main activerest
	        }
	        component.save = save                  // Call into main activerest
	        
	
	        // STEP 2: Wrap all the component's methods
	        function wrap(obj, method, before, after) {
	            var original_method = obj[method]
	            if (!(original_method || before || after)) return
	            obj[method] = function() {
	                before && before.apply(this, arguments)
	                if (this.local_key !== undefined)
	                    // We only want to set the execution context on wrapped methods
	                    // that are called on live instance.  getDefaultProps(), for
	                    // instance, is called when defining a component class, but not
	                    // on actual instances.  You can't render new components from
	                    // within there, so we don't need to track the execution context.
	                    execution_context = this.props.parents.concat([this.local_key])
	
	                try {
	                    var result = original_method && original_method.apply(this, arguments)
	                    // if (method == 'render') {
	                    //     console.log(this.name, result)
	                    //     result = DIV({"data-widget": this.name}, result)
	                    // }
	                } catch (e) {
	                    execution_context = []
	                    if (this.is_waiting()){
	                        // console.log('waiting for', this.name, 'missing', this.is_waiting())
	                        return loading_indicator
	                    }
	                    else {
	                        // Then let's re-cause the error, but without catching it
	                        original_method.apply(this, arguments)
	                        console.assert(false) // this cannot happen unless method has side effects
	                    }
	                }
	
	                execution_context = []
	                after && after.apply(this, arguments)
	
	                return result
	            }
	        }
	
	        // We register the component when mounting it into the DOM
	        wrap(component, 'UNSAFE_componentWillMount',
	            function () { 
	
	                 // STEP 1. Register the component's basic info
	                 if (component.displayName === undefined)
	                     throw 'Component needs a displayName'
	                 this.name = component.displayName.replace(' ', '_')
	                 this.local_key = 'component/' + components_count++
	                 components[this.local_key] = this
	
	                 // XXX Putting this into WillMount probably won't let you use the
	                 // mounted_key inside getInitialState!  But you should be using
	                 // activerest state anyway, right?
	                 this.mounted_key = this._reactInternals.key
	
	                 // // You can pass an object in as a key if you want:
	                 // console.log("GOT KEY!", component.displayName, this._reactInternals.key)
	                 if (this.mounted_key && this.mounted_key.key){
	                     // This is broken now that React doesn't allow props to be modified                 
	                     // this.props.key = this.props.key.key
	                     console.error("component", component.displayName, " received an object as a key")
	                 }
	
	
	
	                 // STEP 2: Create shortcut for this component's local key
	                 
	                 function add_shortcut (obj, shortcut_name, to_key) {
	                     //console.log('Giving '+obj.name+' shorcut @'+shortcut_name+'='+to_key)
	                     // console.log('shortcut', obj, shortcut_name, to_key)
	                     delete obj[name]
	                     Object.defineProperty(obj, shortcut_name, {
	                         get: function () {
	                            if (!obj.shortcuts)
	                                obj.shortcuts = Object.create(null)
	                            if (!obj.shortcuts[to_key])
	                              obj.shortcuts[to_key] = obj.get(to_key)
	                            return obj.shortcuts[to_key]
	                         },
	                         configurable: true })
	                 }
	
	                 add_shortcut(this, 'local', this.local_key)
	                 
	            })
	
	        wrap(component, 'render', function () {
	            // Render will need to clear the component's old
	            // dependencies before rendering and finding new ones
	            clear_component_dependencies(this.local_key)
	            delete dirty_components[this.local_key]
	            if (this.shortcuts) {
	                keys = Object.keys(this.shortcuts)
	                for (var i=0; i < keys.length; i++){
	                    key = keys[i]
	                    keys_4_component.add(this.local_key, key)  // Track dependencies
	                    components_4_key.add(key, this.local_key)  // both ways
	                }
	            }
	        })
	
	        wrap(component, 'componentDidMount', function () {
	            ReactDOM.findDOMNode(this).setAttribute('data-widget', component.displayName)
	            if (this.mounted_key)
	                ReactDOM.findDOMNode(this).setAttribute('data-key', this.mounted_key)              
	        })
	        wrap(component, 'componentDidUpdate', function () {
	            ReactDOM.findDOMNode(this).setAttribute('data-widget', component.displayName)
	            if (this.mounted_key)
	                ReactDOM.findDOMNode(this).setAttribute('data-key', this.mounted_key)              
	        })
	        //wrap(component, 'componentWillReceiveProps')
	        wrap(component, 'componentWillUnmount', function () {
	            // Clean up
	            clear_component_dependencies(this.local_key)
	            delete cache[this.local_key]
	            delete components[this.local_key]
	            delete dirty_components[this.local_key]
	        })
	
	        component.shouldComponentUpdate = function (next_props, next_state) {
	            // This component definitely needs to update if it is marked as dirty
	            if (dirty_components[this.local_key] !== undefined) return true
	
	            // Otherwise, we'll check to see if its state or props
	            // have changed.  We can do so by simply serializing them
	            // and then comparing them.  But ignore React's 'children'
	            // prop, because it often has a circular reference.
	            next_props = clone(next_props); this_props = clone(this.props)
	            delete next_props['children']; delete this_props['children']
	
	            // console.assert(!_.isEqual([next_state, next_props], [this.state, this_props]) == JSON.stringify([next_state, next_props]) != JSON.stringify([this.state, this_props]), {next_state: next_state, next_props: next_props})
	            if (_)
	                return !_.isEqual([next_state, next_props], [this.state, this_props])
	            else 
	                return JSON.stringify([next_state, next_props]) != JSON.stringify([this.state, this_props])
	        }
	        
	        component.is_waiting = function () {
	            // Does this component depend on any keys that are being
	            // requested?
	            var dependent_keys = keys_4_component.get(this.local_key)
	            for (var i=0; i<dependent_keys.length; i++)
	                if (outstanding_fetches[dependent_keys[i]])
	                    return dependent_keys[i]
	            return false
	        }
	
	        window.waiting_for = function(obj_or_key) {
	            return !!outstanding_fetches[obj_or_key.key || obj_or_key]
	        }
	
	        // STEP 3: Configure the global function hooks for React
	        window.re_render = react_rerender
	        window.record_dependence = record_component_dependence
	
	        // Now create the actual React class with this definition, and
	        // return it.
	        var react_class = React.createFactory(createReactClass(component))
	        var result = function (props, children) {
	            props = props || {}
	            props.parents = execution_context.slice()
	            return react_class(props, children)
	        }
	        // Give it the same prototype as the original class so that it
	        // passes React.isValidClass() inspection
	        result.prototype = react_class.prototype
	        return result
	    }
	
	
	    // *****************
	    // Dependency-tracking for React components
	    var keys_4_component = new One_To_Many() // Maps component to its dependence keys
	    var components_4_key = new One_To_Many() // Maps key to its dependent components
	    function react_rerender (keys) {
	        // Re-renders only the components that depend on `keys'
	        // console.log('RENDERING BASED ON:', keys)
	        // First we determine the components that will need to be updated
	        for (var i = 0; i < keys.length; i++) {
	            affected_components = components_4_key.get(keys[i])
	            for (var j = 0; j < affected_components.length; j++)
	                dirty_components[affected_components[j]] = true
	        }
	
	        // Then we sweep through and update them
	        for (var comp_key in dirty_components){
	            // the check on both dirty_components and components is a PATCH
	            // for a possible inconsistency between dirty_components and components
	            // that occurs if a component has a componentWillUnmount method.
	            if (dirty_components[comp_key] && components[comp_key]){ // Since one component might update another
	                // console.log("\tREDO", comp_key, arest.components[comp_key], keys)
	                components[comp_key].forceUpdate()
	            }
	        }
	    }
	    function record_component_dependence(key) {
	        // Looks up current component from the execution context
	        if (execution_context.length > 0) {
	            var component = execution_context[execution_context.length-1]
	            keys_4_component.add(component, key)  // Track dependencies
	            components_4_key.add(key, component)  // both ways
	        }
	    }
	    function clear_component_dependencies(component) {
	        var depends_on_keys = keys_4_component.get(component)
	        for (var i=0; i<depends_on_keys.length; i++)
	            components_4_key.del(depends_on_keys[i], component)
	        keys_4_component.delAll(component)
	    }
	
	
	    // ****************
	    // Utility for React Components
	    window.add_cnt = {}
	    window.print_add_cnt = function(){
	        var my_keys = Object.keys(add_cnt);
	        var values = Object.values(add_cnt)
	        values = values.sort(function(a,b){return (b - a)})
	        sorted_keys = my_keys.sort(function(a,b){return parseInt(add_cnt[b]) - parseInt(add_cnt[a])})
	        var idx=0
	        for(var i=0; i < sorted_keys.length; i++){
	            key = sorted_keys[i]
	            console.log(key, add_cnt[key])
	            idx = idx + 1
	            if (idx > 100)
	                break
	        }
	    }
	    function One_To_Many() {
	        var hash = this.hash = Object.create(null)
	        this.get = function (k) { return Object.keys(hash[k] || {}) }
	        this.add = function (k, v) {
	            if (hash[k] === undefined)
	                hash[k] = Object.create(null)
	
	            // if (window.add_cnt[k + v] == undefined)
	            //     window.add_cnt[k+v] = 0 
	            // if (k == 'component/64' && v == '/subdomain')
	            //     console.trace()
	            // window.add_cnt[k+v] += 1
	            hash[k][v] = true
	        }
	        this.del = function (k, v) {
	            delete hash[k][v]
	        }
	        this.delAll = function (k) { hash[k] = Object.create(null) }
	    }
	    function Set() {
	        var hash = {}
	        this.add = function (a) { if (!hash[a]) hash[a] = true }
	        this.all = function () { return Object.keys(hash) }
	        this.clear = function () { hash = {} }
	    }
	
	
	    // ******************
	    // General utility funcs
	    function clone(obj) {
	        if (obj == null) return obj
	        var copy = obj.constructor()
	        for (var attr in obj)
	            if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr]
	        return copy
	    }
	    function extend(obj, with_obj) {
	        if (with_obj === undefined) return obj
	        for (var attr in with_obj)
	            if (!obj.hasOwnProperty(attr)) obj[attr] = with_obj[attr]
	        return obj
	    }
	    function deep_map(func, object) {
	        // This function isn't actually a full "deep map" yet.
	        // Limitations: It only applies func to OBJECTS (not arrays or
	        // atoms), and doesn't return anything.
	        if (Array.isArray(object))
	            for (var i=0; i < object.length; i++)
	                deep_map(func, object[i])
	        else if (typeof(object) === 'object' && object !== null) {
	            func(object)
	            for (var k in object)
	                deep_map(func, object[k])
	        }
	    }
	    function error(e, name) {
	        console.error('In', name + ':', e.stack)
	        if (window.on_client_error)
	            window.on_client_error(e)
	    }
	
	    function key_id(string) {
	        return string.match(/\/[^\/]+\/(-?\d+)/)[1]
	    }
	
	    // Camelcased API options
	    var updateCache=update_cache, serverFetch=server_fetch,
	        serverSave=server_save, serverDestroy=server_destroy
	
	    // Export the public API
	    window.ReactiveComponent = ReactiveComponent
	    window.fetch = fetch
	    window.save = save
	    window.destroy = destroy
	
	    // Make the private methods accessible under "window.arest"
	    vars = [['cache', cache], ['fetch',fetch], ['save',save], ['server_fetch', server_fetch], ['serverFetch', serverFetch], ['server_save', server_save], ['serverSave',serverSave], ['update_cache',update_cache], ['updateCache',updateCache], ['csrf',csrf], ['keys_4_component',keys_4_component], ['components_4_key', components_4_key], ['components',components], ['execution_context',execution_context], ['One_To_Many',One_To_Many], ['clone',clone], ['dirty_components', dirty_components], ['affected_keys',affected_keys], ['clear_matching_objects',clear_matching_objects], ['deep_map', deep_map], ['key_id', key_id], ['pending_saves', pending_saves], ['outstanding_fetches', outstanding_fetches]]
	    window.arest = {}
	    for (var i=0; i<vars.length; i++)
	        window.arest[vars[i][0]] = vars[i][1]
	
	})()


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var cached_anonymous_avatars, cached_avatars, colors_used, createCompositeGroupIcon, createFallbackIcon, createUserIcon, create_avatar, create_pixelated_avatar, group_colored_icons, icon_cache, loaded_images, missing_images, my_question_mark_icon, props_to_strip, question_mark_icon, user_name, users2images,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	__webpack_require__(1);
	
	__webpack_require__(10);
	
	__webpack_require__(2);
	
	__webpack_require__(6);
	
	window.avatarUrl = function(user, img_size) {
	  var app;
	  user = fetch(user);
	  if (user.avatar_file_name.endsWith('svg')) {
	    img_size = 'original';
	  }
	  if (!!user.avatar_file_name) {
	    app = arest.cache['/application'] || fetch('/application');
	    return (app.asset_host || '') + "/system/avatars/" + ((user.key.split('/')[2]) + "/" + img_size + "/" + user.avatar_file_name);
	  } else {
	    return null;
	  }
	};
	
	window.user_is_organization_account = function(user) {
	  var ref;
	  return ref = user.key || user, indexOf.call(customization('organizational_account') || [], ref) >= 0;
	};
	
	window.anonymous_label = function() {
	  return translator('anonymous', 'Anonymous');
	};
	
	user_name = function(user, anon) {
	  user = fetch(user);
	  if (!user.name || user.name.trim().length === 0) {
	    return anonymous_label();
	  } else {
	    return user.name;
	  }
	};
	
	window.AvatarPopover = ReactiveComponent({
	  displayName: 'AvatarPopover',
	  render: function() {
	    var alt, anon, anonymous, attribute, attributes, cnt, grouped_by, has_opinion, inclusions, is_grouped, name, o_trans, opinion, opinion_views, pixelate_anon_current_user, point, reason, reasons_trans, ref, stance, toggle_reasons, unreported, user, user_val, val;
	    ref = this.props, user = ref.user, anon = ref.anon, opinion = ref.opinion;
	    user = fetch(user);
	    anonymous = arest.key_id(user.key) < 0 || anon || customization('anonymize_permanently');
	    opinion_views = fetch('opinion_views');
	    name = user_name(user, anonymous);
	    has_opinion = opinion != null;
	    if (has_opinion) {
	      opinion = fetch(opinion);
	      stance = opinion.stance;
	      if (stance > .01) {
	        alt = ((stance * 100).toFixed(0)) + "%";
	      } else if (stance < -.01) {
	        alt = "–" + ((stance * -100).toFixed(0)) + "%";
	      } else {
	        alt = translator("engage.histogram.user_is_neutral", "is neutral");
	      }
	      anonymous || (anonymous = opinion.hide_name);
	    }
	    pixelate_anon_current_user = user.key === fetch('/current_user').user && anonymous;
	    return DIV({
	      style: {
	        padding: '8px 4px',
	        position: 'relative',
	        maxWidth: "min(80vw, 800px)"
	      }
	    }, DIV({
	      style: {
	        display: 'flex'
	      }
	    }, user.avatar_file_name ? IMG({
	      alt: this.props.alt || alt || ("Image of " + (anonymous ? 'Image of an anonymous user "#{user.name}"' : user.name)),
	      className: pixelate_anon_current_user ? 'pixelated-avatar' : void 0,
	      style: {
	        width: 120,
	        height: 120,
	        borderRadius: '50%',
	        marginRight: 24,
	        display: 'inline-block',
	        filter: pixelate_anon_current_user ? "blur(" + (.025 * 120) + "px)" : void 0
	      },
	      src: anonymous && !pixelate_anon_current_user ? user.avatar_file_name : avatarUrl(user, 'large')
	    }) : void 0, DIV(null, DIV({
	      style: {
	        letterSpacing: -1,
	        fontSize: 18,
	        fontWeight: 'bold'
	      }
	    }, name), pixelate_anon_current_user ? I(null, your_opinion_i18n.anon_assurance()) : void 0, (typeof get_participant_attributes !== "undefined" && get_participant_attributes !== null) && !anonymous && !user_is_organization_account(user) ? (attributes = get_participant_attributes(), grouped_by = opinion_views.active_views.group_by, unreported = missing_attribute_info_label(), UL({
	      style: {
	        listStyle: 'none',
	        marginTop: 4
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = attributes.length; i < len; i++) {
	        attribute = attributes[i];
	        is_grouped = grouped_by && grouped_by.name === attribute.name;
	        if (attribute.pass) {
	          user_val = attribute.pass(user);
	          if (user_val == null) {
	            user_val = unreported;
	          }
	          if (typeof user_val === "string" && (user_val != null ? user_val.indexOf(CHECKLIST_SEPARATOR > -1) : void 0)) {
	            user_val = user_val.split(CHECKLIST_SEPARATOR);
	          } else {
	            user_val = ["" + user_val];
	          }
	        } else {
	          user_val = user.tags[attribute.key];
	          if (user_val == null) {
	            user_val = unreported;
	          }
	          if (typeof user_val === "string" && (user_val != null ? user_val.indexOf(CHECKLIST_SEPARATOR > -1) : void 0)) {
	            user_val = user_val.split(CHECKLIST_SEPARATOR);
	          } else if (is_grouped) {
	            user_val = [user_val];
	          }
	        }
	        if (!is_grouped && !user_val) {
	          continue;
	        }
	        results.push(LI({
	          key: attribute.name,
	          style: {
	            padding: '3px 0'
	          }
	        }, DIV({
	          key: 'attribute name',
	          style: {
	            fontSize: 14,
	            fontStyle: 'italic'
	          }
	        }, attribute.name), (function() {
	          var j, len1, results1;
	          results1 = [];
	          for (j = 0, len1 = user_val.length; j < len1; j++) {
	            val = user_val[j];
	            results1.push(SPAN({
	              key: val || unreported,
	              style: {
	                fontSize: 14,
	                backgroundColor: is_grouped ? get_color_for_group(val || unreported) : void 0,
	                color: is_grouped ? 'white' : void 0,
	                display: 'inline-block',
	                marginRight: 8,
	                padding: is_grouped ? '2px 8px' : void 0
	              }
	            }, val || unreported));
	          }
	          return results1;
	        })()));
	      }
	      return results;
	    })())) : void 0)), has_opinion ? (inclusions = opinion.point_inclusions || [], cnt = inclusions.length, toggle_reasons = (function(_this) {
	      return function(e) {
	        var popover;
	        _this.local.show_reasons = !_this.local.show_reasons;
	        save(_this.local);
	        popover = fetch('popover');
	        popover.hide_triangle = _this.local.show_reasons;
	        save(popover);
	        e.stopPropagation();
	        return e.preventDefault();
	      };
	    })(this), o_trans = translator('opinion', 'Opinion'), reasons_trans = translator({
	      id: 'avatar_popover.reason_count',
	      cnt: cnt
	    }, '{cnt, plural, one {# reason} other {# reasons}} given'), DIV({
	      style: {
	        marginTop: 8
	      }
	    }, DIV({
	      style: {
	        fontWeight: 'bold',
	        textAlign: 'center'
	      }
	    }, o_trans + ": " + alt + " • " + reasons_trans, cnt > 0 ? BUTTON({
	      tabIndex: 1,
	      className: 'like_link',
	      style: {
	        paddingLeft: 8
	      },
	      onClick: toggle_reasons
	    }, this.local.show_reasons ? translator('avatar_popover.hide_reasons', 'Hide reasons') : translator('avatar_popover.show_reasons', 'Show reasons')) : void 0), this.local.show_reasons ? UL({
	      style: {
	        listStyle: 'none',
	        margin: '12px auto'
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = inclusions.length; i < len; i++) {
	        reason = inclusions[i];
	        point = fetch(reason);
	        results.push(LI({
	          style: {
	            paddingTop: 12,
	            maxWidth: 450,
	            borderRadius: 16,
	            padding: '0.5em 16px',
	            backgroundColor: '#f6f7f9',
	            boxShadow: '#b5b5b5 0 1px 1px 0px',
	            margin: '0px 16px 12px 16px'
	          }
	        }, SPAN({
	          style: {
	            textTransform: 'uppercase',
	            color: '#555',
	            paddingRight: 8
	          }
	        }, point.is_pro ? get_point_label('pro') : get_point_label('con'), ':'), SPAN({
	          style: {}
	        }, point.nutshell), SPAN({
	          style: {
	            fontStyle: 'italic',
	            marginLeft: 12
	          }
	        }, "~ " + (fetch(point.user).name))));
	      }
	      return results;
	    })()) : void 0)) : void 0);
	  }
	});
	
	props_to_strip = ['user', 'anonymous', 'set_bg_color', 'custom_bg_color', 'hide_popover', 'parents', 'img_size'];
	
	window.avatar = function(user, props) {
	  var alt, anonymous, attrs, classes, i, img_size, k, len, name, prop_to_strip, ref, ref1, ref2, src, style, v;
	  attrs = _.clone(props);
	  if (!user.key) {
	    if (user === ((ref = arest.cache['/current_user']) != null ? ref.user : void 0)) {
	      user = fetch(user);
	    } else if (arest.cache[user]) {
	      user = arest.cache[user];
	    } else {
	      fetch(user);
	      return SPAN(null);
	    }
	  }
	  style = {};
	  if (attrs.style) {
	    ref1 = attrs.style;
	    for (k in ref1) {
	      v = ref1[k];
	      style[k] = v;
	    }
	  }
	  anonymous = attrs.anonymous || (user && arest.key_id(user.key) < 0) || customization('anonymize_permanently');
	  src = null;
	  if (!attrs.custom_bg_color && user.avatar_file_name) {
	    if ((style != null ? style.width : void 0) >= 50) {
	      img_size = 'large';
	    } else {
	      img_size = attrs.img_size || 'small';
	    }
	    if (anonymous && user.avatar_file_name.indexOf('/') > -1) {
	      src = user.avatar_file_name;
	    } else {
	      src = avatarUrl(user, img_size);
	    }
	    style.backgroundColor = 'white';
	  } else if (attrs.set_bg_color && !attrs.custom_bg_color) {
	    if (user.bg_color == null) {
	      user.bg_color = hsv2rgb(Math.random() / 5 + .6, Math.random() / 8 + .025, Math.random() / 4 + .4);
	    }
	    style.backgroundColor = user.bg_color;
	  }
	  name = user_name(user, anonymous);
	  if (attrs.alt) {
	    alt = attrs.alt.replace('<user>', name);
	  } else {
	    alt = name;
	  }
	  classes = "avatar" + (attrs.className ? ' ' + attrs.className : '');
	  if (anonymous) {
	    if (user.key === ((ref2 = arest.cache['/current_user']) != null ? ref2.user : void 0)) {
	      classes += " pixelated-avatar";
	      style.filter = "blur(" + (.025 * (style.width || 50)) + "px)";
	    }
	  }
	  attrs = _.extend(attrs, {
	    key: user.key,
	    className: classes,
	    'data-user': user.key,
	    'data-popover': !props.hide_popover && !anonymous && !screencasting() ? alt : void 0,
	    'data-tooltip': anonymous ? alt : void 0,
	    'data-anon': anonymous,
	    tabIndex: props.focusable ? 0 : -1,
	    width: style != null ? style.width : void 0,
	    height: style != null ? style.width : void 0,
	    style: style
	  });
	  for (i = 0, len = props_to_strip.length; i < len; i++) {
	    prop_to_strip = props_to_strip[i];
	    if (prop_to_strip in attrs) {
	      delete attrs[prop_to_strip];
	    }
	  }
	  if (src) {
	    attrs.src = src;
	    return IMG(attrs);
	  } else {
	    return SPAN(attrs);
	  }
	};
	
	window.Avatar = ReactiveComponent({
	  displayName: 'Avatar',
	  render: function() {
	    return avatar(this.data(), this.props);
	  }
	});
	
	styles += ".avatar {\n  position: relative; /* for containing the :after image */\n  border: none;\n  display: inline-block;\n  margin: 0;\n  padding: 0;\n  border-radius: 50%;\n  background-size: cover;\n  background-color: " + default_avatar_in_histogram_color + "; \n  transition: width 750ms, height 750ms, transform 750ms, background-color 750ms, opacity 50ms;\n  user-select: none; \n  -moz-user-select: none; \n  -webkit-user-select: none;\n  -ms-user-select: none;\n}\n\n/* for styling icon of broken images */\nimg.avatar:after { \n  position: absolute;\n  z-index: 2;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #f7954c; \n  border-radius: 50%;\n  content: \"\";\n}\n\n\n.pixelated-avatar::before {\n  content: \"?\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: black;\n  font-size: 24px;\n  font-weight: bold;\n}\n";
	
	cached_avatars = {};
	
	cached_anonymous_avatars = {};
	
	missing_images = {};
	
	loaded_images = {};
	
	users2images = {};
	
	window.getCanvasAvatar = function(user, anonymous) {
	  var key, ref;
	  if (anonymous == null) {
	    anonymous = false;
	  }
	  key = user.key || user;
	  if (anonymous && key === ((ref = arest.cache['/current_user']) != null ? ref.user : void 0)) {
	    if (key in cached_avatars) {
	      if (!(key in cached_anonymous_avatars)) {
	        cached_anonymous_avatars[key] = create_pixelated_avatar(cached_avatars[key]);
	      }
	      return cached_anonymous_avatars[key];
	    } else {
	      return cached_avatars["default"];
	    }
	  }
	  return cached_avatars[key] || cached_avatars["default"];
	};
	
	colors_used = {};
	
	window.createHitRegionAvatar = function(user) {
	  var b, color, g, r;
	  while ((color == null) || color in colors_used) {
	    r = Math.round(Math.random() * 255);
	    g = Math.round(Math.random() * 255);
	    b = Math.round(Math.random() * 255);
	    color = "rgb(" + r + "," + g + "," + b + ")";
	  }
	  colors_used[color] = true;
	  user.hit_region_color = color;
	  return createUserIcon(user.hit_region_color);
	};
	
	group_colored_icons = {};
	
	window.getGroupIcon = function(key, color) {
	  if (!(key in group_colored_icons)) {
	    group_colored_icons[key] = createUserIcon(color);
	  }
	  return group_colored_icons[key];
	};
	
	icon_cache = {};
	
	createUserIcon = function(fill) {
	  var canv, ctx, rx;
	  if (fill in icon_cache) {
	    return icon_cache[fill];
	  }
	  canv = document.createElement('canvas');
	  canv.width = canv.height = 50 * window.devicePixelRatio;
	  rx = canv.width / 2;
	  ctx = canv.getContext("2d");
	  ctx.arc(rx, rx, rx, 0, 2 * Math.PI);
	  ctx.fillStyle = fill;
	  ctx.fill();
	  icon_cache[fill] = canv;
	  return canv;
	};
	
	window.getCompositeGroupIcon = function(key, groups, colors) {
	  if (!(key in group_colored_icons)) {
	    group_colored_icons[key] = createCompositeGroupIcon(groups, colors);
	  }
	  return group_colored_icons[key];
	};
	
	createCompositeGroupIcon = function(groups, colors) {
	  var canv, color, ctx, group, i, idx, len, num, rx;
	  num = groups.length;
	  canv = document.createElement('canvas');
	  canv.width = canv.height = 50 * window.devicePixelRatio;
	  rx = canv.width / 2;
	  ctx = canv.getContext("2d");
	  for (idx = i = 0, len = groups.length; i < len; idx = ++i) {
	    group = groups[idx];
	    color = colors[group];
	    ctx.beginPath();
	    ctx.moveTo(rx, rx);
	    ctx.arc(rx, rx, rx, idx * 2 * Math.PI / num, (idx + 1) * 2 * Math.PI / num);
	    ctx.fillStyle = color;
	    ctx.fill();
	  }
	  return canv;
	};
	
	createFallbackIcon = function(user) {
	  var h, s, v;
	  if (user.bg_color == null) {
	    h = Math.random() / 5 + .6;
	    s = Math.random() / 8 + .025;
	    v = Math.random() / 4 + .4;
	    h = Math.round(h * 15) / 15;
	    s = Math.round(s * 15) / 15;
	    v = Math.round(v * 15) / 15;
	    user.bg_color = hsv2rgb(h, s, v);
	  }
	  return createUserIcon(user.bg_color);
	};
	
	create_avatar = function(img, clip) {
	  var canv, ctx;
	  if (clip == null) {
	    clip = true;
	  }
	  canv = document.createElement('canvas');
	  canv.width = img.width;
	  canv.height = img.height;
	  ctx = canv.getContext('2d');
	  if (clip) {
	    ctx.arc(img.width / 2, img.height / 2, img.height / 2, 0, Math.PI * 2);
	    ctx.clip();
	  }
	  ctx.drawImage(img, 0, 0);
	  canv.original_image = img;
	  return canv;
	};
	
	create_pixelated_avatar = function(canv, showQuestionMarkOverlay) {
	  var anon_canv, ctx, h, pixelSize, size, tempCanvas, tempCtx, w;
	  if (showQuestionMarkOverlay == null) {
	    showQuestionMarkOverlay = false;
	  }
	  if (!canv.original_image) {
	    return cached_avatars["default"];
	  }
	  anon_canv = create_avatar(canv.original_image, false);
	  w = anon_canv.width;
	  h = anon_canv.height;
	  ctx = anon_canv.getContext('2d');
	  pixelSize = w / 10;
	  tempCanvas = document.createElement('canvas');
	  tempCanvas.width = w / pixelSize;
	  tempCanvas.height = h / pixelSize;
	  tempCtx = tempCanvas.getContext('2d');
	  tempCtx.imageSmoothingEnabled = false;
	  tempCtx.drawImage(anon_canv, 0, 0, w / pixelSize, h / pixelSize);
	  ctx.drawImage(tempCanvas, 0, 0, w / pixelSize, h / pixelSize, 0, 0, w, h);
	  if (showQuestionMarkOverlay) {
	    size = w / 2;
	    ctx.drawImage(my_question_mark_icon, w / 2 - size / 2, h / 2 - size / 2, size, size);
	  }
	  canv = document.createElement('canvas');
	  canv.width = w;
	  canv.height = h;
	  ctx = canv.getContext('2d');
	  ctx.arc(w / 2, h / 2, h / 2, 0, Math.PI * 2);
	  ctx.clip();
	  ctx.drawImage(anon_canv, 0, 0);
	  return canv;
	};
	
	question_mark_icon = function() {
	  var iconHeight, iconWidth, path1, qm_canv, qm_ctx, svgPath1;
	  iconWidth = 24;
	  iconHeight = 24;
	  qm_canv = document.createElement('canvas');
	  qm_canv.width = iconWidth;
	  qm_canv.height = iconHeight;
	  qm_ctx = qm_canv.getContext('2d');
	  svgPath1 = "M9.11241 7.82201C9.44756 6.83666 10.5551 6 12 6C13.7865 6 15 7.24054 15 8.5C15 9.75946 13.7865 11 12 11C11.4477 11 11 11.4477 11 12L11 14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14L13 12.9082C15.203 12.5001 17 10.7706 17 8.5C17 5.89347 14.6319 4 12 4C9.82097 4 7.86728 5.27185 7.21894 7.17799C7.0411 7.70085 7.3208 8.26889 7.84366 8.44673C8.36653 8.62458 8.93457 8.34488 9.11241 7.82201ZM12 20C12.8285 20 13.5 19.3284 13.5 18.5C13.5 17.6716 12.8285 17 12 17C11.1716 17 10.5 17.6716 10.5 18.5C10.5 19.3284 11.1716 20 12 20Z";
	  qm_ctx.fillStyle = 'black';
	  qm_ctx.strokeStyle = 'white';
	  qm_ctx.lineWidth = 1;
	  path1 = new Path2D(svgPath1);
	  qm_ctx.fill(path1);
	  qm_ctx.stroke(path1);
	  return qm_canv;
	};
	
	my_question_mark_icon = question_mark_icon();
	
	window.LoadAvatars = ReactiveComponent({
	  displayName: "LoadAvatars",
	  render: function() {
	    var loading, users;
	    users = fetch('/users');
	    loading = fetch('avatar_loading');
	    return SPAN(null);
	  },
	  load: function() {
	    var all_users, app, avatars_to_load, current_user, i, id, img, img_url, len, loading, name1, pic, ref, results, user, users;
	    users = fetch('/users');
	    current_user = fetch('/current_user');
	    if (!users.users || fetch('location').url.match('/dashboard')) {
	      return;
	    }
	    loading = fetch('avatar_loading');
	    app = arest.cache['/application'] || fetch('/application');
	    avatars_to_load = {};
	    all_users = users.users.slice() || [];
	    if (ref = current_user.user, indexOf.call(all_users, ref) < 0) {
	      all_users.push(current_user.user);
	    }
	    if (!cached_avatars["default"]) {
	      cached_avatars["default"] = createFallbackIcon({
	        key: 'default'
	      });
	    }
	    for (i = 0, len = all_users.length; i < len; i++) {
	      user = all_users[i];
	      user = fetch(user);
	      id = arest.key_id(user.key);
	      if (user.avatar_file_name) {
	        if (id < 0) {
	          img_url = user.avatar_file_name;
	        } else {
	          img_url = avatarUrl(user, 'large');
	        }
	        if ((users2images[user.key] !== img_url || !(img_url in loaded_images)) && !(img_url in missing_images)) {
	          if (avatars_to_load[img_url] == null) {
	            avatars_to_load[img_url] = [];
	          }
	          avatars_to_load[img_url].push(user);
	          users2images[user.key] = img_url;
	        }
	      }
	      if (cached_avatars[name1 = user.key] == null) {
	        cached_avatars[name1] = createFallbackIcon(user);
	      }
	    }
	    if (Object.keys(avatars_to_load).length > 0) {
	      if (!loading.loading) {
	        loading.loading = true;
	        save(loading);
	        this.loading_cnt = 0;
	        results = [];
	        for (img in avatars_to_load) {
	          users = avatars_to_load[img];
	          this.loading_cnt += 1;
	          pic = new Image();
	          pic.onload = (function(_this) {
	            return function(img, users, pic) {
	              return function() {
	                var cached_avatar, j, len1, u;
	                cached_avatar = create_avatar(pic);
	                for (j = 0, len1 = users.length; j < len1; j++) {
	                  user = users[j];
	                  loaded_images[img] = cached_avatars[user.key] = cached_avatar;
	                }
	                _this.loading_cnt -= 1;
	                if (_this.loading_cnt === 0) {
	                  loading.loading = false;
	                  loading.loaded = murmurhash((JSON.stringify(Object.keys(loaded_images))) + "-" + (JSON.stringify((function() {
	                    var l, len2, results1;
	                    results1 = [];
	                    for (l = 0, len2 = avatars_to_load.length; l < len2; l++) {
	                      u = avatars_to_load[l];
	                      results1.push(u.name);
	                    }
	                    return results1;
	                  })())), 0);
	                  return save(loading);
	                }
	              };
	            };
	          })(this)(img, users, pic);
	          pic.onerror = (function(_this) {
	            return function(user) {
	              return function() {
	                _this.loading_cnt -= 1;
	                return missing_images[user.avatar_file_name] = 1;
	              };
	            };
	          })(this)(user);
	          results.push(pic.src = img);
	        }
	        return results;
	      } else {
	        return setTimeout(this.load, 10);
	      }
	    }
	  },
	  componentDidMount: function() {
	    return this.load();
	  },
	  componentDidUpdate: function() {
	    return this.load();
	  }
	});


/***/ },
/* 15 */
/***/ function(module, exports) {

	var golden_ratio_conjugate, hsp_sample_size;
	
	window.focus_blue = '#456ae4';
	
	window.logo_red = "#B03A44";
	
	window.considerit_red = "#df6264";
	
	window.default_avatar_in_histogram_color = '#999';
	
	window.considerit_gray = '#f6f7f9';
	
	window.selected_color = '#DA4570';
	
	window.upgrade_color = '#16a1e3';
	
	window.attention_orange = "#fb7e26";
	
	window.main_background_color = '#f6f7f9';
	
	if (location.href.indexOf('aeroparticipa') > -1) {
	  window.focus_blue = "#073682";
	  window.selected_color = focus_blue;
	}
	
	window.parseCssRgb = function(css_color_str) {
	  var rgb, test;
	  test = document.createElement('div');
	  test.style.color = css_color_str;
	  css_color_str = test.style.color;
	  if (css_color_str === 'transparent') {
	    return {
	      r: 0,
	      g: 0,
	      b: 0,
	      a: 0
	    };
	  } else {
	    rgb = /^rgba?\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+),?\s*([\.\d]+)?\s*\)$/i.exec(css_color_str);
	    if (rgb) {
	      return {
	        r: parseInt(rgb[1]),
	        g: parseInt(rgb[2]),
	        b: parseInt(rgb[3]),
	        a: rgb.length > 4 && (rgb[4] != null) ? parseFloat(rgb[4]) : 1
	      };
	    } else {
	      console.error("Color " + css_color_str + " could not be parsed");
	      return {
	        r: 0,
	        g: 0,
	        b: 0
	      };
	    }
	  }
	};
	
	window.parseCssHsl = function(css_color_str) {
	  var rgb;
	  rgb = parseCssRgb(css_color_str);
	  return rgb2hsl(rgb);
	};
	
	window.rgb2hsl = function(rgb) {
	  var b, d, g, h, l, max, min, r, s;
	  r = rgb.r / 255;
	  g = rgb.g / 255;
	  b = rgb.b / 255;
	  max = Math.max(r, g, b);
	  min = Math.min(r, g, b);
	  l = (max + min) / 2;
	  if (max === min) {
	    h = s = 0;
	  } else {
	    d = max - min;
	    s = (l > 0.5 ? d / (2 - max - min) : d / (max + min));
	    switch (max) {
	      case r:
	        h = (g - b) / d + (g < b ? 6 : 0);
	        break;
	      case g:
	        h = (b - r) / d + 2;
	        break;
	      case b:
	        h = (r - g) / d + 4;
	    }
	    h /= 6;
	  }
	  return {
	    h: h,
	    s: s,
	    l: l
	  };
	};
	
	window.hsv2rgb = function(h, s, v, as_array) {
	  var b, f, g, h_i, p, q, r, ref, ref1, ref2, ref3, ref4, ref5, t;
	  h_i = Math.floor(h * 6);
	  f = h * 6 - h_i;
	  p = v * (1 - s);
	  q = v * (1 - f * s);
	  t = v * (1 - (1 - f) * s);
	  if (h_i === 0) {
	    ref = [v, t, p], r = ref[0], g = ref[1], b = ref[2];
	  }
	  if (h_i === 1) {
	    ref1 = [q, v, p], r = ref1[0], g = ref1[1], b = ref1[2];
	  }
	  if (h_i === 2) {
	    ref2 = [p, v, t], r = ref2[0], g = ref2[1], b = ref2[2];
	  }
	  if (h_i === 3) {
	    ref3 = [p, q, v], r = ref3[0], g = ref3[1], b = ref3[2];
	  }
	  if (h_i === 4) {
	    ref4 = [t, p, v], r = ref4[0], g = ref4[1], b = ref4[2];
	  }
	  if (h_i === 5) {
	    ref5 = [v, p, q], r = ref5[0], g = ref5[1], b = ref5[2];
	  }
	  if (as_array) {
	    return [r, g, b];
	  } else {
	    return "rgb(" + (Math.round(r * 256)) + ", " + (Math.round(g * 256)) + ", " + (Math.round(b * 256)) + ")";
	  }
	};
	
	window.addOpacity = function(color, opacity) {
	  var c;
	  c = parseCssRgb(color);
	  return "rgba(" + c.r + "," + c.g + "," + c.b + "," + opacity;
	};
	
	golden_ratio_conjugate = 0.618033988749895;
	
	window.getNiceRandomHues = function(num, seed) {
	  var h, hues, i;
	  h = seed || .5;
	  hues = [];
	  i = num;
	  while (i > 0) {
	    hues.push(h % 1);
	    h += golden_ratio_conjugate;
	    i -= 1;
	  }
	  return hues;
	};
	
	window.getColors = function(num, continuous) {
	  var colors, group_colors, hue, hues, idx, inc, j, k, len, ref;
	  if (continuous) {
	    group_colors = [];
	    inc = 1 / (num + 1);
	    colors = group_colors;
	    for (idx = j = 0, ref = num - 1; 0 <= ref ? j <= ref : j >= ref; idx = 0 <= ref ? ++j : --j) {
	      hue = inc * idx;
	      group_colors.push(hsv2rgb(hue, .75, .65));
	    }
	  } else if (num >= 3 && num <= 12) {
	    if (num <= 5) {
	      group_colors = colorbrewer.Set1[num];
	    } else if (num <= 8) {
	      group_colors = colorbrewer.Dark2[num];
	    } else {
	      group_colors = colorbrewer.Paired[num];
	    }
	  } else {
	    group_colors = [];
	    hues = getNiceRandomHues(num);
	    colors = group_colors;
	    for (idx = k = 0, len = hues.length; k < len; idx = ++k) {
	      hue = hues[idx];
	      group_colors.push(hsv2rgb(hue, Math.random() / 2 + .5, Math.random() / 2 + .5));
	    }
	  }
	  return group_colors;
	};
	
	window.is_light_background = function(color) {
	  var ref;
	  color || (color = fetch('edit_banner').background_css || ((ref = customization('banner')) != null ? ref.background_css : void 0) || DEFAULT_BACKGROUND_COLOR);
	  if (color in named_colors) {
	    color = named_colors[color];
	  }
	  return parseCssHsl(color).l > .75;
	};
	
	hsp_sample_size = 100;
	
	window.is_image_mostly_light = function(image_data, width, height) {
	  var b, col, col_sample, g, hsp, j, k, len, len1, light_pixels, r, row, row_sample, start;
	  row_sample = _.sample(_.range(height), hsp_sample_size);
	  light_pixels = 0;
	  for (j = 0, len = row_sample.length; j < len; j++) {
	    row = row_sample[j];
	    col_sample = _.sample(_.range(width), hsp_sample_size);
	    for (k = 0, len1 = col_sample.length; k < len1; k++) {
	      col = col_sample[k];
	      start = row * (width * 4) + col * 4;
	      r = image_data[start];
	      g = image_data[start + 1];
	      b = image_data[start + 2];
	      hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
	      if (hsp > 127.5) {
	        light_pixels += 1;
	      }
	    }
	  }
	  return light_pixels >= hsp_sample_size * hsp_sample_size / 2;
	};
	
	window.named_colors = {
	  'aliceblue': '#f0f8ff',
	  'antiquewhite': '#faebd7',
	  'aqua': '#00ffff',
	  'aquamarine': '#7fffd4',
	  'azure': '#f0ffff',
	  'beige': '#f5f5dc',
	  'bisque': '#ffe4c4',
	  'black': '#000000',
	  'blanchedalmond': '#ffebcd',
	  'blue': '#0000ff',
	  'blueviolet': '#8a2be2',
	  'brown': '#a52a2a',
	  'burlywood': '#deb887',
	  'cadetblue': '#5f9ea0',
	  'chartreuse': '#7fff00',
	  'chocolate': '#d2691e',
	  'coral': '#ff7f50',
	  'cornflowerblue': '#6495ed',
	  'cornsilk': '#fff8dc',
	  'crimson': '#dc143c',
	  'cyan': '#00ffff',
	  'darkblue': '#00008b',
	  'darkcyan': '#008b8b',
	  'darkgoldenrod': '#b8860b',
	  'darkgray': '#a9a9a9',
	  'darkgreen': '#006400',
	  'darkkhaki': '#bdb76b',
	  'darkmagenta': '#8b008b',
	  'darkolivegreen': '#556b2f',
	  'darkorange': '#ff8c00',
	  'darkorchid': '#9932cc',
	  'darkred': '#8b0000',
	  'darksalmon': '#e9967a',
	  'darkseagreen': '#8fbc8f',
	  'darkslateblue': '#483d8b',
	  'darkslategray': '#2f4f4f',
	  'darkturquoise': '#00ced1',
	  'darkviolet': '#9400d3',
	  'deeppink': '#ff1493',
	  'deepskyblue': '#00bfff',
	  'dimgray': '#696969',
	  'dodgerblue': '#1e90ff',
	  'firebrick': '#b22222',
	  'floralwhite': '#fffaf0',
	  'forestgreen': '#228b22',
	  'fuchsia': '#ff00ff',
	  'gainsboro': '#dcdcdc',
	  'ghostwhite': '#f8f8ff',
	  'gold': '#ffd700',
	  'goldenrod': '#daa520',
	  'gray': '#808080',
	  'green': '#008000',
	  'greenyellow': '#adff2f',
	  'honeydew': '#f0fff0',
	  'hotpink': '#ff69b4',
	  'indianred ': '#cd5c5c',
	  'indigo': '#4b0082',
	  'ivory': '#fffff0',
	  'khaki': '#f0e68c',
	  'lavender': '#e6e6fa',
	  'lavenderblush': '#fff0f5',
	  'lawngreen': '#7cfc00',
	  'lemonchiffon': '#fffacd',
	  'lightblue': '#add8e6',
	  'lightcoral': '#f08080',
	  'lightcyan': '#e0ffff',
	  'lightgoldenrodyellow': '#fafad2',
	  'lightgrey': '#d3d3d3',
	  'lightgreen': '#90ee90',
	  'lightpink': '#ffb6c1',
	  'lightsalmon': '#ffa07a',
	  'lightseagreen': '#20b2aa',
	  'lightskyblue': '#87cefa',
	  'lightslategray': '#778899',
	  'lightsteelblue': '#b0c4de',
	  'lightyellow': '#ffffe0',
	  'lime': '#00ff00',
	  'limegreen': '#32cd32',
	  'linen': '#faf0e6',
	  'magenta': '#ff00ff',
	  'maroon': '#800000',
	  'mediumaquamarine': '#66cdaa',
	  'mediumblue': '#0000cd',
	  'mediumorchid': '#ba55d3',
	  'mediumpurple': '#9370d8',
	  'mediumseagreen': '#3cb371',
	  'mediumslateblue': '#7b68ee',
	  'mediumspringgreen': '#00fa9a',
	  'mediumturquoise': '#48d1cc',
	  'mediumvioletred': '#c71585',
	  'midnightblue': '#191970',
	  'mintcream': '#f5fffa',
	  'mistyrose': '#ffe4e1',
	  'moccasin': '#ffe4b5',
	  'navajowhite': '#ffdead',
	  'navy': '#000080',
	  'oldlace': '#fdf5e6',
	  'olive': '#808000',
	  'olivedrab': '#6b8e23',
	  'orange': '#ffa500',
	  'orangered': '#ff4500',
	  'orchid': '#da70d6',
	  'palegoldenrod': '#eee8aa',
	  'palegreen': '#98fb98',
	  'paleturquoise': '#afeeee',
	  'palevioletred': '#d87093',
	  'papayawhip': '#ffefd5',
	  'peachpuff': '#ffdab9',
	  'peru': '#cd853f',
	  'pink': '#ffc0cb',
	  'plum': '#dda0dd',
	  'powderblue': '#b0e0e6',
	  'purple': '#800080',
	  'rebeccapurple': '#663399',
	  'red': '#ff0000',
	  'rosybrown': '#bc8f8f',
	  'royalblue': '#4169e1',
	  'saddlebrown': '#8b4513',
	  'salmon': '#fa8072',
	  'sandybrown': '#f4a460',
	  'seagreen': '#2e8b57',
	  'seashell': '#fff5ee',
	  'sienna': '#a0522d',
	  'silver': '#c0c0c0',
	  'skyblue': '#87ceeb',
	  'slateblue': '#6a5acd',
	  'slategray': '#708090',
	  'snow': '#fffafa',
	  'springgreen': '#00ff7f',
	  'steelblue': '#4682b4',
	  'tan': '#d2b48c',
	  'teal': '#008080',
	  'thistle': '#d8bfd8',
	  'tomato': '#ff6347',
	  'turquoise': '#40e0d0',
	  'violet': '#ee82ee',
	  'wheat': '#f5deb3',
	  'white': '#ffffff',
	  'whitesmoke': '#f5f5f5',
	  'yellow': '#ffff00',
	  'yellowgreen': '#9acd32'
	};


/***/ },
/* 16 */
/***/ function(module, exports) {

	window.passes_tags = function(user, tags) {
	  var i, len, passes, ref, ref1, ref2, tag;
	  if (typeof tags === 'string') {
	    tags = [tags];
	  }
	  user = fetch(user);
	  passes = true;
	  for (i = 0, len = tags.length; i < len; i++) {
	    tag = tags[i];
	    passes && (passes = !!((user != null ? (ref = user.tags) != null ? ref[tag] : void 0 : void 0) && !((ref1 = ("" + (user != null ? (ref2 = user.tags) != null ? ref2[tag] : void 0 : void 0)).toLowerCase()) === 'no' || ref1 === 'No' || ref1 === 'False' || ref1 === 'false' || ref1 === false)));
	  }
	  return passes;
	};
	
	window.passes_tag_filter = function(user, tag, regex) {
	  var ref, ref1;
	  user = fetch(user);
	  return !!(user != null ? (ref = user.tags) != null ? (ref1 = ref[tag]) != null ? ref1.match(regex) : void 0 : void 0 : void 0);
	};
	
	window.cluster_link = function(href, anchor) {
	  anchor || (anchor = href);
	  return "<a href='" + href + "' target='_blank' style='font-weight: 600; text-decoration:underline'>" + anchor + "</a>";
	};
	
	window.point_labels = {
	  pro_con: {
	    translate: true,
	    pro: 'pro',
	    pros: 'pros',
	    con: 'con',
	    cons: 'cons',
	    your_header: "Give your {arguments}",
	    other_header: "Others' {arguments}",
	    top_header: "Top {arguments}"
	  },
	  strengths_weaknesses: {
	    translate: true,
	    pro: 'strength',
	    pros: 'strengths',
	    con: 'weakness',
	    cons: 'weaknesses',
	    your_header: "{arguments}",
	    other_header: "{arguments} observed",
	    top_header: "Top {arguments}"
	  }
	};
	
	window.get_point_label = function(id, proposal) {
	  var conf, prop, ref, val;
	  prop = ((ref = id.split('.')) != null ? ref[1] : void 0) || id;
	  if (proposal) {
	    conf = customization('point_labels', proposal);
	  } else {
	    conf = customization('point_labels');
	  }
	  val = conf[prop];
	  if (!val) {
	    return "";
	  } else {
	    return translator({
	      id: "point_labels." + val,
	      local: !conf.translate
	    }, val);
	  }
	};
	
	window.get_slider_label = function(id, proposal, subdomain) {
	  var conf, label, ref, side;
	  side = ((ref = id.split('.')) != null ? ref[1] : void 0) || id;
	  if (proposal) {
	    conf = customization('slider_pole_labels', proposal, subdomain);
	  } else {
	    conf = customization('slider_pole_labels', null, subdomain);
	  }
	  label = conf[side];
	  if (!label) {
	    return "";
	  } else {
	    return translator({
	      id: "sliders.pole." + label,
	      local: !conf.translate
	    }, label);
	  }
	};
	
	window.positive_scale = function(value, proposal) {
	  var conf;
	  value = (value + 1) / 2;
	  conf = customization('slider_pole_labels', proposal, fetch('/subdomain'));
	  return (Math.round(value * 100)) + "% " + conf.support;
	};
	
	window.fully_firmly_slightly_scale = function(value, proposal) {
	  var degree, strength_of_opinion, valence;
	  if (Math.abs(value) < 0.02) {
	    return translator({
	      id: "sliders.feedback.neutral"
	    }, "You are neutral");
	  } else {
	    valence = get_slider_label((value > 0 ? 'support' : 'oppose'), proposal);
	    degree = Math.abs(value);
	    strength_of_opinion = degree > .999 ? "Fully" : degree > .5 ? "Firmly" : "Slightly";
	    return translator({
	      id: "sliders.feedback." + strength_of_opinion,
	      strength_of_opinion: strength_of_opinion,
	      valence: valence
	    }, "You " + strength_of_opinion + " {valence}");
	  }
	};
	
	window.slider_labels = {
	  agree_disagree: {
	    translate: true,
	    support: 'Agree',
	    oppose: 'Disagree',
	    slider_feedback: "fully_firmly_slightly_scale"
	  },
	  support_oppose: {
	    translate: true,
	    support: 'Support',
	    oppose: 'Oppose',
	    slider_feedback: "fully_firmly_slightly_scale"
	  },
	  priority: {
	    translate: true,
	    support: 'High Priority',
	    oppose: 'Low Priority',
	    slider_feedback: positive_scale
	  },
	  important_unimportant: {
	    translate: true,
	    support: 'More Important',
	    oppose: 'Less Important'
	  },
	  relevance: {
	    support: 'Big impact!',
	    oppose: 'No impact on me'
	  },
	  interested: {
	    support: 'More Interesting',
	    oppose: 'Less Interesting'
	  },
	  yes_no: {
	    support: 'Yes',
	    oppose: 'No'
	  },
	  strong_weak: {
	    support: 'Strong',
	    oppose: 'Weak'
	  },
	  promising_weak: {
	    support: 'Promising',
	    oppose: 'Weak'
	  },
	  ready_not_ready: {
	    support: 'Ready',
	    oppose: 'Not ready'
	  },
	  plus_minus: {
	    support: '+',
	    oppose: '–'
	  },
	  effective_ineffective: {
	    support: 'Effective',
	    oppose: 'Ineffective'
	  }
	};
	
	window.ExpandableSection = ReactiveComponent({
	  displayName: 'ExpandableSection',
	  render: function() {
	    var expanded, label, symbol, text;
	    label = this.props.label;
	    text = this.props.text;
	    expanded = this.local.expanded;
	    symbol = expanded ? 'fa-chevron-down' : 'fa-chevron-right';
	    return DIV(null, DIV({
	      onClick: (function(_this) {
	        return function() {
	          _this.local.expanded = !_this.local.expanded;
	          return save(_this.local);
	        };
	      })(this),
	      style: {
	        fontWeight: 600,
	        color: this.props.text_color || 'black',
	        cursor: 'pointer',
	        marginTop: 12,
	        fontSize: 22
	      }
	    }, SPAN({
	      className: "fa " + symbol,
	      style: {
	        opacity: .7,
	        position: 'relative',
	        left: -3,
	        paddingRight: 6,
	        display: 'inline-block',
	        width: 20
	      }
	    }), SPAN({
	      style: {}
	    }, label)), expanded ? text : void 0);
	  }
	});


/***/ },
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ function(module, exports) {

	window.drawLogo = function(opts) {
	  var height, width;
	  opts = _.defaults(opts, {
	    main_text_color: 'white',
	    o_text_color: logo_red,
	    line_color: 'white',
	    i_dot_x: 252.25,
	    height: 60
	  });
	  opts.width || (opts.width = opts.height * 284 / 60);
	  height = opts.height;
	  width = opts.width;
	  return SVG({
	    id: 'considerit_logo',
	    height: height,
	    viewBox: "0 0 284 60",
	    version: "1.1",
	    xmlns: "http://www.w3.org/2000/svg"
	  }, TITLE({
	    id: 'considerit_logo_title'
	  }, 'Considerit Logo'), DEFS(null, CLIPPATH({
	    id: 'logo_clip'
	  }, RECT({
	    x: 0,
	    y: 0,
	    width: 284,
	    height: 45
	  })), FILTER({
	    id: "logo_shadow",
	    x: "-50%",
	    y: "-50%",
	    width: "200%",
	    height: "200%",
	    filterUnits: "objectBoundingBox"
	  }, FEOFFSET({
	    dx: "0",
	    dy: "1",
	    "in": "SourceAlpha",
	    result: "shadowOffsetOuter1"
	  }), FEGAUSSIANBLUR({
	    stdDeviation: "1",
	    "in": "shadowOffsetOuter1",
	    result: "shadowBlurOuter1"
	  }), FECOLORMATRIX({
	    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
	    type: "matrix",
	    "in": "shadowBlurOuter1",
	    result: "shadowMatrixOuter1"
	  }), FEMERGE(null, FEMERGENODE({
	    "in": "shadowMatrixOuter1"
	  }), FEMERGENODE({
	    "in": "SourceGraphic"
	  })))), G({
	    filter: opts.box_shadow ? 'url(#logo_shadow)' : void 0
	  }, opts.draw_line ? LINE({
	    id: 'underline',
	    x1: 8,
	    y1: 55,
	    x2: 284,
	    y2: 55,
	    stroke: opts.line_color,
	    strokeWidth: 1
	  }) : void 0, PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M18.2811874,48.356 \nC24.1163223,48.3559999 28.0501221,47.5510218 32.5084274,43.599315 \nC32.9673706,43.1801946 33.0984972,42.4018281 32.5739907,41.9827077 \nL30.2137104,37.099623 \nC29.8203305,36.740377 29.0991341,36.6805026 28.5746276,37.099623 \nC25.8209684,39.1353508 22.4772394,40.5124608 18.5434406,40.5124607 \nC14.4641389,40.5124606 9.32086755,37.716503 9.32086787,29.1762513 \nC9.32086836,20.6359996 15.4629989,17.6360006 18.2811869,17.6360001 \nC22.4641385,17.636 25.4641379,19.6359996 27.5746276,21.2528796 \nC28.0991341,21.7318743 28.7547672,21.7318743 29.2137104,21.2528796 \nL32.5739907,17.001801 \nC33.0984972,16.5228062 33.0984972,15.804314 32.5084274,15.3253193 \nC28.0501221,11.6729842 24.903082,10.236 18.2811874,10.236 \nC8.41026668,10.236 0.0764406792,17.8200837 0.0764406792,29.3558743 \nC0.0764406792,40.2729625 8.41026668,48.3560001 18.2811874,48.356 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M38.1601385,33.164 \nC38.1601385,41.444 44.7841385,48.356 52.9201385,48.356 \nC61.0561385,48.356 67.6801385,41.444 67.6801385,33.164 \nC67.6801385,25.028 61.0561385,18.116 52.9201385,18.116 \nC44.7841385,18.116 38.1601385,25.028 38.1601385,33.164 \nC38.1601385,33.164 38.1601385,25.028 38.1601385,33.164 \nZ\nM46.0081385,33.164 \nC46.0081385,29.132 49.0321385,25.892 52.9201385,25.892 \nC56.7361385,25.892 59.8321385,29.132 59.8321385,33.164 \nC59.8321385,37.268 56.7361385,40.58 52.9201385,40.58 \nC49.0321385,40.58 46.0081385,37.268 46.0081385,33.164 \nC46.0081385,33.164 46.0081385,37.268 46.0081385,33.164 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M74.0881385,46.268 \nC74.0881385,46.988 74.7361385,47.636 75.4561385,47.636 \nL80.7841385,47.636 \nC82.1521385,47.636 82.5841385,47.276 82.5841385,46.268 \nL82.5841385,30.428 \nC83.3041385,28.484 85.6081385,25.892 89.3521385,25.892 \nC92.8081385,25.892 94.7521385,28.268 94.7521385,32.012 \nL94.7521385,46.268 \nC94.7521385,46.988 95.3281385,47.636 96.1201385,47.636 \nL102.024139,47.636 \nC102.744139,47.636 103.392139,46.988 103.392139,46.268 \nL103.392139,32.444 \nC103.392139,24.956 99.7201385,18.116 90.5761385,18.116 \nC85.0321385,18.116 81.5041385,21.212 80.4241385,22.364 \nL79.4161385,19.7 \nC79.2001385,19.196 78.8401385,18.836 78.1921385,18.836 \nL75.4561385,18.836 \nC74.7361385,18.836 74.0881385,19.412 74.0881385,20.204 \nC74.0881385,20.204 74.0881385,19.412 74.0881385,20.204 \nL74.0881385,46.268 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M110.304139,45.692 \nC111.816139,46.844 115.128139,48.356 119.880139,48.356 \nC127.152139,48.356 131.328139,44.324 131.328139,39.572 \nC131.328139,33.956 127.152139,31.58 121.608139,29.42 \nC118.944139,28.34 117.648139,27.908 117.648139,26.612 \nC117.648139,25.676 118.368139,24.956 120.096139,24.956 \nC122.832139,24.956 126.072139,26.468 126.072139,26.468 \nC126.648139,26.684 127.440139,26.612 127.800139,25.964 \nL129.600139,22.292 \nC129.960139,21.572 129.600139,20.78 128.952139,20.348 \nC127.440139,19.34 124.344139,18.116 120.096139,18.116 \nC112.752139,18.116 109.512139,22.22 109.512139,26.612 \nC109.512139,31.004 112.104139,33.956 117.648139,36.116 \nC121.464139,37.628 122.472139,38.42 122.472139,39.716 \nC122.472139,40.94 121.464139,41.516 120.024139,41.516 \nC116.712139,41.516 113.472139,39.788 113.472139,39.788 \nC112.824139,39.428 112.104139,39.572 111.816139,40.292 \nL109.872139,44.18 \nC109.584139,44.756 109.872139,45.332 110.304139,45.692 \nC110.304139,45.692 109.872139,45.332 110.304139,45.692 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M137.664139,46.268 \nC137.664139,46.988 138.312139,47.636 139.032139,47.636 \nL145.008139,47.636 \nC145.728139,47.636 146.376139,46.988 146.376139,46.268 \nL146.376139,20.204 \nC146.376139,19.412 145.728139,18.836 145.008139,18.836 \nL139.032139,18.836 \nC138.312139,18.836 137.664139,19.412 137.664139,20.204 \nC137.664139,20.204 137.664139,19.412 137.664139,20.204 \nL137.664139,46.268 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M166.680139,48.356 \nC172.728139,48.356 176.112139,44.036 176.112139,44.036 \nL176.832139,46.268 \nC177.048139,47.06 177.552139,47.636 178.200139,47.636 \nL181.008139,47.636 \nC181.728139,47.636 182.376139,46.988 182.376139,46.268 \nL182.376139,1.604 \nC182.376139,0.884 181.728139,0.236 181.008139,0.236 \nL174.888139,0.236 \nC174.168139,0.236 173.520139,0.884 173.520139,1.604 \nL173.520139,19.412 \nC172.224139,18.908 169.992139,18.116 167.112139,18.116 \nC158.544139,18.116 152.856139,24.812 152.856139,33.236 \nC152.856139,41.516 158.832139,48.356 166.680139,48.356 \nZ \nM161.208139,33.236 \nC161.208139,29.204 164.160139,25.892 168.192139,25.892 \nC171.792139,25.892 173.808139,27.548 173.808139,27.548 \nL173.808139,35.9 \nC173.304139,37.628 171.576139,40.58 167.760139,40.58 \nC163.944139,40.58 161.208139,37.268 161.208139,33.236 \nC161.208139,33.236 161.208139,37.268 161.208139,33.236 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M188.856139,33.236 \nC188.856139,41.516 194.976139,48.356 203.616139,48.356 \nC208.296139,48.356 211.968139,46.628 214.344139,44.396 \nC215.064139,43.82 214.920139,43.028 214.416139,42.524 \nL211.464139,39.14 \nC210.960139,38.564 210.312139,38.708 209.592139,39.14 \nC208.296139,40.076 206.208139,40.94 203.976139,40.94 \nC199.800139,40.94 197.280139,37.628 197.064139,34.676 \nL215.496139,34.676 \nC216.144139,34.676 216.792139,34.172 216.864139,33.452 \nC216.936139,32.948 217.008139,32.012 217.008139,31.508 \nC217.008139,23.732 210.960139,18.116 203.544139,18.116 \nC194.976139,18.116 188.856139,25.1 188.856139,33.236 \nC188.856139,33.236 188.856139,25.1 188.856139,33.236 \nZ \nM197.712139,29.636 \nC198.072139,26.9 200.448139,24.74 203.328139,24.74 \nC206.064139,24.74 208.368139,26.972 208.584139,29.636 \nC208.584139,29.636 208.368139,26.972 208.584139,29.636 \nL197.712139,29.636 \nZ           "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M223.056139,46.268 \nC223.056139,46.988 223.704139,47.636 224.424139,47.636 \nL229.968139,47.636 \nC230.976139,47.636 231.624139,47.276 231.624139,46.268 \nL231.624139,28.844 \nC232.128139,27.836 233.856139,25.892 236.736139,25.892 \nC237.528139,25.892 238.608139,26.252 238.824139,26.324 \nC239.400139,26.612 240.120139,26.324 240.480139,25.676 \nL243.144139,20.996 \nC244.008139,19.196 240.984139,18.116 237.600139,18.116 \nC233.136139,18.116 230.472139,21.14 229.464139,22.58 \nL228.456139,19.772 \nC228.240139,19.196 227.808139,18.836 227.160139,18.836 \nL224.424139,18.836 \nC223.704139,18.836 223.056139,19.412 223.056139,20.204 \nC223.056139,20.204 223.056139,19.412 223.056139,20.204 \nL223.056139,46.268 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M247.608139,46.268 \nC247.608139,46.988 248.256139,47.636 248.976139,47.636 \nL254.952139,47.636 \nC255.672139,47.636 256.320139,46.988 256.320139,46.268 \nL256.320139,20.204 \nC256.320139,19.412 255.672139,18.836 254.952139,18.836 \nL248.976139,18.836 \nC248.256139,18.836 247.608139,19.412 247.608139,20.204 \nC247.608139,20.204 247.608139,19.412 247.608139,20.204 \nL247.608139,46.268 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M266.472139,39.068 \nC266.472139,44.9 268.920139,48.356 274.464139,48.356 \nC277.992139,48.356 282.672139,46.7 283.032139,46.484 \nC283.752139,46.196 284.112139,45.476 283.824139,44.756 \nL282.384139,40.22 \nC282.168139,39.5 281.592139,39.14 280.800139,39.428 \nC280.008139,39.716 278.496139,40.22 277.272139,40.22 \nC276.120139,40.22 275.040139,39.932 275.040139,37.916 \nL275.040139,26.396 \nL281.376139,26.396 \nC282.168139,26.396 282.744139,25.748 282.744139,25.028 \nL282.744139,20.204 \nC282.744139,19.412 282.168139,18.836 281.376139,18.836 \nL275.040139,18.836 \nL275.040139,10.772 \nC275.040139,10.052 274.464139,9.404 273.744139,9.404 \nL267.840139,9.476 \nC267.120139,9.476 266.472139,10.124 266.472139,10.844 \nL266.472139,18.836 \nL264.024139,18.836 \nC263.304139,18.836 262.728139,19.412 262.728139,20.204 \nL262.728139,25.028 \nC262.728139,25.748 263.304139,26.396 264.024139,26.396 \nL266.472139,26.396 \nL266.472139,39.068 \nZ"
	  }), CIRCLE({
	    id: 'i_dot',
	    style: {
	      transition: 'fill 500ms'
	    },
	    fill: opts.o_text_color,
	    cx: opts.i_dot_x,
	    cy: "55",
	    r: "4.25",
	    style: opts.transition ? {
	      transition: 'cx 1000ms'
	    } : void 0
	  })));
	};


/***/ },
/* 21 */,
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var PHONE_BREAKPOINT, SUPER_NARROW_HEIGHT_BREAK, TABLET_BREAKPOINT, setResponsive;
	
	__webpack_require__(3);
	
	PHONE_BREAKPOINT = 545;
	
	TABLET_BREAKPOINT = 990;
	
	SUPER_NARROW_HEIGHT_BREAK = 150;
	
	window.PHONE_MEDIA = "(max-width: " + PHONE_BREAKPOINT + "px),      (max-height: " + SUPER_NARROW_HEIGHT_BREAK + "px)";
	
	window.TABLET_MEDIA = "(min-width: " + PHONE_BREAKPOINT + "px)   and (max-width:  " + TABLET_BREAKPOINT + "px) and (min-height: " + SUPER_NARROW_HEIGHT_BREAK + "px)";
	
	window.LAPTOP_MEDIA = "(min-width: " + TABLET_BREAKPOINT + "px)  and (min-height: " + SUPER_NARROW_HEIGHT_BREAK + "px)";
	
	window.NOT_LAPTOP_MEDIA = "(max-width: " + TABLET_BREAKPOINT + "px),     (max-height: " + SUPER_NARROW_HEIGHT_BREAK + "px)";
	
	window.NOT_PHONE_MEDIA = "(min-width: " + PHONE_BREAKPOINT + "px)   and (min-height: " + SUPER_NARROW_HEIGHT_BREAK + "px)";
	
	setResponsive = function() {
	  var content_width, doc_gutter, h, homepage_width, i, k, len, needs_save, new_vals, phone_size, portrait, registry, responsive, tablet_size, v, w;
	  responsive = fetch('responsive_vars');
	  w = Math.max(320, document.documentElement.clientWidth);
	  h = window.innerHeight;
	  phone_size = w < PHONE_BREAKPOINT || h < SUPER_NARROW_HEIGHT_BREAK;
	  tablet_size = w < TABLET_BREAKPOINT || phone_size;
	  portrait = h > w;
	  doc_gutter = phone_size ? 16 : tablet_size ? 40 : Math.max(80, .09 * w);
	  content_width = w - 2 * doc_gutter;
	  homepage_width = Math.round(Math.min(content_width, 1200));
	  new_vals = {
	    WINDOW_WIDTH: w,
	    DOC_GUTTER: doc_gutter,
	    DASHBOARD_WIDTH: Math.max(100, w),
	    AUTH_WIDTH: phone_size ? w - 8 : tablet_size ? content_width : 820,
	    TABLET_SIZE: tablet_size,
	    PHONE_SIZE: phone_size,
	    CONTENT_WIDTH: content_width,
	    PORTRAIT_MOBILE: portrait && browser.is_mobile,
	    LANDSCAPE_MOBILE: !portrait && browser.is_mobile,
	    HOMEPAGE_WIDTH: homepage_width,
	    SAAS_PAGE_WIDTH: Math.min(1120, w - 2 * 24)
	  };
	  for (i = 0, len = responsive_style_registry.length; i < len; i++) {
	    registry = responsive_style_registry[i];
	    _.extend(new_vals, registry(new_vals));
	  }
	  needs_save = false;
	  for (k in new_vals) {
	    v = new_vals[k];
	    if (window[k] == null) {
	      window[k] = (function(k) {
	        return function() {
	          return fetch('responsive_vars')[k];
	        };
	      })(k);
	    }
	    needs_save || (needs_save = responsive[k] !== v);
	  }
	  if (needs_save) {
	    _.extend(responsive, new_vals);
	    return save(responsive);
	  }
	};
	
	styles += "\n@media " + LAPTOP_MEDIA + " {\n  :after, :root {\n    --DOC_GUTTER: max(80px, 9vw);\n  }\n}\n\n@media " + TABLET_MEDIA + " {\n  :after, :root {\n    --DOC_GUTTER: 40px;\n  }\n\n}\n\n@media " + PHONE_MEDIA + " {\n  :after, :root {\n    --DOC_GUTTER: 16px;\n  }\n}\n\n:after, :root {\n  --WINDOW_WIDTH: max(350px, 100vw);\n  --SAAS_PAGE_WIDTH: min(1120px, 100vw - 2 * 24px);\n  --HOMEPAGE_WIDTH:  min(1200px, 100vw - 2 * var(--DOC_GUTTER));\n  --CONTENT_WIDTH: calc(var(--WINDOW_WIDTH) - 2 * var(--DOC_GUTTER));\n}\n";
	
	window.responsive_style_registry = [];
	
	setTimeout(setResponsive);
	
	window.addEventListener("resize", setResponsive);
	
	window.addEventListener("gestureend", setResponsive);
	
	window.matchMedia('screen and (min-resolution: 2dppx)').addEventListener("change", setResponsive);


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var TOOLTIP_DELAY, hide_tooltip, show_tooltip, toggle_tooltip, tooltip;
	
	__webpack_require__(1);
	
	styles += "\n#tooltip .downward_arrow {\n  width: 0; \n  height: 0; \n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;  \n  border-top: 10px solid black;\n}\n#tooltip .upward_arrow {\n  width: 0; \n  height: 0; \n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;  \n  border-bottom: 10px solid black;\n}\n";
	
	TOOLTIP_DELAY = 500;
	
	window.clear_tooltip = function() {
	  var tooltip;
	  tooltip = fetch('tooltip');
	  tooltip.coords = tooltip.tip = tooltip.top = tooltip.positioned = null;
	  tooltip.offsetY = tooltip.offsetX = null;
	  tooltip.rendered_size = false;
	  return save(tooltip);
	};
	
	toggle_tooltip = function(e) {
	  var tooltip, tooltip_el;
	  tooltip_el = $$.closest(e.target, '[data-tooltip]');
	  if (tooltip_el != null) {
	    tooltip = fetch('tooltip');
	    if (tooltip.coords) {
	      return clear_tooltip();
	    } else {
	      return show_tooltip(e);
	    }
	  }
	};
	
	show_tooltip = function(e) {
	  var name, tooltip, tooltip_el;
	  tooltip_el = $$.closest(e.target, '[data-tooltip]');
	  if ((tooltip_el == null) || tooltip_el.style.opacity === 0) {
	    return;
	  }
	  tooltip = fetch('tooltip');
	  name = tooltip_el.getAttribute('data-tooltip');
	  if (tooltip.tip !== name) {
	    tooltip.tip = name;
	    setTimeout(function() {
	      if (tooltip.tip === name) {
	        tooltip.coords = calc_coords_for_tooltip_or_popover(tooltip_el);
	        return save(tooltip);
	      }
	    }, TOOLTIP_DELAY);
	    e.preventDefault();
	    return e.stopPropagation();
	  }
	};
	
	tooltip = fetch('tooltip');
	
	hide_tooltip = function(e) {
	  if (e.target.getAttribute('data-tooltip')) {
	    clear_tooltip();
	    e.preventDefault();
	    return e.stopPropagation();
	  }
	};
	
	document.addEventListener("click", toggle_tooltip);
	
	document.body.addEventListener("mouseover", show_tooltip, true);
	
	document.body.addEventListener("mouseleave", hide_tooltip, true);
	
	$$.add_delegated_listener(document.body, 'focusin', '[data-tooltip]', show_tooltip);
	
	$$.add_delegated_listener(document.body, 'focusout', '[data-tooltip]', hide_tooltip);
	
	window.Tooltip = ReactiveComponent({
	  displayName: 'Tooltip',
	  render: function() {
	    var arrow_adjustment, arrow_size, arrow_up, coords, left, ref, style, tip, top;
	    tooltip = fetch('tooltip');
	    if (!tooltip.coords) {
	      return SPAN(null);
	    }
	    coords = tooltip.coords;
	    tip = tooltip.tip;
	    arrow_size = {
	      height: 7,
	      width: 14
	    };
	    ref = get_tooltip_or_popover_position({
	      tooltip: tooltip,
	      arrow_size: arrow_size
	    }), top = ref.top, left = ref.left, arrow_up = ref.arrow_up, arrow_adjustment = ref.arrow_adjustment;
	    style = _.defaults({
	      top: top,
	      left: left
	    }, this.props.style || {}, {
	      fontSize: 14,
	      padding: '4px 8px',
	      borderRadius: 8,
	      pointerEvents: 'none',
	      zIndex: 999999999999,
	      color: 'white',
	      backgroundColor: 'black',
	      position: 'absolute',
	      boxShadow: '0 1px 1px rgba(0,0,0,.2)',
	      maxWidth: 350
	    });
	    return DIV({
	      id: 'tooltip',
	      role: "tooltip",
	      style: style
	    }, DIV({
	      dangerouslySetInnerHTML: {
	        __html: tip
	      }
	    }), SVG({
	      width: arrow_size.width,
	      height: arrow_size.height,
	      viewBox: "0 0 531.74 460.5",
	      preserveAspectRatio: "none",
	      style: {
	        position: 'absolute',
	        bottom: arrow_up ? -arrow_size.height : void 0,
	        top: !arrow_up ? -arrow_size.height : void 0,
	        left: tooltip.positioned !== 'right' ? "calc(50% - " + (arrow_size.width / 2 + arrow_adjustment) + "px)" : void 0,
	        right: tooltip.positioned === 'right' ? 7 : void 0,
	        transform: !arrow_up ? 'scale(1,-1)' : void 0,
	        display: tooltip.hide_triangle ? 'none' : void 0
	      }
	    }, POLYGON({
	      stroke: "black",
	      fill: 'black',
	      points: "530.874,0.5 265.87,459.5 0.866,0.5"
	    })));
	  },
	  componentDidUpdate: function() {
	    tooltip = fetch('tooltip');
	    if (!tooltip.rendered_size && tooltip.coords) {
	      tooltip.rendered_size = {
	        width: ReactDOM.findDOMNode(this).offsetWidth,
	        height: ReactDOM.findDOMNode(this).offsetHeight
	      };
	      return save(tooltip);
	    }
	  }
	});


/***/ },
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var OTHER_SEPARATOR;
	
	__webpack_require__(5);
	
	window.HostQuestions = ReactiveComponent({
	  displayName: 'CreateAccount',
	  mixins: [AuthForm, Modal],
	  render: function() {
	    var auth, avatar_url, current_user, i18n, title;
	    i18n = this.i18n();
	    auth = fetch('auth');
	    current_user = fetch('/current_user');
	    return this.Draw({
	      task: translator('auth.additional_info.heading', 'Questions from your host'),
	      disallow_cancel: true,
	      goal: auth.goal ? translator("auth.login_goal." + (auth.goal.toLowerCase()), auth.goal) : void 0,
	      on_submit: (function(_this) {
	        return function(ev) {
	          return _this.Submit(ev, {
	            action: 'user questions',
	            has_host_questions: true,
	            onSuccess: function() {
	              auth.show_user_questions_after_account_creation = false;
	              return save(auth);
	            }
	          });
	        };
	      })(this),
	      under_submit: customization('user_tags').length > 1 || !customization('user_tags')[0].key.match('pledge_taken') ? DIV({
	        style: {
	          fontSize: 13,
	          color: auth_text_gray,
	          padding: '16px 0',
	          textAlign: 'center'
	        }
	      }, "By proceeding, you consent to the collection of the above data on behalf of the Forum Host. You can edit your responses later in your User Profile.") : void 0,
	      render_below_title: function() {
	        var host_framing;
	        host_framing = customization('host_questions_framing');
	        if (host_framing) {
	          return DIV({
	            style: {
	              marginBottom: 12,
	              textAlign: host_framing.length > 80 ? 'left' : void 0
	            }
	          }, DIV({
	            style: {
	              fontSize: 14,
	              marginTop: 0
	            },
	            dangerouslySetInnerHTML: {
	              __html: host_framing
	            }
	          }));
	        } else {
	          return SPAN(null);
	        }
	      }
	    }, DIV(null, (function() {
	      var ref;
	      if (embedded_demo() && fetch('/subdomain').name === 'galacticfederation' && ((ref = fetch('local_tags').tags) != null ? ref.federation_allegiance : void 0)) {
	        switch (current_user.tags.federation_allegiance) {
	          case 'Dark':
	            avatar_url = "https://d2rtgkroh5y135.cloudfront.net/system/avatars/287330/large/stormtrooper1.png";
	            title = 'A Stormtrooper';
	            break;
	          case 'Light':
	            avatar_url = "https://f.consider.it/galacticfederation/ewok.png";
	            title = 'An Ewok';
	            break;
	          case "Wouldn't you like to know":
	            avatar_url = 'https://f.consider.it/galacticfederation/wookiee.jpeg';
	            title = 'A Wookiee';
	            break;
	          case 'Non-binary':
	            avatar_url = 'https://f.consider.it/galacticfederation/rodian.jpeg';
	            title = 'A Rodian';
	            break;
	        }
	        return DIV({
	          style: {
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: 36
	          }
	        }, "In this parody, you'll participate as:", IMG({
	          "data-tooltip": title,
	          src: avatar_url,
	          style: {
	            height: 70,
	            marginLeft: 24,
	            borderRadius: '50%'
	          }
	        }));
	      }
	    })(), ShowHostQuestions({
	      disable_unchecking_required_booleans: this.props.disable_unchecking_required_booleans
	    }), customization('auth_footer') ? DIV({
	      style: {
	        fontSize: 13,
	        color: auth_text_gray,
	        padding: '16px 0'
	      },
	      dangerouslySetInnerHTML: {
	        __html: customization('auth_footer')
	      }
	    }) : void 0, this.ShowErrors()));
	  }
	});
	
	window.forum_has_host_questions = function() {
	  var tag;
	  return ((function() {
	    var i, len, ref, results;
	    ref = customization('user_tags') || [];
	    results = [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      tag = ref[i];
	      if (tag.self_report) {
	        results.push(tag);
	      }
	    }
	    return results;
	  })()).length > 0;
	};
	
	window.errors_in_host_questions = function(responses) {
	  var errors, has_response, i, is_valid_input, len, question, ref, ref1, tag, vals;
	  errors = [];
	  ref = customization('user_tags') || [];
	  for (i = 0, len = ref.length; i < len; i++) {
	    vals = ref[i];
	    if (!vals.self_report) {
	      continue;
	    }
	    tag = vals.key;
	    question = vals.self_report;
	    if (question.required) {
	      has_response = ((ref1 = question.input) === 'checklist') || !!responses[tag];
	      if (!has_response || (question.require_checked && !responses[tag])) {
	        errors.push(translator({
	          id: 'auth.validation.missing_answer',
	          question: question.question
	        }, "\"{question}\" is required."));
	      }
	      is_valid_input = true;
	      if (question.validation) {
	        is_valid_input = question.validation(responses[tag]);
	      }
	      if (!is_valid_input && has_response) {
	        errors.push(translator({
	          id: 'auth.validation.invalid_answer',
	          response: responses[tag],
	          question: question.question
	        }, "{response} isn't a valid answer to \"{question}\"!"));
	      }
	    }
	  }
	  return errors;
	};
	
	styles += "#SHOWHOSTQUESTIONS {\n  /* padding: 0px 36px; */\n  margin-top: 18px;\n}\n\n#SHOWHOSTQUESTIONS .question {\n  margin-bottom: 36px;\n}\n\n#SHOWHOSTQUESTIONS .question-prompt {\n  display: block;\n  font-weight: 600;\n  font-size: 18px;   \n}\n\n.question_metadata {\n  font-size: 14px;\n  color: #333;\n}\n.question_metadata .optionality {\n  font-style: italic;\n  text-transform: capitalize;\n}";
	
	window.ShowHostQuestions = ReactiveComponent({
	  displayName: 'ShowHostQuestions',
	  render: function() {
	    var field_id, host_questions, label, question, render;
	    host_questions = this.HostQuestionInputs();
	    if (host_questions.length === 0) {
	      return SPAN(null);
	    }
	    return DIV({
	      id: 'SHOWHOSTQUESTIONS'
	    }, UL({
	      style: {
	        padding: "6px 0px",
	        listStyle: 'none'
	      }
	    }, (function() {
	      var i, len, ref, ref1, ref2, ref3, results;
	      results = [];
	      for (i = 0, len = host_questions.length; i < len; i++) {
	        ref = host_questions[i], label = ref[0], render = ref[1], question = ref[2];
	        field_id = (render != null ? (ref1 = render.props) != null ? ref1.id : void 0 : void 0) || (render != null ? (ref2 = render[0]) != null ? (ref3 = ref2.props) != null ? ref3.id : void 0 : void 0 : void 0);
	        results.push(LI({
	          key: label,
	          className: 'question'
	        }, LABEL({
	          className: 'question-prompt',
	          htmlFor: field_id
	        }, SPAN({
	          style: {
	            paddingRight: !question.required ? 8 : void 0
	          },
	          dangerouslySetInnerHTML: {
	            __html: label
	          }
	        })), render, question.tag.indexOf('pledge_taken') === -1 ? DIV({
	          className: 'question_metadata'
	        }, SPAN({
	          className: 'optionality'
	        }, !question.required ? SPAN({
	          style: {
	            color: selected_color
	          }
	        }, translator('auth.optional_field', 'Optional')) : SPAN(null, translator('auth.required_field', 'Required'))), ". ", question.visibility === 'host-only' ? translator('auth.host-only-response', 'Your response will only be shared with the Forum Host.') : translator('auth.public-visibility-response', 'Your response will be visible to any participant.')) : void 0));
	      }
	      return results;
	    })()));
	  },
	  HostQuestionInputs: function() {
	    var auth, current_user, fn, i, inputs, j, len, len1, local, question, questions, ref, subdomain, tag, vals;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    auth = fetch('auth');
	    local = fetch('local_tags');
	    if (!current_user.tags) {
	      return DIV();
	    }
	    questions = [];
	    ref = customization('user_tags') || [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      vals = ref[i];
	      tag = vals.key;
	      if (vals.self_report) {
	        questions.push(_.extend({}, vals.self_report, {
	          tag: tag
	        }, {
	          visibility: vals.visibility
	        }));
	      }
	    }
	    if (local.tags !== current_user.tags) {
	      local.tags = current_user.tags;
	      save(local);
	      return SPAN(null);
	    }
	    inputs = [];
	    fn = (function(_this) {
	      return function(question) {
	        var input, label, option, ref1, ref2, value;
	        label = "" + question.question;
	        switch (question.input) {
	          case 'text':
	            input = INPUT({
	              key: label,
	              style: _.defaults(question.input_style || {}, {
	                marginBottom: 6,
	                width: 300,
	                border: "1px solid #a1a1a1",
	                padding: '5px 10px',
	                fontSize: 18
	              }),
	              key: question.tag + "_inputBox",
	              id: slugify(question.tag + "inputBox"),
	              type: 'text',
	              value: local.tags[question.tag],
	              onChange: (function(question) {
	                return function(event) {
	                  local.tags[question.tag] = current_user.tags[question.tag] = event.target.value;
	                  return save(local);
	                };
	              })(question),
	              onKeyPress: function(event) {
	                if (event.which === 13) {
	                  return _this.submitAuth(event);
	                }
	              }
	            });
	            break;
	          case 'boolean':
	            input = DIV({
	              key: label,
	              style: {
	                marginBottom: 6
	              }
	            }, INPUT({
	              id: slugify(question.tag + "inputBox"),
	              key: question.tag + "_inputBox",
	              type: 'checkbox',
	              className: 'bigger',
	              style: {
	                fontSize: 24,
	                verticalAlign: 'top',
	                marginTop: 5,
	                marginLeft: 0,
	                marginRight: 6
	              },
	              checked: local.tags[question.tag],
	              onChange: (function(question) {
	                return function(event) {
	                  local.tags[question.tag] = current_user.tags[question.tag] = event.target.checked;
	                  return save(local);
	                };
	              })(question)
	            }), LABEL({
	              htmlFor: slugify(question.tag + "inputBox"),
	              style: {
	                display: 'inline-block',
	                width: '90%',
	                paddingLeft: 8
	              }
	            }, SPAN({
	              dangerouslySetInnerHTML: {
	                __html: question.question
	              }
	            }), question.tag.indexOf('pledge_taken') > -1 ? SPAN({
	              title: translator('auth.required_field', 'Required')
	            }, "*") : void 0));
	            label = '';
	            break;
	          case 'checklist':
	            input = DIV({
	              key: label,
	              style: {
	                margin: "10px 18px"
	              }
	            }, (function() {
	              var k, len2, ref1, results;
	              ref1 = question.options;
	              results = [];
	              for (k = 0, len2 = ref1.length; k < len2; k++) {
	                option = ref1[k];
	                results.push((function(_this) {
	                  return function(option) {
	                    var idx, is_checked, key, opt, options_checked, ref2, ref3;
	                    key = question.tag + "-" + option;
	                    options_checked = (function() {
	                      var l, len3, ref2, ref3, results1;
	                      ref3 = ((ref2 = current_user.tags[question.tag]) != null ? ref2.split(CHECKLIST_SEPARATOR) : void 0) || [];
	                      results1 = [];
	                      for (l = 0, len3 = ref3.length; l < len3; l++) {
	                        opt = ref3[l];
	                        results1.push(opt.split(OTHER_SEPARATOR)[0]);
	                      }
	                      return results1;
	                    })();
	                    is_checked = options_checked.indexOf(option) > -1;
	                    return DIV({
	                      key: key,
	                      style: {
	                        display: 'flex',
	                        alignItems: 'flex-start',
	                        marginBottom: 8
	                      }
	                    }, INPUT({
	                      id: slugify(key + "-inputBox"),
	                      key: key + "_inputBox",
	                      type: 'checkbox',
	                      className: 'bigger',
	                      style: {
	                        fontSize: 24,
	                        marginLeft: 0,
	                        marginTop: 5
	                      },
	                      checked: is_checked,
	                      onChange: (function(question, option) {
	                        return function(event) {
	                          var idx, int;
	                          if (event.target.checked) {
	                            options_checked.push(option);
	                          } else {
	                            idx = options_checked.indexOf(option);
	                            if (idx > -1) {
	                              options_checked.splice(idx, 1);
	                            }
	                          }
	                          local.tags[question.tag] = current_user.tags[question.tag] = options_checked.join(CHECKLIST_SEPARATOR);
	                          save(local);
	                          if (question.open_text_option === option && event.target.checked) {
	                            return int = setInterval(function() {
	                              if (_this.refs["open_value-" + question.tag] && !_this.refs["open_value-" + question.tag].getAttribute('disabled')) {
	                                _this.refs["open_value-" + question.tag].focus();
	                                return clearInterval(int);
	                              }
	                            }, 10);
	                          }
	                        };
	                      })(question, option)
	                    }), LABEL({
	                      htmlFor: slugify(key + "-inputBox"),
	                      style: {
	                        display: 'inline',
	                        paddingLeft: 12
	                      },
	                      dangerouslySetInnerHTML: {
	                        __html: option
	                      }
	                    }), question.open_text_option === option ? (idx = options_checked.indexOf(option), INPUT({
	                      ref: "open_value-" + question.tag,
	                      disabled: !is_checked,
	                      defaultValue: ((ref2 = current_user.tags[question.tag]) != null ? (ref3 = ref2.split(CHECKLIST_SEPARATOR)[idx]) != null ? ref3.split(OTHER_SEPARATOR)[1] : void 0 : void 0) || "",
	                      style: {
	                        display: 'inline-block',
	                        marginLeft: 12
	                      },
	                      type: 'text',
	                      onChange: (function(question, option) {
	                        return function(event) {
	                          var full_vals;
	                          full_vals = options_checked.slice();
	                          full_vals[idx] = "" + full_vals[idx] + OTHER_SEPARATOR + event.target.value;
	                          local.tags[question.tag] = current_user.tags[question.tag] = full_vals.join(CHECKLIST_SEPARATOR);
	                          return save(local);
	                        };
	                      })(question, option)
	                    })) : void 0);
	                  };
	                })(this)(option));
	              }
	              return results;
	            }).call(_this));
	            break;
	          case 'dropdown':
	            input = DIV({
	              key: question.tag + "-wrapper"
	            }, SELECT({
	              id: slugify(question.tag + "inputBox"),
	              key: question.tag + "_inputBox",
	              style: _.defaults(question.input_style || {}, {
	                fontSize: 18,
	                marginTop: 4,
	                maxWidth: '100%',
	                marginRight: 12,
	                marginBottom: 4
	              }),
	              defaultValue: (local.tags[question.tag] || '').split(OTHER_SEPARATOR)[0],
	              onChange: (function(question) {
	                return function(event) {
	                  var int;
	                  local.tags[question.tag] = current_user.tags[question.tag] = event.target.value;
	                  save(local);
	                  if (question.open_text_option === event.target.value) {
	                    return int = setInterval(function() {
	                      if (_this.refs["open_value-" + question.tag] && !_this.refs["open_value-" + question.tag].getAttribute('disabled')) {
	                        _this.refs["open_value-" + question.tag].focus();
	                        return clearInterval(int);
	                      }
	                    }, 10);
	                  }
	                };
	              })(question)
	            }, [
	              OPTION({
	                key: 'none',
	                value: '',
	                disabled: true,
	                hidden: true
	              }), (function() {
	                var k, len2, ref1, results;
	                ref1 = question.options;
	                results = [];
	                for (k = 0, len2 = ref1.length; k < len2; k++) {
	                  value = ref1[k];
	                  results.push(OPTION({
	                    key: value,
	                    value: value
	                  }, value));
	                }
	                return results;
	              })()
	            ]), question.open_text_option && question.open_text_option === ((ref1 = local.tags[question.tag]) != null ? ref1.split(OTHER_SEPARATOR)[0] : void 0) ? INPUT({
	              ref: "open_value-" + question.tag,
	              defaultValue: ((ref2 = current_user.tags[question.tag]) != null ? ref2.split(OTHER_SEPARATOR)[1] : void 0) || "",
	              style: {
	                display: 'inline-block'
	              },
	              type: 'text',
	              onChange: (function(question) {
	                return function(event) {
	                  var new_val;
	                  new_val = "" + (local.tags[question.tag].split(OTHER_SEPARATOR)[0]) + OTHER_SEPARATOR + event.target.value;
	                  local.tags[question.tag] = current_user.tags[question.tag] = new_val;
	                  return save(local);
	                };
	              })(question)
	            }) : void 0);
	            break;
	          default:
	            throw "Unsupported question type: " + question.input + " for " + question.tag;
	        }
	        return inputs.push([label, input, question]);
	      };
	    })(this);
	    for (j = 0, len1 = questions.length; j < len1; j++) {
	      question = questions[j];
	      fn(question);
	    }
	    return inputs;
	  }
	});
	
	window.CHECKLIST_SEPARATOR = ' ;;; ';
	
	OTHER_SEPARATOR = ' :: ';


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var toggle_modes;
	
	__webpack_require__(5);
	
	__webpack_require__(31);
	
	window.styles += "button.toggle_auth {\n  color: " + selected_color + ";\n  font-weight: 700;\n}";
	
	window.disallow_cancel = function() {
	  return permit('access forum') < 0;
	};
	
	toggle_modes = function() {
	  var auth, toggle_to;
	  auth = fetch('auth');
	  if (auth.form === 'create account') {
	    toggle_to = translator("auth.log_in", 'Log in');
	  } else {
	    toggle_to = translator("auth.login.toggle_to_create", 'Create an account');
	  }
	  return DIV({
	    style: {
	      textAlign: 'center'
	    }
	  }, DIV({
	    style: {
	      marginBottom: 12,
	      width: '100%'
	    }
	  }, SPAN({
	    style: {
	      fontWeight: 300,
	      fontSize: 16
	    }
	  }, auth.form === 'create account' ? TRANSLATE('auth.create.should_you_be_here', 'Already have an account?') : TRANSLATE('auth.login.should_you_be_here', 'Not registered?')), " ", BUTTON({
	    className: 'toggle_auth like_link',
	    onClick: (function(_this) {
	      return function(e) {
	        var current_user;
	        current_user = fetch('/current_user');
	        auth.form = auth.form === 'create account' ? 'login' : 'create account';
	        save(auth);
	        return setTimeout(function() {
	          var ref;
	          return (ref = document.getElementById('user_email')) != null ? ref.focus() : void 0;
	        }, 0);
	      };
	    })(this)
	  }, toggle_to)));
	};
	
	window.Login = ReactiveComponent({
	  displayName: 'Login',
	  mixins: [AuthForm, Modal, OAuthLogin],
	  render: function() {
	    var auth, i18n, on_submit;
	    i18n = this.i18n();
	    auth = fetch('auth');
	    on_submit = (function(_this) {
	      return function(ev) {
	        return _this.Submit(ev, {
	          action: 'login'
	        });
	      };
	    })(this);
	    return this.Draw({
	      task: translator("auth.login.heading", 'Login to Participate'),
	      goal: auth.goal ? translator("auth.login_goal." + (auth.goal.toLowerCase()), auth.goal) : void 0,
	      disallow_cancel: disallow_cancel(),
	      render_below_title: toggle_modes,
	      on_submit: on_submit,
	      submit_button: translator("auth.log_in", 'Log in')
	    }, DIV({
	      style: {
	        marginBottom: 36
	      }
	    }, this.WrapOAuth('login', DIV(null, this.RenderInput({
	      name: 'email',
	      type: 'email',
	      label: i18n.email_label,
	      on_submit: on_submit
	    }), this.RenderInput({
	      name: 'password',
	      type: 'password',
	      label: i18n.password_label,
	      on_submit: on_submit
	    }), this.resetPasswordLink(), this.ShowErrors(), customization('login_footer') ? (auth = fetch('auth'), auth.form === 'login' ? DIV({
	      style: {
	        fontSize: 13,
	        color: auth_text_gray,
	        padding: '16px 0'
	      },
	      dangerouslySetInnerHTML: {
	        __html: customization('login_footer')
	      }
	    }) : void 0) : void 0))));
	  },
	  resetPasswordLink: function() {
	    var reset;
	    reset = (function(_this) {
	      return function(e) {
	        var current_user, ref, ref1;
	        current_user = fetch('/current_user');
	        current_user.trying_to = 'send_password_reset_token';
	        if (((ref = _this.local.updates) != null ? (ref1 = ref.email) != null ? ref1.length : void 0 : void 0) > 0) {
	          current_user.email = _this.local.updates.email;
	        }
	        return save(current_user, function() {
	          var ref2;
	          if (((ref2 = current_user.errors) != null ? ref2.length : void 0) > 0) {
	            return arest.updateCache(current_user);
	          } else {
	            return reset_key('auth', {
	              form: 'reset password'
	            });
	          }
	        });
	      };
	    })(this);
	    return DIV({
	      style: {
	        textAlign: 'right',
	        width: '100%'
	      }
	    }, BUTTON({
	      style: {
	        textDecoration: 'underline',
	        color: '#333',
	        backgroundColor: 'transparent',
	        border: 'none',
	        fontSize: 12,
	        padding: 0,
	        position: 'relative',
	        top: -8,
	        fontWeight: 700
	      },
	      onClick: reset
	    }, translator('auth.forgot_password.link', 'Help! I forgot my password')));
	  }
	});
	
	window.CreateAccount = ReactiveComponent({
	  displayName: 'CreateAccount',
	  mixins: [AuthForm, Modal, OAuthLogin],
	  render: function() {
	    var auth, avatar_field, current_user, email_fields, form_name, i18n, on_submit;
	    i18n = this.i18n();
	    current_user = fetch('/current_user');
	    auth = fetch('auth');
	    form_name = this.props.by_invitation ? 'create account via invitation' : 'create account';
	    avatar_field = AvatarInput();
	    on_submit = (function(_this) {
	      return function(ev) {
	        current_user.signed_pledge = document.querySelectorAll('.pledge-input').length === document.querySelectorAll('.pledge-input:checked').length;
	        if (forum_has_host_questions()) {
	          auth.show_user_questions_after_account_creation = true;
	          save(auth);
	        }
	        return _this.Submit(ev, {
	          action: form_name,
	          has_host_questions: false,
	          has_avatar_upload: true,
	          onSuccess: function() {
	            return typeof plausibleRegistrationEvent === "function" ? plausibleRegistrationEvent() : void 0;
	          }
	        });
	      };
	    })(this);
	    email_fields = DIV(null, this.RenderInput({
	      name: 'name',
	      label: i18n.name_label,
	      on_submit: on_submit
	    }), this.RenderInput({
	      name: 'email',
	      type: 'email',
	      label: i18n.email_label,
	      disabled: this.props.by_invitation ? true : void 0,
	      on_submit: on_submit
	    }), this.RenderInput({
	      name: 'password',
	      type: 'password',
	      label: i18n.password_label,
	      on_submit: on_submit
	    }), avatar_field ? DIV({
	      className: 'AUTH_field_wrapper',
	      style: {
	        marginBottom: 8
	      }
	    }, LABEL({
	      className: 'AUTH_field_label'
	    }, i18n.pic_prompt, SPAN({
	      style: {
	        fontSize: 12,
	        color: "#666",
	        textTransform: 'lowercase',
	        marginLeft: 4,
	        display: 'inline-block'
	      }
	    }, " (" + (translator('optional', 'optional')) + ")")), avatar_field) : void 0);
	    return this.Draw({
	      task: this.props.by_invitation ? translator('auth.create-by-invitation.heading', 'Complete registration') : translator('auth.create.heading', 'Create your account'),
	      disallow_cancel: disallow_cancel(),
	      goal: auth.goal ? translator("auth.login_goal." + (auth.goal.toLowerCase()), auth.goal) : void 0,
	      on_submit: on_submit,
	      render_below_title: !this.props.by_invitation ? toggle_modes : void 0,
	      submit_button: translator("shared.auth.sign_up", "Sign up"),
	      under_submit: this.ConsideritTerms()
	    }, DIV({
	      style: {
	        marginBottom: 36
	      }
	    }, this.props.by_invitation ? email_fields : this.WrapOAuth('create_account', email_fields), this.ShowErrors(), customization('auth_footer') ? DIV({
	      style: {
	        fontSize: 13,
	        color: auth_text_gray,
	        padding: '16px 0'
	      },
	      dangerouslySetInnerHTML: {
	        __html: customization('auth_footer')
	      }
	    }) : void 0, customization('login_footer') ? (auth = fetch('auth'), auth.form === 'login' ? DIV({
	      style: {
	        fontSize: 13,
	        color: auth_text_gray,
	        padding: '16px 0'
	      },
	      dangerouslySetInnerHTML: {
	        __html: customization('login_footer')
	      }
	    }) : void 0) : void 0));
	  },
	  ConsideritTerms: function() {
	    var current_user, default_terms, terms;
	    current_user = fetch('/current_user');
	    default_terms = TRANSLATE({
	      id: 'auth.create.agree_to_terms',
	      as_html: true,
	      privacy_link: {
	        component: "a",
	        args: "href='/docs/legal/privacy_policy' style='font-weight: 700; color: " + selected_color + ";' target='_blank'"
	      },
	      terms_link: {
	        component: "a",
	        args: "href='/docs/legal/terms_of_service' style='font-weight: 700; color: " + selected_color + ";' target='_blank'"
	      },
	      br: {
	        component: 'br'
	      }
	    }, "By signing up, you agree to the Consider.it <privacy_link>Privacy Policy</privacy_link> and <terms_link>Terms of Service</terms_link>. <br>We will never sell your data to advertisers or other third-parties.");
	    terms = customization('terms') || default_terms.join('');
	    return DIV({
	      style: {
	        marginTop: 12,
	        fontSize: 13,
	        color: '#444',
	        textAlign: 'center'
	      },
	      dangerouslySetInnerHTML: {
	        __html: terms
	      }
	    });
	  }
	});


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(5);
	
	window.styles += "";
	
	window.ResetPassword = ReactiveComponent({
	  displayName: 'ResetPassword',
	  mixins: [AuthForm, Modal],
	  render: function() {
	    var i18n, on_submit;
	    i18n = this.i18n();
	    on_submit = (function(_this) {
	      return function(ev) {
	        return _this.Submit(ev, {
	          action: 'reset password'
	        });
	      };
	    })(this);
	    return this.Draw({
	      task: translator("auth.reset_password.heading", 'Reset Your Password'),
	      on_submit: on_submit
	    }, DIV(null, DIV({
	      style: {
	        color: auth_text_gray,
	        marginBottom: 18
	      }
	    }, i18n.verification_sent_message), INPUT({
	      name: 'user[verification_code]',
	      disabled: true,
	      style: {
	        display: 'none'
	      }
	    }), INPUT({
	      type: 'password',
	      name: 'user[password]',
	      disabled: true,
	      style: {
	        display: 'none'
	      }
	    }), this.RenderInput({
	      label: i18n.code_label,
	      name: 'verification_code',
	      on_submit: on_submit
	    }), this.RenderInput({
	      label: translator('auth.reset_password.new_pass', 'New password'),
	      type: 'password',
	      name: 'password',
	      on_submit: on_submit
	    }), this.ShowErrors(), DIV({
	      style: {
	        marginTop: 20,
	        textAlign: 'center'
	      }
	    }, TRANSLATE({
	      id: "auth.reset_password.help",
	      link: {
	        component: A,
	        args: {
	          target: '_blank',
	          href: 'https://vimeo.com/198802322',
	          style: {
	            textDecoration: 'underline',
	            fontWeight: 600
	          }
	        }
	      }
	    }, 'Having trouble resetting your password? Watch this brief <link>video tutorial</link>.'))));
	  }
	});


/***/ },
/* 31 */
/***/ function(module, exports) {

	var OAuthHandler, OAuth_providers;
	
	OAuthHandler = (function() {
	  function OAuthHandler(options) {
	    var callback, provider;
	    if (options == null) {
	      options = {};
	    }
	    provider = options.provider;
	    callback = options.callback;
	    if (provider === 'google') {
	      provider = 'google_oauth2';
	    }
	    this.callback = callback;
	    this.popup = this.openPopupWindow(location.protocol + "//" + (fetch('/subdomain').host) + "/auth/" + provider);
	  }
	
	  OAuthHandler.prototype.openPopupWindow = function(url) {
	    var cb, coords, openidpopup;
	    openidpopup = window.open(url, 'openid_popup', 'width=450,height=500,location=1,status=1,resizable=yes');
	    openidpopup.current_user_hash = null;
	    coords = this.getCenteredCoords(450, 500);
	    openidpopup.moveTo(coords[0], coords[1]);
	    cb = (function(_this) {
	      return function(event) {
	        if (event.source !== openidpopup) {
	          return;
	        }
	        _this.callback(event.data);
	        return window.removeEventListener("message", cb);
	      };
	    })(this);
	    window.addEventListener("message", cb, false);
	    return openidpopup;
	  };
	
	  OAuthHandler.prototype.getCenteredCoords = function(width, height) {
	    var parentPos, parentSize, xPos, yPos;
	    if (window.ActiveXObject) {
	      xPos = window.event.screenX - (width / 2) + 100;
	      yPos = window.event.screenY - (height / 2) - 100;
	    } else {
	      parentSize = [window.outerWidth, window.outerHeight];
	      parentPos = [window.screenX, window.screenY];
	      xPos = parentPos[0] + Math.max(0, Math.floor((parentSize[0] - width) / 2));
	      yPos = parentPos[1] + Math.max(0, Math.floor((parentSize[1] - (height * 1.25)) / 2));
	    }
	    yPos = 100;
	    return [xPos, yPos];
	  };
	
	  return OAuthHandler;
	
	})();
	
	OAuth_providers = ['google'];
	
	styles += ".oauth_wrapper {\n  display: flex;\n}\n\n.oauth_child_wrapper {\n  flex-grow: 4;\n}\n\n.oauth_providers_wrapper {\n  flex-grow: 0;\n}\n\n\n@media (min-width: 637px) {\n  .oauth_wrapper {\n\n  }\n\n  .oauth_child_wrapper {\n\n  }\n\n  .oauth_providers_wrapper {\n    border-left: 1px dashed #ccc;\n    margin-left: 40px;\n    padding: 15px 0 0 40px;\n  }\n}\n\n@media (max-width: 637px) {\n  .oauth_wrapper {\n    flex-direction: column;\n  }\n\n  .oauth_child_wrapper {\n\n  }\n\n  .oauth_providers_wrapper {\n    margin-top: 24px;\n  }\n}\n";
	
	window.OAuthLogin = {
	  startThirdPartyAuth: function(provider) {
	    var root;
	    root = fetch('root');
	    return new OAuthHandler({
	      provider: provider,
	      callback: (function(_this) {
	        return function(new_data) {
	          var auth, current_user, subdomain;
	          arest.updateCache(new_data);
	          subdomain = fetch('/subdomain');
	          if (subdomain.custom_url) {
	            current_user = fetch('/current_user');
	            current_user.trying_to = 'login';
	            save(current_user);
	          }
	          poll_until_avatar_arrives();
	          if (forum_has_host_questions() && fetch('/current_user').first_visit_to_forum) {
	            auth = fetch('auth');
	            auth.show_user_questions_after_account_creation = true;
	            return save(auth);
	          }
	        };
	      })(this)
	    });
	  },
	  WrapOAuth: function(form, children) {
	    return DIV({
	      className: 'oauth_wrapper'
	    }, DIV({
	      className: 'oauth_child_wrapper'
	    }, children), DIV({
	      className: 'oauth_providers_wrapper'
	    }, this.RenderOAuthProviders(form)));
	  },
	  RenderOAuthProviders: function(form) {
	    var current_user, provider, root, third_party_authenticated;
	    current_user = fetch('/current_user');
	    root = fetch('root');
	    third_party_authenticated = current_user.facebook_uid || current_user.twitter_uid || current_user.google_uid;
	    if (current_user.provider || third_party_authenticated) {
	      return SPAN(null);
	    }
	    return DIV({
	      className: 'third_party_auth'
	    }, LABEL(null, form === 'create_account' ? translator('auth.oauth.options_create-account', 'Or sign up using:') : translator('auth.oauth.options_login', 'Or log in using:')), (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = OAuth_providers.length; i < len; i++) {
	        provider = OAuth_providers[i];
	        results.push((function(_this) {
	          return function(provider) {
	            return BUTTON({
	              key: provider,
	              className: "third_party_option " + provider,
	              onClick: function() {
	                return _this.startThirdPartyAuth(provider);
	              }
	            }, provider === 'google' ? google_icon(22) : I({
	              className: "fa fa-" + provider
	            }), SPAN(null, provider));
	          };
	        })(this)(provider));
	      }
	      return results;
	    }).call(this));
	  }
	};
	
	styles += ".third_party_auth {\n  max-width: 75px;\n}\n.third_party_auth label {\n  font-size: 12px;\n  margin-bottom: 12px;\n  display: block;\n  white-space: nowrap;\n}\n.third_party_option.facebook span {\n  position: relative; \n  left: 12px;\n}\n.third_party_option {\n  border: 1px solid #bbb;\n  color: black;\n  width: 120px;\n  padding: 8px 0px;\n  margin-bottom: 12px;\n  text-align: center;\n  border-radius: 4px;\n  position: relative;\n  font-size: 11px;\n  text-transform: capitalize;\n  background-color: transparent;\n}\n\n.third_party_option svg {\n  vertical-align: middle;\n  position: relative; \n  left: -14px;\n}\n\n.third_party_option i {\n  display: inline-block;\n}\n\n.third_party_option i.fa-facebook {\n  color: #3C5997;\n  font-size: 24px;\n  position: relative;\n  left: -8px;\n  vertical-align: middle;\n}\n";


/***/ },
/* 32 */
/***/ function(module, exports) {

	window.AvatarInput = ReactiveComponent({
	  displayName: 'AvatarInput',
	  render: function() {
	    var base, current_user, img_preview_src, user;
	    if (!window.FormData) {
	      return SPAN(null);
	    }
	    current_user = fetch('/current_user');
	    user = fetch(fetch('/current_user').user);
	    if ((base = this.local).preview == null) {
	      base.preview = user.avatar_file_name || current_user.avatar_remote_url;
	    }
	    img_preview_src = this.local.newly_uploaded ? this.local.newly_uploaded : user.avatar_file_name ? avatarUrl(user, 'large') : current_user.avatar_remote_url ? current_user.avatar_remote_url : null;
	    return FORM({
	      id: 'user_avatar_form',
	      action: '/current_user'
	    }, DIV({
	      style: {
	        height: 60,
	        width: 60,
	        borderRadius: '50%',
	        backgroundColor: '#e6e6e6',
	        overflow: 'hidden',
	        display: 'inline-block',
	        marginRight: 18,
	        marginTop: 3
	      }
	    }, IMG({
	      alt: '',
	      id: 'avatar_preview',
	      ref: 'avatar_preview',
	      style: {
	        width: 60,
	        display: !this.local.preview ? 'none' : void 0
	      },
	      src: img_preview_src
	    }), !this.local.preview ? SVG({
	      width: 60,
	      viewBox: "0 0 100 100",
	      style: {
	        position: 'relative',
	        top: 8
	      }
	    }, PATH({
	      fill: "#ccc",
	      d: "M64.134,50.642c-0.938-0.75-1.93-1.43-2.977-2.023c8.734-6.078,10.867-18.086,4.797-26.805  c-6.086-8.727-18.086-10.875-26.82-4.797c-8.719,6.086-10.867,18.086-4.781,26.812c1.297,1.867,2.922,3.484,4.781,4.789  c-1.039,0.594-2.039,1.273-2.977,2.023c-6.242,5.031-11.352,11.312-15.023,18.438c-0.906,1.75-1.75,3.539-2.555,5.344  c17.883,16.328,45.266,16.328,63.133,0c-0.789-1.805-1.641-3.594-2.547-5.344C75.509,61.954,70.384,55.673,64.134,50.642z"
	    })) : void 0), INPUT({
	      id: 'user_avatar',
	      name: "avatar",
	      type: "file",
	      accept: "image/jpg, image/jpeg, image/pjpeg, image/png, image/x-png, image/gif, image/webp",
	      style: {
	        marginTop: 24,
	        verticalAlign: 'top'
	      },
	      onChange: (function(_this) {
	        return function(ev) {
	          var input, reader;
	          input = ev.target;
	          if (input.files && input.files[0]) {
	            reader = new FileReader();
	            reader.onload = function(e) {
	              _this.local.preview = true;
	              _this.local.newly_uploaded = e.target.result;
	              save(_this.local);
	              return _this.refs.avatar_preview.setAttribute('src', e.target.result);
	            };
	            return reader.readAsDataURL(input.files[0]);
	          } else {
	            return _this.refs.avatar_preview.setAttribute('src', asset('no_image_preview.png'));
	          }
	        };
	      })(this)
	    }));
	  }
	});
	
	window.upload_avatar = function() {
	  var avatar_file_input;
	  avatar_file_input = document.getElementById('user_avatar');
	  if ((avatar_file_input != null ? avatar_file_input.files.length : void 0) > 0) {
	    return ajax_submit_files_in_form({
	      type: 'PUT',
	      form: '#user_avatar_form',
	      additional_data: {
	        authenticity_token: arest.csrf(),
	        trying_to: 'update_avatar_hack'
	      },
	      success: function(resp) {
	        var errors, ref;
	        if (resp && (errors = (ref = JSON.parse(resp)[0]) != null ? ref.errors : void 0)) {
	          if (errors.length > 0) {
	            show_flash_error(errors[0]);
	          }
	        }
	        return poll_until_avatar_arrives();
	      },
	      error: function(problem) {
	        return console.error("Error uploading avatar", problem);
	      }
	    });
	  }
	};
	
	window.poll_until_avatar_arrives = function() {
	  var time_between, update_user;
	  time_between = 500;
	  update_user = function() {
	    var current_user, loading, user;
	    current_user = fetch('/current_user');
	    user = fetch(current_user.user || '/current_user');
	    if (!user.avatar_file_name) {
	      arest.serverFetch('/current_user');
	      time_between *= 1.5;
	      if (time_between < 100000) {
	        return setTimeout(update_user, time_between);
	      }
	    } else {
	      loading = fetch('avatar_loading');
	      if (loading.dummy == null) {
	        loading.dummy = 0;
	      }
	      loading.dummy += 1;
	      return save(loading);
	    }
	  };
	  return update_user();
	};


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(5);
	
	window.styles += "";
	
	window.VerifyEmail = ReactiveComponent({
	  displayName: 'VerifyEmail',
	  mixins: [AuthForm, Modal],
	  render: function() {
	    var auth, i18n, on_submit;
	    i18n = this.i18n();
	    auth = fetch('auth');
	    on_submit = (function(_this) {
	      return function(ev) {
	        return _this.Submit(ev, {
	          action: 'verify email'
	        });
	      };
	    })(this);
	    return this.Draw({
	      task: translator('auth.verify_email.heading', 'Verify Your Email'),
	      goal: auth.goal ? translator("auth.login_goal." + (auth.goal.toLowerCase()), auth.goal) : void 0,
	      on_submit: on_submit,
	      before_cancel: function() {
	        loadPage('/');
	        return setTimeout(logout, 1);
	      }
	    }, DIV(null, DIV({
	      style: {
	        color: auth_text_gray,
	        marginBottom: 18
	      }
	    }, i18n.verification_sent_message), this.RenderInput({
	      label: i18n.code_label,
	      name: 'verification_code',
	      on_submit: on_submit
	    }), this.ShowErrors()));
	  }
	});


/***/ },
/* 34 */
/***/ function(module, exports) {

	var GoogleDocEmbed, doc_groups;
	
	GoogleDocEmbed = ReactiveComponent({
	  displayName: 'GoogleDocEmbed',
	  render: function() {
	    return DIV({
	      style: {
	        width: '80%',
	        margin: 'auto',
	        maxWidth: 700
	      }
	    }, IFRAME({
	      ref: 'iframe',
	      width: '100%',
	      height: window.innerHeight,
	      src: this.props.link
	    }));
	  }
	});
	
	styles += ".Documentation {\n  background-color: #eee;\n  padding: 56px 0;\n}\n.doc_menu {\n}\n\n.doc_menu ul {\n  display: flex;\n  justify-content: center;\n}\n.doc_menu li {\n  padding: 6px 12px;\n  font-weight: 700;\n  display: inline-block;\n  list-style: none;\n  text-align: center;\n}\n.doc_menu li a {\n  text-decoration: none;\n  display: inline-block;    \n}\n.doc_menu li.active {\n  # background-color: " + (focus_color()) + ";\n  # color: white;\n  background-color: white;\n}\n\n.doc_groups {\n  display: flex;\n  justify-content: center; \n}\n\n.doc_group {\n  padding: 12px 24px;\n}\n\n.doc_group h2 {\n  font-size: 14px;\n}\n\n.doc_group ul {\n  list-style: none;\n}\n\n.doc_group li {\n  list-style: none;\n  padding-top: 8px;\n}\n\n.doc_group ul a {\n  text-decoration: none;\n  font-weight: 500;\n  color: #444;\n}\n\n.doc_group ul a:hover {\n  text-decoration: underline;\n}\n\n.doc_group ul .active a {\n  color: black;\n  text-decoration: underline;\n}\n\n\n@media " + NOT_PHONE_MEDIA + " {\n  .doc_groups {\n    flex-direction: row;\n  }\n}\n\n@media " + PHONE_MEDIA + " {\n  .doc_groups {\n    flex-direction: column;\n  }\n  .doc_group li, .doc_group h2 {\n    text-align: center;\n  }\n}\n";
	
	doc_groups = {
	  data: {
	    name: '',
	    groups: [
	      {
	        label: '',
	        docs: [
	          {
	            name: 'Data Export Documentation',
	            path: 'data_export'
	          }
	        ]
	      }
	    ]
	  },
	  legal: {
	    name: '',
	    groups: [
	      {
	        label: 'Terms',
	        docs: [
	          {
	            name: 'Terms of Service',
	            path: 'terms_of_service'
	          }, {
	            name: 'Forum Hosting Terms',
	            path: 'standard_hosting_terms'
	          }, {
	            name: 'Data Processing Addendum',
	            path: 'data_processing_addendum'
	          }
	        ]
	      }, {
	        label: 'Policies',
	        docs: [
	          {
	            name: 'Privacy Policy',
	            path: 'privacy_policy'
	          }, {
	            name: 'Acceptable Use',
	            path: 'use_restrictions'
	          }, {
	            name: 'Delete Your Data',
	            path: 'deleting_your_data'
	          }
	        ]
	      }, {
	        label: 'Background',
	        docs: [
	          {
	            name: 'Security Practices',
	            path: 'security'
	          }, {
	            name: 'Subprocessors',
	            path: 'subprocessors'
	          }
	        ]
	      }
	    ]
	  }
	};
	
	window.DocumentationGroup = ReactiveComponent({
	  displayName: 'DocumentationGroup',
	  render: function() {
	    var doc, ggroup, group, group_config, item, parts;
	    parts = fetch('location').url.split('/');
	    group = parts[parts.length - 2];
	    doc = parts[parts.length - 1];
	    group_config = doc_groups[group];
	    if (!group_config) {
	      return SPAN(null);
	    }
	    return DIV({
	      className: 'Documentation'
	    }, group_config.groups.length === 1 ? DIV({
	      className: 'doc_menu'
	    }, group_config.groups[0].docs.length > 1 ? UL({
	      style: {}
	    }, (function() {
	      var i, len, ref, results;
	      ref = group_config.groups[0].docs;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        item = ref[i];
	        fetch("/docs/" + item.path);
	        results.push(LI({
	          className: item.path === doc ? 'active' : void 0
	        }, A({
	          href: "/docs/" + group + "/" + item.path
	        }, item.name)));
	      }
	      return results;
	    })()) : void 0) : DIV({
	      className: 'doc_groups_container'
	    }, H1({
	      className: 'doc_center'
	    }, group_config.name), DIV({
	      className: 'doc_groups'
	    }, (function() {
	      var i, len, ref, results;
	      ref = group_config.groups;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        ggroup = ref[i];
	        results.push(DIV({
	          className: 'doc_group'
	        }, H2(null, ggroup.label), UL(null, (function() {
	          var j, len1, ref1, results1;
	          ref1 = ggroup.docs;
	          results1 = [];
	          for (j = 0, len1 = ref1.length; j < len1; j++) {
	            item = ref1[j];
	            fetch("/docs/" + item.path);
	            results1.push(LI({
	              className: item.path === doc ? 'active' : void 0
	            }, A({
	              href: "/docs/" + group + "/" + item.path
	            }, item.name)));
	          }
	          return results1;
	        })())));
	      }
	      return results;
	    })())), Documentation({
	      doc: doc
	    }));
	  }
	});
	
	styles += ".Documentation .markdown_doc {\n  width: 80%;\n  max-width: 1100px;\n  margin: 0px auto;\n  padding: 36px 86px;\n  background-color: white;\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 2px;  \n}\n\n@media " + NOT_LAPTOP_MEDIA + " {\n  .Documentation .markdown_doc {\n    width: 100%;\n    padding: 36px 48px;      \n  }\n  .doc_menu li a {\n    font-size: 14px;\n    min-width: 76px;\n  }\n\n}\n\n@media " + PHONE_MEDIA + " {\n  .Documentation .markdown_doc {\n    width: 100%;\n    padding: 36px 24px;      \n  }\n  .doc_menu li {\n    padding: 6px 6px;\n  }\n\n  .doc_menu li a {\n    font-size: 14px;\n    min-width: 65px;\n  }\n\n}\n\n.markdown-body {\n  padding: 40px 36px; \n  max-width: 872px;\n  margin: auto;       \n}\n\n.markdown-body a {\n  text-decoration: underline; \n  color:" + considerit_red + ";    \n}\n.markdown-body li {\n  list-style-position: outside;\n  padding: 0px 0px 8px 12px;\n}\n\n.markdown-body b, .markdown-body strong {\n  color: black;\n}\n";
	
	window.Documentation = ReactiveComponent({
	  displayName: 'Documentation',
	  render: function() {
	    var html;
	    html = fetch("/docs/" + this.props.doc).html;
	    if (!html) {
	      return SPAN(null);
	    }
	    return DIV({
	      className: 'markdown_doc'
	    }, LINK({
	      rel: 'stylesheet',
	      type: 'text/css',
	      href: asset("../vendor/github-markdown.css")
	    }), DIV({
	      className: 'markdown-body',
	      dangerouslySetInnerHTML: {
	        __html: html
	      }
	    }));
	  }
	});


/***/ },
/* 35 */
/***/ function(module, exports) {

	window.$$ = {
	  add_delegated_listener: function(el, eventName, selector, callback) {
	    return el.addEventListener(eventName, function(e) {
	      var results, target;
	      try {
	        target = e.target;
	        results = [];
	        while (target && target !== el) {
	          if (target.matches(selector)) {
	            callback.call(target, e);
	            break;
	          }
	          results.push(target = target.parentNode);
	        }
	        return results;
	      } catch (error) {
	        e = error;
	        console.log('Got error in add_delegated_listener');
	        return console.error(e);
	      }
	    }, false);
	  },
	  closest: function(el, selector) {
	    var current_el, matchesSelector;
	    if (el.closest != null) {
	      return el.closest(selector);
	    } else {
	      matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
	      current_el = el;
	      while (current_el) {
	        if (matchesSelector.call(current_el, selector)) {
	          return current_el;
	        } else {
	          current_el = current_el.parentElement;
	        }
	      }
	      return null;
	    }
	  },
	  height: function(el) {
	    return Math.round(el.clientHeight);
	  },
	  width: function(el) {
	    return Math.round(el.getBoundingClientRect().width);
	  },
	  offset: function(el) {
	    var left, rect, top;
	    rect = el.getBoundingClientRect();
	    top = rect.top + window.pageYOffset - document.documentElement.clientTop;
	    left = rect.left + window.pageXOffset - document.documentElement.clientLeft;
	    return {
	      top: top,
	      left: left
	    };
	  },
	  offsetParent: function(el) {
	    return el.offsetParent || el;
	  },
	  scrollTop: function(el) {
	    if (el == null) {
	      el = document;
	    }
	    return (el.documentElement && el.documentElement.scrollTop) || el.body.scrollTop;
	  },
	  animate: function(el, params, speed) {
	    var k, results, v;
	    el.style.transition = 'all ' + speed;
	    results = [];
	    for (k in params) {
	      v = params[k];
	      results.push(el.style[k] = v);
	    }
	    return results;
	  },
	  ensureInView: function(el, options) {
	    var bottom_inside, distance_to_travel, doc_bottom, doc_height, doc_top, e, el_bottom, el_height, el_top, is_onscreen, no_adjustment_needed, target, top_inside;
	    if (options == null) {
	      options = {};
	    }
	    if (!el) {
	      options.callback();
	      return;
	    }
	    try {
	      _.defaults(options, {
	        fill_threshold: 0,
	        offset_buffer: 36,
	        scroll: true,
	        position: 'top',
	        speed: null,
	        speed_mult: 1,
	        callback: function() {}
	      });
	      el_height = $$.height(el) + (options.extra_height || 0);
	      el_top = $$.offset(el).top;
	      el_bottom = el_top + el_height;
	      doc_height = $$.height(document.body);
	      doc_top = $$.scrollTop();
	      doc_bottom = doc_top + doc_height;
	      is_onscreen = el_top > doc_top && el_bottom < doc_bottom;
	      bottom_inside = el_bottom < doc_bottom && (el_bottom - doc_top) > options.fill_threshold * el_height;
	      top_inside = el_top > doc_top && (doc_bottom - el_top) > options.fill_threshold * el_height;
	      no_adjustment_needed = !options.force && is_onscreen && top_inside && bottom_inside;
	      if (!no_adjustment_needed) {
	        switch (options.position) {
	          case 'top':
	            target = el_top - options.offset_buffer;
	            break;
	          case 'bottom':
	            target = el_bottom - doc_height + options.offset_buffer;
	            break;
	          default:
	            throw 'bad position for ensureInView';
	        }
	        if (options.scroll) {
	          distance_to_travel = options.speed || Math.abs(doc_top - (el_top - options.offset_buffer));
	          if (options.dom_possibly_shifting) {
	            if (options.position !== 'top') {
	              console.error("smoothScrollToTargetWithChangingElement doesn't support position targets except 'top'");
	            }
	            return $$.smoothScrollToTargetWithChangingElements({
	              el: el,
	              offset_buffer: options.offset_buffer,
	              duration: options.speed_mult * Math.min(distance_to_travel, 1500),
	              callback: options.callback
	            });
	          } else {
	            return $$.smoothScrollToTarget({
	              target: el_top - options.offset_buffer,
	              duration: options.speed_mult * Math.min(distance_to_travel, 1500),
	              callback: options.callback
	            });
	          }
	        } else {
	          window.scrollTo(0, target);
	          return options.callback();
	        }
	      } else {
	        return options.callback();
	      }
	    } catch (error) {
	      e = error;
	      console.log("Error in ensureInView");
	      return console.error(e);
	    }
	  },
	  ensure_in_viewport_when_appears: function(selector) {
	    var viewport_ensurer;
	    return viewport_ensurer = setInterval(function() {
	      var el;
	      el = document.querySelector(selector);
	      if (el) {
	        $$.ensureInView(el, {
	          scroll: true
	        });
	        return clearInterval(viewport_ensurer);
	      }
	    }, 10);
	  },
	  smoothScrollToTargetWithChangingElements: function(arg) {
	    var callback, diff, dist_per_frame, duration, el, frames, iter, offset_buffer, target;
	    duration = arg.duration, callback = arg.callback, el = arg.el, offset_buffer = arg.offset_buffer;
	    target = $$.offset(el).top - offset_buffer;
	    diff = target - window.pageYOffset;
	    frames = 60 * duration / 1000;
	    dist_per_frame = diff / frames;
	    iter = function(current_time) {
	      var done, e, scroll_to, top;
	      try {
	        top = el.getBoundingClientRect().top;
	        if (diff < 0) {
	          done = top + dist_per_frame > offset_buffer;
	        } else {
	          done = top - dist_per_frame < offset_buffer;
	        }
	        done || (done = document.documentElement.scrollHeight - document.documentElement.scrollTop - document.documentElement.clientHeight <= 0);
	        if (done) {
	          dist_per_frame = top - offset_buffer;
	        }
	        scroll_to = window.pageYOffset + dist_per_frame;
	        window.scrollTo(0, scroll_to);
	        if (!done) {
	          return requestAnimationFrame(iter);
	        } else {
	          return typeof callback === "function" ? callback() : void 0;
	        }
	      } catch (error) {
	        e = error;
	        console.log("Error in smoothScrollToTargetWithChangingElements");
	        return console.error(e);
	      }
	    };
	    return requestAnimationFrame(iter);
	  },
	  smoothScrollToTarget: function(arg) {
	    var callback, diff, duration, iter, requestId, start_pos, start_time, target;
	    target = arg.target, duration = arg.duration, callback = arg.callback;
	    start_pos = window.pageYOffset;
	    diff = target - start_pos;
	    start_time = null;
	    iter = function(current_time) {
	      var e, percent, requestId, time;
	      try {
	        if (!start_time) {
	          start_time = current_time;
	        }
	        time = current_time - start_time;
	        percent = Math.min(time / duration, 1);
	        window.scrollTo(0, start_pos + diff * percent);
	        if (time < duration) {
	          return requestId = window.requestAnimationFrame(iter);
	        } else {
	          window.cancelAnimationFrame(requestId);
	          return typeof callback === "function" ? callback() : void 0;
	        }
	      } catch (error) {
	        e = error;
	        console.log("Got error in smoothScrollToTarget");
	        return console.error(e);
	      }
	    };
	    return requestId = window.requestAnimationFrame(iter);
	  },
	  moveToTop: function(el, options) {
	    var el_bottom, el_top, target;
	    if (options == null) {
	      options = {};
	    }
	    _.defaults(options, {
	      offset_buffer: 50
	    });
	    el_top = $$.offset(el).top;
	    el_bottom = target = el_top - options.offset_buffer;
	    return window.scrollTo(0, target);
	  },
	  setStyles: function(selector, styles) {
	    var el, els, i, k, len, results, v;
	    els = document.querySelectorAll(selector);
	    results = [];
	    for (i = 0, len = els.length; i < len; i++) {
	      el = els[i];
	      results.push((function() {
	        var results1;
	        results1 = [];
	        for (k in styles) {
	          v = styles[k];
	          if (k.indexOf('-') > -1) {
	            results1.push(el.style.setProperty(k, v));
	          } else {
	            results1.push(el.style[k] = v);
	          }
	        }
	        return results1;
	      })());
	    }
	    return results;
	  }
	};


/***/ },
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ function(module, exports) {

	window.iconX = function(size, color) {
	  if (size == null) {
	    size = 30;
	  }
	  if (color == null) {
	    color = 'black';
	  }
	  return SVG({
	    width: size,
	    height: size,
	    viewBox: "-50 -50 200 200",
	    stroke: color,
	    fill: 'none',
	    dangerouslySetInnerHTML: {
	      __html: "<g>\n <path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"15\" d=\"M 0 0 L 100 100 M 0 100 L 100 0 Z\"/>\n</g>"
	    }
	  });
	};
	
	window.iconAnonymousMask = function(height, color) {
	  var width;
	  if (color == null) {
	    color = 'black';
	  }
	  width = 1.4 * height;
	  return SVG({
	    width: width,
	    height: height,
	    viewBox: "-350 0 700 200",
	    stroke: color,
	    dangerouslySetInnerHTML: {
	      __html: "\n<g style=\"\">\n  <path fill=\"" + color + "\" style=\"\" d=\"M -7.3 130.8 L 75 150.1 C 69.8 117.1 190.9 87.7 217.7 105 C 252.3 147.9 119.5 270.8 73.8 150 L -2.4 119.5 C -5.6 140.7 -10.6 159.4 0.9 195.4 C 59.3 197.1 67.4 258.4 108.2 280.2 S 193.8 295.9 225.6 294.9 C 263 290.8 284.4 271.3 301 230.8 C 315 187.8 317 154.8 314.3 107.8 C 309.2 73.3 291.1 41.9 264.8 27.6 c -54.7 -31.2 -216.8 15.1 -266.7 15.9 Z\"></path>\n  <path fill=\"" + color + "\" style=\"\" d=\"M -7.3 130.8 L 75 150.1 C 69.8 117.1 190.9 87.7 217.7 105 C 252.3 147.9 119.5 270.8 73.8 150 L -2.4 119.5 C -5.6 140.7 -10.6 159.4 0.9 195.4 C 59.3 197.1 67.4 258.4 108.2 280.2 S 193.8 295.9 225.6 294.9 C 263 290.8 284.4 271.3 301 230.8 C 315 187.8 317 154.8 314.3 107.8 C 309.2 73.3 291.1 41.9 264.8 27.6 c -54.7 -31.2 -216.8 15.1 -266.7 15.9 Z\"\n    transform=\"scale(-1, 1)\"></path>\n</g>"
	    }
	  });
	};
	
	window.closedIcon = function(arg) {
	  var fill, size;
	  size = arg.size, fill = arg.fill;
	  if (fill == null) {
	    fill = 'black';
	  }
	  return SVG({
	    width: size,
	    height: size,
	    viewBox: "0 0 700 700",
	    dangerouslySetInnerHTML: {
	      __html: "\n<g style=\"\">\n  <path fill=\"" + fill + "\" d=\"M 564.996 591.909 C 558.141 591.909 551.293 589.222 546.053 583.981 L 116.152 154.08 C 105.672 143.6 105.672 126.54 116.152 116.06 C 126.632 105.58 143.692 105.58 154.172 116.06 L 584.073 545.961 C 594.553 556.443 594.553 573.501 584.073 583.981 C 578.697 589.222 571.85 591.909 564.996 591.909 Z\" style=\"\"></path>\n  <path fill=\"" + fill + "\" d=\"M 350.052 699.388 C 256.819 699.388 169.093 663.117 103.126 597.018 C 37.032 531.054 0.755 443.334 0.755 350.091 C 0.755 256.848 37.026 169.132 103.126 103.165 C 169.225 37.197 256.809 0.794 350.052 0.794 C 443.295 0.794 531.012 37.065 596.979 103.165 C 662.946 169.264 699.349 256.848 699.349 350.091 C 699.349 443.334 663.078 531.051 596.979 597.018 C 531.015 663.111 443.295 699.388 350.052 699.388 Z M 350.052 54.544 C 187.099 54.544 54.503 187.141 54.503 350.093 C 54.503 513.045 187.101 645.642 350.052 645.642 C 513.005 645.642 645.601 513.044 645.601 350.093 C 645.601 187.14 513.009 54.544 350.052 54.544 Z\" style=\"\"></path>\n</g>"
	    }
	  });
	};
	
	window.ThreeDotsIcon = function(arg) {
	  var fill, size;
	  size = arg.size, fill = arg.fill;
	  if (fill == null) {
	    fill = 'black';
	  }
	  return SVG({
	    width: size,
	    height: size,
	    viewBox: "0 0 700 700",
	    dangerouslySetInnerHTML: {
	      __html: "<g>\n <path fill=\"" + fill + "\" d=\"m419.35 280c0 38.301-31.047 69.348-69.348 69.348s-69.348-31.047-69.348-69.348 31.047-69.348 69.348-69.348 69.348 31.047 69.348 69.348\"/>\n <path fill=\"" + fill + "\" d=\"m419.35 98.512c0 38.301-31.047 69.348-69.348 69.348s-69.348-31.047-69.348-69.348c0-38.297 31.047-69.344 69.348-69.344s69.348 31.047 69.348 69.344\"/>\n <path fill=\"" + fill + "\" d=\"m419.35 461.49c0 38.297-31.047 69.344-69.348 69.344s-69.348-31.047-69.348-69.344c0-38.301 31.047-69.348 69.348-69.348s69.348 31.047 69.348 69.348\"/>\n</g>"
	    }
	  });
	};
	
	window.double_up_icon = function(size) {
	  return SVG({
	    width: size,
	    height: size,
	    viewBox: "0 0 66 66",
	    dangerouslySetInnerHTML: {
	      __html: "<g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n    <g transform=\"translate(-869.000000, -2725.000000)\">\n        <g transform=\"translate(870.000000, 2726.000000)\">\n            <circle stroke=\"#D1D1D1\" fill=\"#F0F0F0\" cx=\"32\" cy=\"32\" r=\"32\"></circle>\n            <path d=\"M45.7016044,27.11626 C46.2524214,27.6626885 46.5621531,28.4064037 46.5621531,29.1816368 C46.5621531,29.957456 46.252409,30.7011836 45.7016044,31.2470136 C45.1556622,31.7978306 44.4119595,32.1075624 43.6362276,32.1075624 C42.8608947,32.1075624 42.1171795,31.7978182 41.5708508,31.2470136 L32,21.6469887 L22.4291492,31.2470136 C21.6913187,31.9853304 20.6154925,32.2731566 19.6073652,32.003346 C18.5997366,31.7330492 17.8122852,30.9455479 17.5419884,29.9379692 C17.2721778,28.9298544 17.5600078,27.8540157 18.2983208,27.1161852 L29.9345484,15.4799576 C30.4809768,14.9291406 31.2241933,14.6194089 31.9999252,14.6194089 C32.7756571,14.6194089 33.5189733,14.9291531 34.065302,15.4799576 L45.7016044,27.11626 Z M34.0653768,28.9346232 C33.5189484,28.3838062 32.7757319,28.0740745 32,28.0740745 C31.2242681,28.0740745 30.4809519,28.3838187 29.9346232,28.9346232 L18.2983956,40.5708508 C17.5600789,41.3086813 17.2722527,42.3845075 17.5420632,43.3926348 C17.81236,44.4002634 18.5998613,45.1877148 19.60744,45.4580116 C20.6155548,45.7278222 21.6913935,45.4399922 22.429224,44.7016792 L32.0000748,35.1016543 L41.5709256,44.7016792 C42.1173541,45.2524962 42.8610692,45.562228 43.6363024,45.562228 C44.4121216,45.562228 45.1558492,45.2524838 45.7016792,44.7016792 C46.2524962,44.155737 46.562228,43.4120343 46.562228,42.6363024 C46.562228,41.8609695 46.2524838,41.1172543 45.7016792,40.5709256 L34.0653768,28.9346232 Z\" fill=\"#9D9D9D\"></path>\n        </g>\n    </g>\n</g>"
	    }
	  });
	};
	
	window.plusIcon = function(outline_color, size) {
	  if (size == null) {
	    size = 30;
	  }
	  return SVG({
	    width: size,
	    height: size,
	    fill: outline_color || 'white',
	    viewBox: "50 50 600 450",
	    dangerouslySetInnerHTML: {
	      __html: "<g>\n <path d=\"m350 28c-66.836 0-130.93 26.551-178.19 73.809-47.258 47.258-73.809 111.36-73.809 178.19s26.551 130.93 73.809 178.19c47.258 47.258 111.36 73.809 178.19 73.809s130.93-26.551 178.19-73.809c47.258-47.258 73.809-111.36 73.809-178.19 0-44.234-11.645-87.691-33.762-126-22.117-38.309-53.93-70.121-92.238-92.238-38.309-22.117-81.766-33.762-126-33.762zm0 470.4c-57.922 0-113.47-23.008-154.43-63.965-40.957-40.961-63.965-96.512-63.965-154.43s23.008-113.47 63.965-154.43c40.961-40.957 96.512-63.965 154.43-63.965s113.47 23.008 154.43 63.965c40.957 40.961 63.965 96.512 63.965 154.43s-23.008 113.47-63.965 154.43c-40.961 40.957-96.512 63.965-154.43 63.965z\"/>\n <path d=\"m456.4 257.6h-84v-84h-44.797v84h-84v44.797h84v84h44.797v-84h84z\"/>\n</g>"
	    }
	  });
	};
	
	window.checkmark = function(size, color) {
	  var d;
	  if (size == null) {
	    size = 24;
	  }
	  if (color == null) {
	    color = "currentColor";
	  }
	  return SVG({
	    width: size,
	    height: size,
	    xmlns: "http://www.w3.org/2000/svg",
	    viewBox: "0 0 700 700",
	    fill: color
	  }, PATH({
	    d: d = "m514.59 195.66-34.609-34.551-168.56 168.61-91.559-91.559-34.441 35.727 126 124.99z"
	  }));
	};
	
	window.ChevronRight = function(size) {
	  if (size == null) {
	    size = 24;
	  }
	  return SVG({
	    width: size,
	    height: size,
	    xmlns: "http://www.w3.org/2000/svg",
	    viewBox: "0 0 24 24",
	    stroke: "currentColor"
	  }, PATH({
	    strokeLinecap: "round",
	    strokeLinejoin: "round",
	    strokeWidth: "2",
	    d: "M9 5l7 7-7 7",
	    fill: 'none'
	  }));
	};
	
	window.ChevronLeft = function(size) {
	  if (size == null) {
	    size = 24;
	  }
	  return SVG({
	    width: size,
	    height: size,
	    xmlns: "http://www.w3.org/2000/svg",
	    viewBox: "0 0 24 24",
	    stroke: "currentColor"
	  }, PATH({
	    strokeLinecap: "round",
	    strokeWidth: "2",
	    d: "M15 19l-7-7 7-7",
	    fill: 'none'
	  }));
	};
	
	window.HelpIcon = function(help_text, style) {
	  if (style == null) {
	    style = {};
	  }
	  return BUTTON({
	    "data-tooltip": help_text,
	    style: _.defaults(style || {}, {
	      backgroundColor: 'transparent',
	      border: 'none',
	      padding: 0,
	      display: 'inline-block',
	      width: style.width || 17,
	      height: style.height || 17
	    })
	  }, SVG({
	    width: style.width || 17,
	    height: style.height || 17,
	    viewBox: "0 0 17 17.0000094",
	    style: {
	      pointerEvents: 'none'
	    }
	  }, G({
	    stroke: "none",
	    strokeWidth: "1",
	    fill: "none",
	    fillRule: "evenodd"
	  }, G({
	    transform: "translate(0.000000, 0.000000)",
	    fill: style.color || "#666",
	    fillRule: "nonzero"
	  }, PATH({
	    d: "M8.5,2.833339 C7.71759653,2.833339 7.08333333,3.4676022 7.08333333,4.25000567 C7.08333333,5.03240913 7.71759653,5.66667233 8.5,5.66667233 C9.28240347,5.66667233 9.91666667,5.03240913 9.91666667,4.25000567 C9.91666667,3.4676022 9.28240347,2.833339 8.5,2.833339 Z M6.61111111,6.61111678 L7.55555556,7.55556122 L7.55555556,13.2222279 L6.61111111,13.2222279 L6.61111111,14.1666723 L10.3888889,14.1666723 L10.3888889,13.2222279 L9.44444444,13.2222279 L9.44444444,6.61111678 L7.55555556,6.61111678 L6.61111111,6.61111678 Z"
	  }), PATH({
	    d: "M8.5,2.14741805e-14 C3.81117296,2.14741805e-14 0,3.81117333 0,8.5 C0,13.1888361 3.81117296,17 8.5,17 C13.188827,17 17,13.1888361 17,8.5 C17,3.81117333 13.188827,2.14741805e-14 8.5,2.14741805e-14 Z M8.5,0.944444444 C12.6784115,0.944444444 16.0555556,4.32158889 16.0555556,8.49999056 C16.0555556,12.6784206 12.6784115,16.055565 8.5,16.055565 C4.32158851,16.055565 0.944444444,12.6784206 0.944444444,8.49999056 C0.944444444,4.32158889 4.32158851,0.944444444 8.5,0.944444444 Z"
	  })))));
	};
	
	window.GearIcon = function(opts) {
	  return SVG({
	    height: opts.size || '100px',
	    width: opts.size || '100px',
	    fill: opts.fill || "#888",
	    x: "0px",
	    y: "0px",
	    viewBox: "0 0 100 100",
	    dangerouslySetInnerHTML: {
	      __html: '<path d="M95.784,59.057c1.867,0,3.604-1.514,3.858-3.364c0,0,0.357-2.6,0.357-5.692c0-3.092-0.357-5.692-0.357-5.692  c-0.255-1.851-1.991-3.364-3.858-3.364h-9.648c-1.868,0-3.808-1.191-4.31-2.646s-1.193-6.123,0.128-7.443l6.82-6.82  c1.32-1.321,1.422-3.575,0.226-5.01L80.976,11c-1.435-1.197-3.688-1.095-5.01,0.226l-6.82,6.82c-1.32,1.321-3.521,1.853-4.888,1.183  c-1.368-0.67-5.201-3.496-5.201-5.364V4.217c0-1.868-1.514-3.604-3.364-3.859c0,0-2.6-0.358-5.692-0.358s-5.692,0.358-5.692,0.358  c-1.851,0.254-3.365,1.991-3.365,3.859v9.648c0,1.868-1.19,3.807-2.646,4.31c-1.456,0.502-6.123,1.193-7.444-0.128l-6.82-6.82  C22.713,9.906,20.459,9.804,19.025,11L11,19.025c-1.197,1.435-1.095,3.689,0.226,5.01l6.819,6.82  c1.321,1.321,1.854,3.521,1.183,4.888s-3.496,5.201-5.364,5.201H4.217c-1.868,0-3.604,1.514-3.859,3.364c0,0-0.358,2.6-0.358,5.692  c0,3.093,0.358,5.692,0.358,5.692c0.254,1.851,1.991,3.364,3.859,3.364h9.648c1.868,0,3.807,1.19,4.309,2.646  c0.502,1.455,1.193,6.122-0.128,7.443l-6.819,6.819c-1.321,1.321-1.423,3.575-0.226,5.01L19.025,89  c1.435,1.196,3.688,1.095,5.009-0.226l6.82-6.82c1.321-1.32,3.521-1.853,4.889-1.183c1.368,0.67,5.201,3.496,5.201,5.364v9.648  c0,1.867,1.514,3.604,3.365,3.858c0,0,2.599,0.357,5.692,0.357s5.692-0.357,5.692-0.357c1.851-0.255,3.364-1.991,3.364-3.858v-9.648  c0-1.868,1.19-3.808,2.646-4.31s6.123-1.192,7.444,0.128l6.819,6.82c1.321,1.32,3.575,1.422,5.01,0.226L89,80.976  c1.196-1.435,1.095-3.688-0.227-5.01l-6.819-6.819c-1.321-1.321-1.854-3.521-1.183-4.889c0.67-1.368,3.496-5.201,5.364-5.201H95.784  z M50,68.302c-10.108,0-18.302-8.193-18.302-18.302c0-10.107,8.194-18.302,18.302-18.302c10.108,0,18.302,8.194,18.302,18.302  C68.302,60.108,60.108,68.302,50,68.302z"></path>'
	    }
	  });
	};
	
	window.drag_icon = function(height, color) {
	  var width;
	  width = height * 14 / 20;
	  return SVG({
	    viewBox: "0 0 14 20",
	    stroke: 'none',
	    fill: color,
	    width: width,
	    height: height,
	    dangerouslySetInnerHTML: {
	      __html: "<g>\n    <circle id=\"Oval\" cx=\"2\" cy=\"2\" r=\"2\"></circle>\n    <circle id=\"Oval\" cx=\"2\" cy=\"10\" r=\"2\"></circle>\n    <circle id=\"Oval\" cx=\"2\" cy=\"18\" r=\"2\"></circle>\n    <circle id=\"Oval\" cx=\"12\" cy=\"18\" r=\"2\"></circle>\n    <circle id=\"Oval\" cx=\"12\" cy=\"10\" r=\"2\"></circle>\n    <circle id=\"Oval\" cx=\"12\" cy=\"2\" r=\"2\"></circle>\n</g>"
	    }
	  });
	};
	
	window.edit_icon = function(width, height, color) {
	  return SVG({
	    viewBox: "0 0 24 24",
	    stroke: color,
	    fill: 'none',
	    width: width,
	    height: height,
	    dangerouslySetInnerHTML: {
	      __html: "<path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z\" />"
	    }
	  });
	};
	
	window.trash_icon = function(width, height, color) {
	  return SVG({
	    viewBox: "0 0 24 24",
	    stroke: color,
	    fill: 'none',
	    width: width,
	    height: height,
	    dangerouslySetInnerHTML: {
	      __html: "<path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16\" />"
	    }
	  });
	};
	
	window.filter_icon = function(height) {
	  if (height == null) {
	    height = 27;
	  }
	  return SVG({
	    className: 'opinion_view_class',
	    width: 33 / 27 * height,
	    height: height,
	    viewBox: "0 0 33 27",
	    dangerouslySetInnerHTML: {
	      __html: "<g id=\"final-push,-filters,-weights,-group-by\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n    <g id=\"Artboard-Copy-47\" transform=\"translate(-373.000000, -868.000000)\">\n        <g id=\"Group-22\" transform=\"translate(333.000000, 843.000000)\">\n            <g id=\"filter2\" transform=\"translate(40.000000, 25.000000)\">\n                <circle id=\"Oval\" fill-opacity=\"0.491815314\" fill=\"#B0B0B0\" cx=\"4.5\" cy=\"4.5\" r=\"4.5\"></circle>\n                <circle id=\"Oval\" fill-opacity=\"0.491815314\" fill=\"#B0B0B0\" cx=\"15.5\" cy=\"4.5\" r=\"4.5\"></circle>\n                <circle id=\"Oval\" fill=\"#5F5E5E\" cx=\"15.5\" cy=\"22.5\" r=\"4.5\"></circle>\n                <circle id=\"Oval\" fill-opacity=\"0.491815314\" fill=\"#B0B0B0\" cx=\"25.5\" cy=\"4.5\" r=\"4.5\"></circle>\n                <line x1=\"2.1744186\" y1=\"13\" x2=\"31.8255814\" y2=\"13\" id=\"Line\" stroke=\"#757575\" stroke-linecap=\"square\" stroke-dasharray=\"0,2\"></line>\n            </g>\n        </g>\n    </g>\n</g>"
	    }
	  });
	};
	
	window.group_by_icon = function(height) {
	  if (height == null) {
	    height = 19;
	  }
	  return SVG({
	    className: 'opinion_view_class',
	    width: 34 / 19 * height,
	    height: height,
	    viewBox: "0 0 34 19",
	    dangerouslySetInnerHTML: {
	      __html: "<g id=\"final-push,-filters,-weights,-group-by\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n    <g id=\"Artboard-Copy-47\" transform=\"translate(-371.000000, -937.000000)\">\n        <g id=\"Group-22\" transform=\"translate(333.000000, 843.000000)\">\n            <g id=\"weigh\" transform=\"translate(39.000000, 94.000000)\">\n                <circle id=\"Oval\" fill=\"#F09552\" cx=\"6.45454545\" cy=\"13.1818182\" r=\"5\"></circle>\n                <circle id=\"Oval\" fill=\"#F09552\" cx=\"16.2727273\" cy=\"13\" r=\"5\"></circle>\n                <circle id=\"Oval\" fill=\"#5E91E9\" cx=\"10.8181818\" cy=\"5\" r=\"5\"></circle>\n                <circle id=\"Oval\" fill=\"#BC62C4\" cx=\"27.8181818\" cy=\"13\" r=\"5\"></circle>\n                <line x1=\"0.228571429\" y1=\"18.4545455\" x2=\"31.7714286\" y2=\"18.4545455\" id=\"Line\" stroke=\"#A7A7A7\" stroke-linecap=\"square\"></line>\n            </g>\n        </g>\n    </g>\n</g>"
	    }
	  });
	};
	
	window.weigh_icon = function(height) {
	  if (height == null) {
	    height = 18;
	  }
	  return SVG({
	    className: 'opinion_view_class',
	    width: height * 34 / 18,
	    height: height,
	    viewBox: "0 0 34 18",
	    dangerouslySetInnerHTML: {
	      __html: "<g id=\"final-push,-filters,-weights,-group-by\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n    <g id=\"Artboard-Copy-47\" transform=\"translate(-372.000000, -759.000000)\">\n        <g id=\"Group-22\" transform=\"translate(333.000000, 602.000000)\">\n            <g id=\"weigh\" transform=\"translate(40.000000, 157.000000)\">\n                <circle id=\"Oval\" fill=\"#9C9C9C\" cx=\"4.36363636\" cy=\"13.0909091\" r=\"2.90909091\"></circle>\n                <circle id=\"Oval\" fill=\"#9C9C9C\" cx=\"27.6363636\" cy=\"13.0909091\" r=\"4.36363636\"></circle>\n                <circle id=\"Oval\" fill=\"#9C9C9C\" cx=\"13.8181818\" cy=\"8\" r=\"8\"></circle>\n                <line x1=\"0.228571429\" y1=\"17.4545455\" x2=\"31.7714286\" y2=\"17.4545455\" id=\"Line\" stroke=\"#A7A7A7\" stroke-linecap=\"square\"></line>\n            </g>\n        </g>\n    </g>\n</g>"
	    }
	  });
	};
	
	window.date_icon = function(activated) {
	  return SVG({
	    width: 13,
	    height: 12,
	    viewBox: "0 0 96 86",
	    dangerouslySetInnerHTML: {
	      __html: "\n<g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n    <g transform=\"translate(-234.000000, -823.000000)\" fill=\"" + (activated ? '#ffffff' : '#000000') + "\" fill-rule=\"nonzero\">\n        <g transform=\"translate(234.500000, 823.000000)\">\n            <path d=\"M84.3,5.7 L73.1,5.7 L73.1,2.9 C73.1,1.3 71.8,-1.77635684e-15 70.2,-1.77635684e-15 C68.6,-1.77635684e-15 67.3,1.3 67.3,2.9 L67.3,5.7 L50.4,5.7 L50.4,2.9 C50.4,1.3 49.1,-1.77635684e-15 47.5,-1.77635684e-15 C45.9,-1.77635684e-15 44.6,1.3 44.6,2.9 L44.6,5.7 L27.7,5.7 L27.7,2.9 C27.7,1.3 26.4,-1.77635684e-15 24.8,-1.77635684e-15 C23.2,-1.77635684e-15 21.9,1.3 21.9,2.9 L21.9,5.7 L10.7,5.7 C4.8,5.7 0,10.5 0,16.4 L0,75.2 C0,81.1 4.8,85.9 10.7,85.9 L84.4,85.9 C90.3,85.9 95.1,81.1 95.1,75.2 L95.1,16.4 C95,10.5 90.2,5.7 84.3,5.7 Z M89.2,75.1 C89.2,77.8 87,79.9 84.4,79.9 L10.7,79.9 C8,79.9 5.9,77.7 5.9,75.1 L5.9,16.4 C5.9,13.7 8.1,11.6 10.7,11.6 L21.9,11.6 L21.9,14.4 C21.9,16 23.2,17.3 24.8,17.3 C26.4,17.3 27.7,16 27.7,14.4 L27.7,11.6 L44.6,11.6 L44.6,14.4 C44.6,16 45.9,17.3 47.5,17.3 C49.1,17.3 50.4,16 50.4,14.4 L50.4,11.6 L67.3,11.6 L67.3,14.4 C67.3,16 68.6,17.3 70.2,17.3 C71.8,17.3 73.1,16 73.1,14.4 L73.1,11.6 L84.3,11.6 C87,11.6 89.1,13.8 89.1,16.4 L89.1,75.1 L89.2,75.1 Z\" id=\"Shape\"></path>\n            <path d=\"M29.9,27.9 L21.4,27.9 C19.8,27.9 18.6,29.2 18.6,30.7 C18.6,32.3 19.9,33.5 21.4,33.5 L29.9,33.5 C31.5,33.5 32.7,32.2 32.7,30.7 C32.8,29.2 31.5,27.9 29.9,27.9 Z\" id=\"Path\"></path>\n            <path d=\"M73.6,27.9 L65.1,27.9 C63.5,27.9 62.3,29.2 62.3,30.7 C62.3,32.3 63.6,33.5 65.1,33.5 L73.6,33.5 C75.2,33.5 76.4,32.2 76.4,30.7 C76.4,29.2 75.1,27.9 73.6,27.9 Z\" id=\"Path\"></path>\n            <path d=\"M51.7,27.9 L43.2,27.9 C41.6,27.9 40.4,29.2 40.4,30.7 C40.4,32.3 41.7,33.5 43.2,33.5 L51.7,33.5 C53.3,33.5 54.5,32.2 54.5,30.7 C54.6,29.2 53.3,27.9 51.7,27.9 Z\" id=\"Path\"></path>\n            <path d=\"M29.9,45.2 L21.4,45.2 C19.8,45.2 18.6,46.5 18.6,48 C18.6,49.6 19.9,50.8 21.4,50.8 L29.9,50.8 C31.5,50.8 32.7,49.5 32.7,48 C32.8,46.5 31.5,45.2 29.9,45.2 Z\" id=\"Path\"></path>\n            <path d=\"M73.6,45.2 L65.1,45.2 C63.5,45.2 62.3,46.5 62.3,48 C62.3,49.6 63.6,50.8 65.1,50.8 L73.6,50.8 C75.2,50.8 76.4,49.5 76.4,48 C76.4,46.5 75.1,45.2 73.6,45.2 Z\" id=\"Path\"></path>\n            <path d=\"M51.7,45.2 L43.2,45.2 C41.6,45.2 40.4,46.5 40.4,48 C40.4,49.6 41.7,50.8 43.2,50.8 L51.7,50.8 C53.3,50.8 54.5,49.5 54.5,48 C54.6,46.5 53.3,45.2 51.7,45.2 Z\" id=\"Path\"></path>\n            <path d=\"M29.9,62.5 L21.4,62.5 C19.8,62.5 18.6,63.8 18.6,65.3 C18.6,66.9 19.9,68.1 21.4,68.1 L29.9,68.1 C31.5,68.1 32.7,66.8 32.7,65.3 C32.8,63.8 31.5,62.5 29.9,62.5 Z\" id=\"Path\"></path>\n            <path d=\"M73.6,62.5 L65.1,62.5 C63.5,62.5 62.3,63.8 62.3,65.3 C62.3,66.9 63.6,68.1 65.1,68.1 L73.6,68.1 C75.2,68.1 76.4,66.8 76.4,65.3 C76.4,63.8 75.1,62.5 73.6,62.5 Z\" id=\"Path\"></path>\n            <path d=\"M51.7,62.5 L43.2,62.5 C41.6,62.5 40.4,63.8 40.4,65.3 C40.4,66.9 41.7,68.1 43.2,68.1 L51.7,68.1 C53.3,68.1 54.5,66.8 54.5,65.3 C54.6,63.8 53.3,62.5 51.7,62.5 Z\" id=\"Path\"></path>\n        </g>\n    </g>\n</g>"
	    }
	  });
	};
	
	window.google_icon = function(size) {
	  return SVG({
	    width: size + "px",
	    height: size + "px",
	    viewBox: "0 0 39 39",
	    dangerouslySetInnerHTML: {
	      __html: "<g id=\"auth\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n    <g id=\"btn_google_light_normal_ios\" transform=\"translate(-24.000000, -23.000000)\">\n        <g id=\"logo_googleg_48dp\" transform=\"translate(24.000000, 23.000000)\">\n            <path d=\"M38.22,19.9431818 C38.22,18.5604546 38.0959091,17.2309091 37.8654545,15.9545454 L19.5,15.9545454 L19.5,23.4975 L29.9945455,23.4975 C29.5425,25.935 28.1686364,28.0002272 26.1034091,29.3829545 L26.1034091,34.2756819 L32.4054545,34.2756819 C36.0927272,30.8809092 38.22,25.8818181 38.22,19.9431818 L38.22,19.9431818 Z\" id=\"Shape\" fill=\"#4285F4\" fill-rule=\"nonzero\"></path>\n            <path d=\"M19.5,39 C24.765,39 29.1790908,37.2538636 32.4054545,34.2756819 L26.1034091,29.3829545 C24.3572728,30.5529545 22.1236364,31.2443181 19.5,31.2443181 C14.4211364,31.2443181 10.1222727,27.8140908 8.58886364,23.205 L2.07409091,23.205 L2.07409091,28.2572728 C5.28272728,34.6302272 11.8772727,39 19.5,39 L19.5,39 Z\" id=\"Shape\" fill=\"#34A853\" fill-rule=\"nonzero\"></path>\n            <path d=\"M8.58886364,23.205 C8.19886364,22.035 7.97727272,20.7852273 7.97727272,19.5 C7.97727272,18.2147727 8.19886364,16.965 8.58886364,15.795 L8.58886364,10.7427273 L2.07409091,10.7427273 C0.753409091,13.3752273 0,16.3534091 0,19.5 C0,22.6465908 0.753409091,25.6247728 2.07409091,28.2572728 L8.58886364,23.205 L8.58886364,23.205 Z\" id=\"Shape\" fill=\"#FBBC05\" fill-rule=\"nonzero\"></path>\n            <path d=\"M19.5,7.75568181 C22.3629545,7.75568181 24.9334092,8.73954545 26.9543181,10.6718182 L32.5472728,5.07886364 C29.1702272,1.93227273 24.7561364,0 19.5,0 C11.8772727,0 5.28272728,4.36977272 2.07409091,10.7427273 L8.58886364,15.795 C10.1222727,11.1859091 14.4211364,7.75568181 19.5,7.75568181 L19.5,7.75568181 Z\" id=\"Shape\" fill=\"#EA4335\" fill-rule=\"nonzero\"></path>\n            <polygon id=\"Shape\" points=\"0 0 39 0 39 39 0 39\"></polygon>\n        </g>\n    </g>\n</g>"
	    }
	  });
	};
	
	window.import_icon = function(size, color) {
	  return SVG({
	    width: size + "px",
	    height: size + "px",
	    viewBox: "0 0 550 550",
	    dangerouslySetInnerHTML: {
	      __html: "<g>\n <path fill=\"" + color + "\" d=\"m534.8 71.68-210.56 210.56v-81.199c0-6-3.1992-11.547-8.3984-14.547-5.1992-3.0039-11.602-3.0039-16.801 0-5.1953 3-8.3984 8.5469-8.3984 14.547v121.52c0.070313 1.1367 0.25781 2.2617 0.55859 3.3633v3.3594l1.1211 1.6797v1.1211-0.003906c1.1953 1.7656 2.7148 3.2852 4.4805 4.4805h1.1211l1.6797 1.1211h129.36c6 0 11.547-3.2031 14.547-8.3984 3.0039-5.1992 3.0039-11.602 0-16.801-3-5.1992-8.5469-8.4023-14.547-8.4023h-81.199l210.56-208.88c3.2617-4.3477 4.2188-10.008 2.5625-15.191-1.6523-5.1797-5.7109-9.2383-10.891-10.891-5.1836-1.6562-10.844-0.69922-15.191 2.5625z\"/>\n <path fill=\"" + color + "\" d=\"m209.44 493.36h242.48c19.305 0 37.824-7.668 51.477-21.32 13.652-13.656 21.32-32.172 21.32-51.48v-146.72c0-6-3.1992-11.547-8.3984-14.551-5.1992-3-11.602-3-16.801 0-5.1992 3.0039-8.3984 8.5508-8.3984 14.551v146.72c0 10.398-4.1328 20.367-11.484 27.719-7.3477 7.3516-17.32 11.484-27.715 11.484h-242.48c-10.398 0-20.367-4.1328-27.719-11.484-7.3516-7.3516-11.484-17.32-11.484-27.719v-242.48c0-10.395 4.1328-20.367 11.484-27.715 7.3516-7.3516 17.32-11.484 27.719-11.484h146.72c6 0 11.547-3.1992 14.551-8.3984 3-5.1992 3-11.602 0-16.801-3.0039-5.1992-8.5508-8.3984-14.551-8.3984h-146.72c-19.309 0-37.824 7.668-51.48 21.32-13.652 13.652-21.32 32.172-21.32 51.477v242.48c0 19.309 7.668 37.824 21.32 51.48 13.656 13.652 32.172 21.32 51.48 21.32z\"/>\n</g>"
	    }
	  });
	};
	
	window.dashboard_icons = {
	  avatar: function(color) {
	    return "<svg fill=\"" + color + "\" x=\"0px\" y=\"0px\" viewBox=\"23 25 53 50\" enable-background=\"new 0 0 100 100\" xml:space=\"preserve\"><path d=\"M25.7,75.2c0,0,0.1,0,0.1,0c1.1-0.1,1.9-1,1.8-2.1c-0.2-2.3,0-6.2,3.1-6.9c10.7-2.7,14.4-6.3,15.6-8.6  c1,0.3,2.1,0.4,3.2,0.4c0,0,0.1,0,0.1,0h0.2c0,0,0.1,0,0.1,0c1.3,0,2.5-0.2,3.7-0.5c1.3,2.4,4.9,6.1,15.6,8.8  c3.1,0.8,3.3,4.7,3.1,6.9c-0.1,1.1,0.7,2,1.8,2.1c0,0,0.1,0,0.1,0c1,0,1.8-0.8,1.9-1.8c0.4-5.9-1.8-9.9-6-11  c-9.6-2.4-12.3-5.4-13-6.7c0.7-0.5,1.3-1,1.9-1.7c4.9-5.5,4.1-14.9,4-15.9c-0.5-9.9-7.3-13.4-13-13.4c-0.1,0-0.2,0-0.3,0  c-0.1,0-0.2,0-0.3,0c-5.7,0-12.5,3.5-13,13.4c-0.1,0.9-0.9,10.4,4,15.9c0.7,0.8,1.4,1.4,2.2,1.9c-0.2,0.3-0.5,0.6-0.9,1  c-1.5,1.5-4.8,3.6-12.1,5.4c-4.2,1.1-6.4,5.1-6,10.9C23.9,74.4,24.7,75.2,25.7,75.2z M40.4,38.5c0,0,0-0.1,0-0.1  c0.4-9.1,7.1-9.8,9.1-9.8c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.2,0c2,0,8.7,0.7,9.1,9.8c0,0,0,0.1,0,0.1  c0.3,2.4,0.2,9.3-3.1,13c-1.5,1.7-3.6,2.6-6.3,2.6c0,0,0,0-0.1,0c0,0,0,0-0.1,0c-2.7,0-4.8-0.9-6.3-2.6  C39.5,47.1,40.4,38.6,40.4,38.5z\"/></svg>";
	  },
	  upload: function(color) {
	    return "<svg fill=\"" + color + "\" viewBox=\"2 4 28 22\" x=\"0px\" y=\"0px\"><g data-name=\"upload cloud\"><path d=\"M30,17.9375a4.3632,4.3632,0,0,0-5.0087-4.327c.0011-.0578.0087-.1151.0087-.173A8.875,8.875,0,0,0,7.8149,10.3218,5.9967,5.9967,0,0,0,8,22.3125h3a1,1,0,0,0,0-2H8a4,4,0,0,1,0-8,4.0947,4.0947,0,0,1,.4268.0225.9464.9464,0,0,0,.118-.0113.9685.9685,0,0,0,.1976-.0188.9517.9517,0,0,0,.1826-.0614.8625.8625,0,0,0,.3111-.214.95.95,0,0,0,.1154-.1378.975.975,0,0,0,.0923-.182.9173.9173,0,0,0,.0523-.1033A6.8771,6.8771,0,0,1,22.86,14.8232a.9958.9958,0,0,0,.1459.7529l.0025.0069a1.0034,1.0034,0,0,0,1.376.3291,2.375,2.375,0,1,1,1.24,4.4h-4.5a1,1,0,0,0,0,2h4.9375a.9931.9931,0,0,0,.3983-.0845A4.38,4.38,0,0,0,30,17.9375Z\"/><path d=\"M20.6,16.6377l-4-3a.996.996,0,0,0-1.1992,0l-4,3a1,1,0,0,0,1.1992,1.6l2.4-1.8v10a1,1,0,0,0,2,0v-10l2.4,1.8a1,1,0,0,0,1.1992-1.6Z\"/></g></svg>";
	  },
	  translate: function(color) {
	    return "<svg fill=\"" + color + "\" x=\"0px\" y=\"0px\" viewBox=\"10 10 60 60\" style=\"enable-background:new 0 0 80 80;\" xml:space=\"preserve\"><g><path d=\"M40,16c0-2.21-1.79-4-4-4H16c-2.21,0-4,1.79-4,4v20c0,2.21,1.79,4,4,4h20c2.21,0,4-1.79,4-4V16z M38,36c0,1.1-0.9,2-2,2H16   c-1.1,0-2-0.9-2-2V16c0-1.1,0.9-2,2-2h20c1.1,0,2,0.9,2,2V36z\"/><path d=\"M64,40H44c-2.21,0-4,1.79-4,4v20c0,2.21,1.79,4,4,4h20c2.21,0,4-1.79,4-4V44C68,41.79,66.21,40,64,40z M59.32,59.05   c0.52,0.18,0.8,0.74,0.63,1.27C59.81,60.74,59.42,61,59,61c-0.1,0-0.21-0.02-0.32-0.05c-1.97-0.66-3.5-1.5-4.68-2.4301   c-1.18,0.9301-2.71,1.77-4.68,2.4301C49.21,60.98,49.1,61,49,61c-0.42,0-0.81-0.26-0.95-0.68c-0.17-0.53,0.11-1.09,0.63-1.27   c1.61-0.53,2.87-1.2,3.85-1.93c-2.02-2.27-2.46-4.72-2.54-6.12H49c-0.55,0-1-0.45-1-1s0.45-1,1-1h4v-1c0-0.55,0.45-1,1-1   s1,0.45,1,1v1h4c0.55,0,1,0.45,1,1s-0.45,1-1,1h-0.99c-0.08,1.4-0.52,3.85-2.54,6.12C56.45,57.85,57.71,58.51,59.32,59.05z\"/><path d=\"M54,55.79c1.6-1.82,1.96-3.72,2.02-4.79h-4.05C52.02,52.07,52.38,53.98,54,55.79z\"/><path d=\"M26.9229,19.6152C26.7676,19.2432,26.4033,19,26,19s-0.7676,0.2432-0.9229,0.6152l-2.7814,6.6755   C22.1133,26.4718,22,26.7224,22,27c0,0.0001,0.0001,0.0001,0.0001,0.0002l-1.9229,4.615   c-0.2129,0.5098,0.0283,1.0957,0.5381,1.3076c0.5098,0.2129,1.0947-0.0273,1.3076-0.5381L23.7498,28h4.5004l1.827,4.3848   C30.2373,32.7686,30.6084,33,31,33c0.1289,0,0.2588-0.0244,0.3848-0.0771c0.5098-0.2119,0.751-0.7979,0.5381-1.3076   L26.9229,19.6152z M24.5832,26L26,22.5996L27.4168,26H24.5832z\"/><path d=\"M43.1663,27.5197c0.0552,0.0881,0.1168,0.1675,0.1959,0.2344c0.0154,0.0131,0.0219,0.0335,0.0382,0.0457l4,3   C47.5801,30.9346,47.79,31,47.999,31c0.3047,0,0.6045-0.1377,0.8008-0.4004c0.332-0.4414,0.2422-1.0684-0.2002-1.3994L46.9999,28   H50c0.2861,0,7,0.0908,7,8c0,0.5527,0.4473,1,1,1s1-0.4473,1-1c0-9.8857-8.9102-10-9-10h-3.0001l1.5997-1.2002   c0.4424-0.3311,0.5322-0.958,0.2002-1.3994c-0.3311-0.4434-0.958-0.5322-1.3994-0.2002l-4,3   c-0.0163,0.0122-0.0228,0.0326-0.0382,0.0457c-0.0791,0.0669-0.1408,0.1464-0.196,0.2346   c-0.0216,0.0345-0.0496,0.0624-0.0668,0.0992C43.0391,26.7084,43,26.8484,43,27s0.0391,0.2916,0.0994,0.4203   C43.1166,27.4572,43.1447,27.4851,43.1663,27.5197z\"/><path d=\"M36.834,52.4807c-0.0552-0.0883-0.1171-0.1678-0.1962-0.2347c-0.0154-0.0131-0.0219-0.0335-0.0381-0.0457l-4-3   c-0.4404-0.3301-1.0674-0.2422-1.3994,0.2002c-0.332,0.4414-0.2422,1.0684,0.2002,1.3994L33.0001,52H30c-0.2861,0-7-0.0908-7-8   c0-0.5527-0.4473-1-1-1s-1,0.4473-1,1c0,9.8857,8.9102,10,9,10h3.0001l-1.5997,1.2002c-0.4424,0.3311-0.5322,0.958-0.2002,1.3994   C31.3965,56.8623,31.6963,57,32.001,57c0.209,0,0.4189-0.0654,0.5986-0.2002l4-3c0.0164-0.0122,0.0228-0.0326,0.0382-0.0457   c0.0791-0.0669,0.1409-0.1464,0.196-0.2346c0.0215-0.0345,0.0496-0.0623,0.0668-0.0991C36.9609,53.2917,37,53.1517,37,53   s-0.0391-0.2918-0.0994-0.4205C36.8835,52.5428,36.8555,52.5151,36.834,52.4807z\"/></g></svg>";
	  },
	  bell: function(color) {
	    return "<svg viewBox=\"20 15 60 70\" x=\"0px\" y=\"0px\"><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g fill-rule=\"nonzero\" fill=\"" + color + "\"><path d=\"M58.9863458,71.5 C58.726905,76.2379945 54.8027842,80 50,80 C45.1972158,80 41.273095,76.2379945 41.0136542,71.5 L27.0025482,71.5 C25.3425883,71.5 24,70.1608104 24,68.5029699 L24,65.5 C24,62.189348 26.688664,59.5 30.0020869,59.5 C29.9981947,59.5 30,47.4992494 30,47.4992494 C30,39.0465921 35.2858464,31.6357065 43,28.7587819 L43,28.4952534 C43,24.6330455 46.138457,21.5 50,21.5 C53.8656855,21.5 57,24.6311601 57,28.4952534 L57,28.7589486 C64.7139633,31.6362562 70,39.0483724 70,47.4992494 L70,59.4982567 C73.3063923,59.5 76,62.1883045 76,65.5 L76,68.5029699 C76,70.1542433 74.6530016,71.5 72.9974518,71.5 L58.9863458,71.5 Z M54.9753124,71.5 L45.0246876,71.5 C45.2755498,74.0266613 47.4073259,76 50,76 C52.5926741,76 54.7244502,74.0266613 54.9753124,71.5 Z M72,67.5 L72,65.5 C72,64.3992101 71.099016,63.5 69.9979131,63.5 C67.7877428,63.5 66,61.7131252 66,59.4982567 L66,47.4992494 C66,40.3240131 61.2358497,34.083713 54.4456568,32.1249199 L53,31.7078857 L53,28.4952534 C53,26.8412012 51.6574476,25.5 50,25.5 C48.3460522,25.5 47,26.8437313 47,28.4952534 L47,31.7078537 L45.5542654,32.1248469 C38.7637896,34.083424 34,40.3222636 34,47.4992494 L34,59.4982567 C34,61.7067825 32.2078843,63.5 30.0020869,63.5 C28.8980308,63.5 28,64.3982593 28,65.5 L28,67.5 L72,67.5 Z\"/></g></g></svg>";
	  },
	  forum: function(color) {
	    return "<svg fill=\"" + color + "\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" viewBox=\"6 17 88 65\" enable-background=\"new 0 0 100 100\" xml:space=\"preserve\"><g><path d=\"M84.412,19.068H43.588c-3.916,0-7.177,2.833-7.857,6.557H15.588c-4.408,0-7.994,3.586-7.994,7.993v27.164   c0,4.408,3.586,7.994,7.994,7.994h19.456l12.867,11.518c0.468,0.42,1.065,0.638,1.668,0.638c0.368,0,0.738-0.081,1.083-0.247   c0.912-0.438,1.469-1.383,1.413-2.393l-0.532-9.516h4.868c3.593,0,6.639-2.384,7.642-5.653l11.858,10.614   c0.468,0.42,1.065,0.638,1.668,0.638c0.007,0,0.014-0.001,0.02,0c1.381,0,2.5-1.119,2.5-2.5c0-0.156-0.014-0.309-0.042-0.457   l-0.514-9.198h4.868c4.408,0,7.994-3.586,7.994-7.993V27.063C92.405,22.654,88.819,19.068,84.412,19.068z M56.412,63.776H48.9   c-0.687,0-1.344,0.283-1.816,0.782s-0.718,1.171-0.68,1.857l0.342,6.124l-9.079-8.126c-0.458-0.411-1.052-0.638-1.667-0.638H15.588   c-1.651,0-2.994-1.343-2.994-2.994V33.618c0-1.65,1.343-2.993,2.994-2.993h20.006v23.602c0,4.407,3.586,7.993,7.994,7.993h15.433   C58.511,63.143,57.539,63.776,56.412,63.776z M87.405,54.227c0,1.65-1.343,2.993-2.994,2.993H76.9   c-0.687,0-1.344,0.283-1.816,0.782s-0.718,1.171-0.68,1.857l0.342,6.124l-9.079-8.126C65.209,57.446,64.615,57.22,64,57.22H43.588   c-1.651,0-2.994-1.343-2.994-2.993V28.13c0-0.002,0-0.003,0-0.005s0-0.003,0-0.005v-1.058c0-1.651,1.343-2.994,2.994-2.994h40.823   c1.651,0,2.994,1.343,2.994,2.994V54.227z\"/></g></svg>";
	  },
	  lock: function(color) {
	    return "<svg viewBox=\"0 0 40 40\" version=\"1.1\" x=\"0px\" y=\"0px\"><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><rect x=\"0\" y=\"0\" width=\"40\" height=\"40\"/><path d=\"M20,20 C20.8817862,20 21.5484529,20 22,20 C30.836556,20 38,27.163444 38,36 L38,37 L36,37 L36,36 C36,28.2680135 29.7319865,22 22,22 C21.5473049,22 20.8806382,22 20,22 L20,22 C20,21.4477153 19.5522847,21 19,21 L19,20 L20,20 Z\" fill=\"" + color + "\" fill-rule=\"nonzero\"/><path d=\"M22,16 C25.3137085,16 28,13.3137085 28,10 C28,6.6862915 25.3137085,4 22,4 C18.6862915,4 16,6.6862915 16,10 C16,13.3137085 18.6862915,16 22,16 Z M22,18 C17.581722,18 14,14.418278 14,10 C14,5.581722 17.581722,2 22,2 C26.418278,2 30,5.581722 30,10 C30,14.418278 26.418278,18 22,18 Z\" fill=\"" + color + "\" fill-rule=\"nonzero\"/><path d=\"M11,32 C11,32.5522847 10.5522847,33 10,33 C9.44771525,33 9,32.5522847 9,32 L9,30.9146471 C8.41740381,30.7087289 8,30.1531094 8,29.5 C8,28.6715729 8.67157288,28 9.5,28 L10.5,28 C11.3284271,28 12,28.6715729 12,29.5 C12,30.1531094 11.5825962,30.7087289 11,30.9146471 L11,32 Z M4,23 L4,20 C4,16.6862915 6.6862915,14 10,14 C13.3137085,14 16,16.6862915 16,20 L16,23 L18,23 L18,38 L2,38 L2,23 L4,23 Z M4,25 L4,36 L16,36 L16,25 L4,25 Z M6,23 L14,23 L14,20 C14,17.790861 12.209139,16 10,16 C7.790861,16 6,17.790861 6,20 L6,23 Z\" fill=\"" + color + "\" fill-rule=\"nonzero\"/></g></svg>";
	  },
	  coding: function(color) {
	    return "<svg fill=\"" + color + "\" viewBox=\"5 5 37 37\" x=\"0px\" y=\"0px\"><g data-name=\"Layer 2\"><path d=\"M41,6H7A1,1,0,0,0,6,7V41a1,1,0,0,0,1,1H41a1,1,0,0,0,1-1V7A1,1,0,0,0,41,6ZM20,11a1,1,0,1,1-1-1A1,1,0,0,1,20,11Zm-4,0a1,1,0,1,1-1-1A1,1,0,0,1,16,11Zm-5-1a1,1,0,1,1-1,1A1,1,0,0,1,11,10ZM40,40H8V16H21a1,1,0,0,0,.71-.29L25.41,12H40Z\"/><path d=\"M17.29,22.29a1,1,0,0,0-1.41,0l-4,4a1,1,0,0,0,0,1.42l4,4a1,1,0,1,0,1.41-1.42L14,27l3.29-3.29A1,1,0,0,0,17.29,22.29Z\"/><path d=\"M30.88,31.71a1,1,0,0,0,1.41,0l4-4a1,1,0,0,0,0-1.42l-4-4a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.42L34.17,27l-3.29,3.29A1,1,0,0,0,30.88,31.71Z\"/><path d=\"M25.11,22.55l-4,8a1,1,0,0,0,.44,1.34A.93.93,0,0,0,22,32a1,1,0,0,0,.89-.55l4-8a1,1,0,1,0-1.78-.9Z\"/></g></svg>";
	  },
	  moderation: function(color) {
	    return "<svg fill=\"" + color + "\" x=\"0px\" y=\"0px\" viewBox=\"3 3 95 95\" style=\"enable-background:new 0 0 100 100;\" xml:space=\"preserve\"><switch><foreignObject requiredExtensions=\"http://ns.adobe.com/AdobeIllustrator/10.0/\" x=\"0\" y=\"0\" width=\"1\" height=\"1\"/><g i:extraneous=\"self\"><g><path d=\"M95.1,84.8L74,65.7c4.9-6.6,7.9-14.7,7.9-23.6C81.8,20.3,64,2.5,42.2,2.5S2.5,20.3,2.5,42.2s17.8,39.7,39.7,39.7     c8.8,0,17-2.9,23.6-7.9l19.1,21.1c0.2,0.2,0.3,0.4,0.5,0.5c3,2.7,7.6,2.5,10.3-0.5C98.3,92.1,98.1,87.5,95.1,84.8z M11.1,42.2     C11.1,25,25,11.1,42.2,11.1S73.2,25,73.2,42.2S59.3,73.2,42.2,73.2S11.1,59.3,11.1,42.2z\"/><path d=\"M52.6,30.8L38.1,46.5l-6.4-6.9c-1.6-1.7-4.3-1.8-6.1-0.2c-1.7,1.6-1.8,4.3-0.2,6.1l9.5,10.3c0.8,0.9,2,1.4,3.2,1.4     s2.3-0.5,3.2-1.4l17.7-19.1c1.6-1.7,1.5-4.5-0.2-6.1C57,29,54.2,29.1,52.6,30.8z\"/></g></g></switch></svg>";
	  },
	  user_data: function(color) {
	    return "<svg fill=\"" + color + "\" stroke-width=\"0.501\" stroke-linejoin=\"bevel\" fill-rule=\"evenodd\" version=\"1.1\" overflow=\"visible\" viewBox=\"10 20 80 55\" x=\"0px\" y=\"0px\"><g fill=\"none\" stroke=\"black\" transform=\"scale(1 -1)\"><g transform=\"translate(0 -96)\"><g><path d=\"M 8.625,23.701 L 8.625,72.3 C 8.625,73.334 9.465,74.175 10.5,74.175 L 85.501,74.175 C 86.535,74.175 87.376,73.334 87.376,72.3 L 87.376,23.701 C 87.376,22.666 86.535,21.826 85.501,21.826 L 10.5,21.826 C 9.465,21.826 8.625,22.666 8.625,23.701 Z M 83.626,25.576 L 83.626,70.425 L 12.375,70.425 L 12.375,25.576 L 83.626,25.576 Z M 17.778,33.112 L 17.778,34.987 C 17.778,38.826 19.254,41.73 21.775,43.611 C 24.216,45.432 27.432,46.147 30.721,46.147 C 34.008,46.147 37.224,45.432 39.665,43.611 C 42.187,41.728 43.662,38.829 43.662,34.987 L 43.662,33.112 L 17.778,33.112 Z M 37.422,40.605 C 35.856,41.774 33.539,42.397 30.721,42.397 C 27.901,42.397 25.583,41.774 24.017,40.605 C 22.904,39.774 22.06,38.586 21.707,36.869 L 39.733,36.869 C 39.379,38.587 38.536,39.773 37.422,40.605 Z M 49.433,42.366 C 49.433,43.4 50.273,44.241 51.308,44.241 L 67.636,44.241 C 68.67,44.241 69.511,43.4 69.511,42.366 C 69.511,41.331 68.67,40.491 67.636,40.491 L 51.308,40.491 C 50.273,40.491 49.433,41.331 49.433,42.366 Z M 23.246,55.433 C 23.246,59.558 26.593,62.906 30.719,62.906 C 34.844,62.906 38.192,59.558 38.192,55.433 C 38.192,51.307 34.844,47.96 30.719,47.96 C 26.593,47.96 23.246,51.307 23.246,55.433 Z M 49.433,49.866 C 49.433,50.9 50.273,51.741 51.308,51.741 L 75.886,51.741 C 76.92,51.741 77.761,50.9 77.761,49.866 C 77.761,48.831 76.92,47.991 75.886,47.991 L 51.308,47.991 C 50.273,47.991 49.433,48.831 49.433,49.866 Z M 34.442,55.433 C 34.442,57.487 32.773,59.156 30.719,59.156 C 28.664,59.156 26.996,57.487 26.996,55.433 C 26.996,53.378 28.664,51.71 30.719,51.71 C 32.773,51.71 34.442,53.378 34.442,55.433 Z M 49.433,57.366 C 49.433,58.4 50.273,59.241 51.308,59.241 L 75.886,59.241 C 76.92,59.241 77.761,58.4 77.761,57.366 C 77.761,56.331 76.92,55.491 75.886,55.491 L 51.308,55.491 C 50.273,55.491 49.433,56.331 49.433,57.366 Z\" stroke=\"none\" fill=\"#000000\" fill-rule=\"evenodd\" stroke-width=\"0.5\" marker-start=\"none\" marker-end=\"none\" stroke-miterlimit=\"79.8403193612775\"/></g></g></g></svg>";
	  },
	  survey: function(color) {
	    return "<svg viewBox=\"80 0 540 540\"> <g fill=\"" + color + "\" stroke=\"" + color + "\">  <path d=\"m386.96 206.64h114.8c10.641 0 19.039-8.3984 19.039-19.039 0-10.641-8.4023-19.602-19.039-19.602h-114.8c-10.641 0-19.039 8.3984-19.039 19.039 0 10.641 8.3984 19.602 19.039 19.602z\"/>  <path d=\"m386.96 299.04h114.8c10.641 0 19.039-8.3984 19.039-19.039s-8.3984-19.039-19.039-19.039h-114.8c-10.641 0-19.039 8.3984-19.039 19.039s8.3984 19.039 19.039 19.039z\"/>  <path d=\"m386.96 392h114.8c10.641 0 19.039-8.3984 19.039-19.039 0-10.641-8.3984-19.039-19.039-19.039h-114.8c-10.641 0-19.039 8.3984-19.039 19.039 0 10.078 8.3984 19.039 19.039 19.039z\"/>  <path d=\"m189.84 244.16h16.801c6.1602 0 11.199-4.4805 11.762-10.078 2.2383-11.762 9.5195-26.32 33.039-26.32 17.922 0 25.762 9.5195 28.559 15.121 3.9219 8.3984 3.3594 17.922-1.6797 24.641-5.0391 7.2812-10.078 10.641-16.238 14.559-14.559 10.078-26.32 20.719-28.559 50.961 0 3.3594 1.1211 6.7188 3.3594 9.5195 2.2383 2.2383 5.6016 3.9219 8.9609 3.9219h16.801c6.1602 0 11.762-5.0391 12.32-11.199 1.1211-11.762 3.9219-14 11.199-19.602 6.7188-5.0391 16.238-11.199 25.199-24.078 14.559-19.602 16.238-45.922 5.0391-67.762-11.762-23.52-36.398-37.52-64.961-37.52-47.602 0-69.441 34.719-73.922 63.84-0.55859 3.3594 0.55859 6.7188 2.8008 9.5195 2.8008 2.7969 6.1602 4.4766 9.5195 4.4766z\"/>  <path d=\"m278.88 369.04c0 13.609-11.031 24.641-24.641 24.641-13.605 0-24.637-11.031-24.637-24.641 0-13.605 11.031-24.641 24.637-24.641 13.609 0 24.641 11.035 24.641 24.641\"/>  <path d=\"m596.96 72.801h-493.92c-10.641 0-19.039 8.3984-19.039 19.039v376.32c0 10.641 8.3984 19.039 19.039 19.039h493.92c10.641 0 19.039-8.3984 19.039-19.039v-376.32c0-10.641-8.3984-19.039-19.039-19.039zm-19.039 376.32h-455.84v-338.24h455.84z\"/> </g></svg>";
	  }
	};


/***/ },
/* 41 */,
/* 42 */,
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var AccessControlled, AccessDenied, Permission, matchEmail, matchSomeRole, permit, sent_verification_token,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	__webpack_require__(4);
	
	__webpack_require__(2);
	
	Permission = {
	  PERMITTED: 1,
	  DISABLED: -1,
	  UNVERIFIED_EMAIL: -2,
	  NOT_LOGGED_IN: -3,
	  INSUFFICIENT_INFORMATION: -5,
	  INSUFFICIENT_PRIVILEGES: -4
	};
	
	permit = function(action) {
	  var arg, can_add_to_list, comment, current_user, i, len, list_key, opinion, phase, point, proposal, subdomain;
	  subdomain = null;
	  for (i = 0, len = arguments.length; i < len; i++) {
	    arg = arguments[i];
	    if (arg.customizations) {
	      subdomain = arg;
	      break;
	    }
	  }
	  current_user = fetch('/current_user');
	  phase = customization('contribution_phase', null, subdomain);
	  if (phase === 'frozen' && (action !== 'read proposal' && action !== 'access forum' && action !== 'configure paid feature')) {
	    return Permission.DISABLED;
	  }
	  switch (action) {
	    case 'read proposal':
	    case 'access forum':
	      if (subdomain == null) {
	        subdomain = fetch('/subdomain');
	      }
	      if (!current_user.is_admin && !matchSomeRole(subdomain.roles, ['visitor'])) {
	        if (!current_user.logged_in) {
	          return Permission.NOT_LOGGED_IN;
	        } else {
	          return Permission.INSUFFICIENT_PRIVILEGES;
	        }
	      } else if (subdomain.roles.visitor.indexOf('*') === -1 && !current_user.verified) {
	        return Permission.UNVERIFIED_EMAIL;
	      }
	      break;
	    case 'create proposal':
	      if (subdomain == null) {
	        subdomain = fetch('/subdomain');
	      }
	      if (arguments[1]) {
	        list_key = arguments[1];
	        list_key = list_key.key || list_key;
	        if (!list_key.startsWith('list/')) {
	          list_key = "list/" + list_key;
	        }
	        can_add_to_list = customization('list_permit_new_items', list_key, subdomain);
	      } else {
	        can_add_to_list = true;
	      }
	      if (phase === 'opinions-only') {
	        can_add_to_list = false;
	      }
	      if (!current_user.is_admin && (!matchEmail(subdomain.roles.proposer) || !can_add_to_list)) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      if (!current_user.logged_in) {
	        return Permission.NOT_LOGGED_IN;
	      }
	      break;
	    case 'update proposal':
	    case 'delete proposal':
	      if (!current_user.logged_in) {
	        return Permission.NOT_LOGGED_IN;
	      }
	      proposal = fetch(arguments[1]);
	      if (!current_user.is_admin && (proposal.key === 'new_proposal' || !matchEmail(proposal.roles.editor))) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    case 'publish opinion':
	      proposal = fetch(arguments[1]);
	      if (phase === 'ideas-only') {
	        return Permission.DISABLED;
	      }
	      if (!proposal.active) {
	        return Permission.DISABLED;
	      }
	      if (!current_user.logged_in) {
	        return Permission.NOT_LOGGED_IN;
	      }
	      if (!current_user.is_admin && !matchSomeRole(proposal.roles, ['editor', 'participant'])) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      if (!current_user.completed_host_questions) {
	        return Permission.INSUFFICIENT_INFORMATION;
	      }
	      break;
	    case 'update opinion':
	      proposal = fetch(arguments[1]);
	      if (!arguments[2]) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      opinion = fetch(arguments[2]);
	      if (opinion.user !== fetch('/current_user').user) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    case 'create point':
	      proposal = fetch(arguments[1]);
	      if (phase === 'ideas-only' || !proposal.active) {
	        return Permission.DISABLED;
	      }
	      if (!current_user.logged_in) {
	        return Permission.NOT_LOGGED_IN;
	      }
	      if (!current_user.is_admin && !matchSomeRole(proposal.roles, ['editor', 'participant'])) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    case 'update point':
	      point = fetch(arguments[1]);
	      if (!current_user.is_admin && point.user !== fetch('/current_user').user) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    case 'delete point':
	      point = fetch(arguments[1]);
	      if (!current_user.is_admin) {
	        if (point.user !== fetch('/current_user').user) {
	          return Permission.INSUFFICIENT_PRIVILEGES;
	        }
	        if (point.includers.length > 1 || (point.includers.length === 1 && point.includers[0] !== current_user.user)) {
	          return Permission.DISABLED;
	        }
	      }
	      break;
	    case 'create comment':
	      proposal = fetch(arguments[1]);
	      if (phase === 'ideas-only') {
	        return Permission.DISABLED;
	      }
	      if (!proposal.active) {
	        return Permission.DISABLED;
	      }
	      if (!current_user.logged_in) {
	        return Permission.NOT_LOGGED_IN;
	      }
	      if (!current_user.is_admin && !matchSomeRole(proposal.roles, ['editor', 'participant'])) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    case 'update comment':
	      comment = fetch(arguments[1]);
	      if (!current_user.is_admin && comment.user !== fetch('/current_user').user) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    case 'configure paid feature':
	      if (subdomain == null) {
	        subdomain = fetch('/subdomain');
	      }
	      if (!((current_user.is_admin && subdomain.plan) || current_user.is_super_admin)) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    default:
	      console.error("Unrecognized action to permit: " + action);
	  }
	  return Permission.PERMITTED;
	};
	
	matchEmail = function(permission_list) {
	  var allowed_domain, email_or_key, i, len, p, ref, ref1, user;
	  permission_list = (function() {
	    var i, len, results;
	    results = [];
	    for (i = 0, len = permission_list.length; i < len; i++) {
	      p = permission_list[i];
	      results.push(p.toLowerCase());
	    }
	    return results;
	  })();
	  user = fetch('/current_user');
	  if (indexOf.call(permission_list, '*') >= 0) {
	    return true;
	  }
	  if (ref = user.user, indexOf.call(permission_list, ref) >= 0) {
	    return true;
	  }
	  if (ref1 = user.email, indexOf.call(permission_list, ref1) >= 0) {
	    return true;
	  }
	  for (i = 0, len = permission_list.length; i < len; i++) {
	    email_or_key = permission_list[i];
	    if (email_or_key.indexOf('*') > -1) {
	      if (user.email) {
	        allowed_domain = email_or_key.split('@')[1];
	        if (user.email.split('@')[1] === allowed_domain) {
	          return true;
	        }
	      }
	    }
	  }
	  return false;
	};
	
	matchSomeRole = function(roles, accepted_roles) {
	  var i, len, role;
	  for (i = 0, len = accepted_roles.length; i < len; i++) {
	    role = accepted_roles[i];
	    if (matchEmail(roles[role])) {
	      return true;
	    }
	  }
	  return false;
	};
	
	sent_verification_token = false;
	
	window.recourse = function(permission, goal) {
	  var auth, current_user, loc;
	  loc = fetch('location');
	  auth = fetch('auth');
	  if (goal == null) {
	    goal = "To access this " + (is_a_dialogue_page() ? 'forum' : 'page') + ",";
	  }
	  switch (permission) {
	    case Permission.INSUFFICIENT_PRIVILEGES:
	      if (loc.url !== '/') {
	        return loadPage('/');
	      }
	      break;
	    case Permission.NOT_LOGGED_IN:
	      if (!auth.form) {
	        return reset_key('auth', {
	          form: 'login',
	          goal: goal + " please introduce yourself below"
	        });
	      }
	      break;
	    case Permission.UNVERIFIED_EMAIL:
	      if (auth.form !== 'verify email') {
	        reset_key('auth', {
	          form: 'verify email',
	          goal: goal + " please demonstrate you control this email."
	        });
	        if (!sent_verification_token) {
	          current_user = fetch('/current_user');
	          current_user.trying_to = 'send_verification_token';
	          save(current_user);
	          return sent_verification_token = true;
	        }
	      }
	  }
	};
	
	AccessControlled = {
	  accessGranted: function() {
	    var access_attrs, current_user, local_but_not_component_unique, page, permission_denied;
	    current_user = fetch('/current_user');
	    page = get_page();
	    local_but_not_component_unique = fetch("local-" + page.key);
	    access_attrs = ['verified', 'logged_in', 'email'];
	    permission_denied = page.permission_denied;
	    if (local_but_not_component_unique._last_current_user && permission_denied) {
	      if (this._relevant_current_user_values_have_changed(access_attrs)) {
	        delete page.permission_denied;
	        arest.serverFetch(page.key);
	      }
	    }
	    if (permission_denied && permission_denied < 0) {
	      recourse(permission_denied);
	    }
	    if (this._relevant_current_user_values_have_changed(access_attrs)) {
	      local_but_not_component_unique._last_current_user = _.map(access_attrs, function(attr) {
	        return current_user[attr];
	      });
	      save(local_but_not_component_unique);
	    }
	    return !permission_denied || permission_denied > 0;
	  },
	  _relevant_current_user_values_have_changed: function(access_attrs) {
	    var current_user, el, i, idx, last_values, len, reduced_user;
	    current_user = fetch('/current_user');
	    last_values = fetch("local-" + (get_page().key));
	    reduced_user = _.map(access_attrs, function(attr) {
	      return current_user[attr];
	    });
	    for (idx = i = 0, len = reduced_user.length; i < len; idx = ++i) {
	      el = reduced_user[idx];
	      if (!last_values._last_current_user || el !== last_values._last_current_user[idx]) {
	        return true;
	      }
	    }
	    return false;
	  }
	};
	
	AccessDenied = function() {
	  var user;
	  user = fetch('/current_user');
	  return DIV({
	    style: {
	      position: 'relative',
	      padding: 50
	    }
	  }, ProfileMenu(), DIV({
	    style: {
	      width: HOMEPAGE_WIDTH(),
	      margin: 'auto',
	      padding: '50px 100px',
	      backgroundColor: focus_color(),
	      color: 'white',
	      fontSize: 22
	    }
	  }, H1({
	    style: {
	      fontSize: 36,
	      color: 'white',
	      paddingBottom: 40
	    }
	  }, TRANSLATE({
	    id: "permissions.access_denied",
	    email: user.email
	  }, "We're sorry, but {email} doesn't have access to this private forum.")), DIV(null, TRANSLATE({
	    id: "permissions.access_denied.recourse"
	  }, "If you think you should have access, please contact the person who invited you. \nSometimes they will have granted access to a different email address. You will \neither have to create an account using that other email address, or the forum \nadministrator will have to grant this email address access.")), DIV({
	    style: {
	      marginTop: 40
	    }
	  }, TRANSLATE({
	    id: "permissions.contact_for_help",
	    link: {
	      component: A,
	      args: {
	        href: 'mailto:support@consider.it?subject=I am having trouble accessing a private forum',
	        style: {
	          textDecoration: 'underline'
	        }
	      }
	    }
	  }, "Contact us at <link>support@consider.it</link> if you need help."))));
	};
	
	window.AccessControlled = AccessControlled;
	
	window.permit = permit;
	
	window.Permission = Permission;
	
	window.AccessDenied = AccessDenied;


/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** product_page_dependencies.353c9c5791dea7355c1d.js
 **/